(() => {
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a, _b;
function _mergeNamespaces(n2, m2) {
  for (var i = 0; i < m2.length; i++) {
    const e = m2[i];
    if (typeof e !== "string" && !Array.isArray(e)) {
      for (const k2 in e) {
        if (k2 !== "default" && !(k2 in n2)) {
          const d = Object.getOwnPropertyDescriptor(e, k2);
          if (d) {
            Object.defineProperty(n2, k2, d.get ? d : {
              enumerable: true,
              get: () => e[k2]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n2, Symbol.toStringTag, { value: "Module" }));
}
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
!function(o) {
  (o.Shopify = o.Shopify || {}).modules = true;
}(window);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
var react = { exports: {} };
var react_production_min = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l$1 = Symbol.for("react.element"), n$2 = Symbol.for("react.portal"), p$3 = Symbol.for("react.fragment"), q$2 = Symbol.for("react.strict_mode"), r$1 = Symbol.for("react.profiler"), t$1 = Symbol.for("react.provider"), u$1 = Symbol.for("react.context"), v$2 = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z$1 = Symbol.iterator;
function A$1(a) {
  if (null === a || "object" !== typeof a) return null;
  a = z$1 && a[z$1] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
var B$1 = { isMounted: function() {
  return false;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, C$1 = Object.assign, D$1 = {};
function E$1(a, b, e) {
  this.props = a;
  this.context = b;
  this.refs = D$1;
  this.updater = e || B$1;
}
E$1.prototype.isReactComponent = {};
E$1.prototype.setState = function(a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, a, b, "setState");
};
E$1.prototype.forceUpdate = function(a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {
}
F.prototype = E$1.prototype;
function G$1(a, b, e) {
  this.props = a;
  this.context = b;
  this.refs = D$1;
  this.updater = e || B$1;
}
var H$1 = G$1.prototype = new F();
H$1.constructor = G$1;
C$1(H$1, E$1.prototype);
H$1.isPureReactComponent = true;
var I$1 = Array.isArray, J = Object.prototype.hasOwnProperty, K$1 = { current: null }, L$1 = { key: true, ref: true, __self: true, __source: true };
function M$1(a, b, e) {
  var d, c = {}, k2 = null, h = null;
  if (null != b) for (d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k2 = "" + b.key), b) J.call(b, d) && !L$1.hasOwnProperty(d) && (c[d] = b[d]);
  var g2 = arguments.length - 2;
  if (1 === g2) c.children = e;
  else if (1 < g2) {
    for (var f2 = Array(g2), m2 = 0; m2 < g2; m2++) f2[m2] = arguments[m2 + 2];
    c.children = f2;
  }
  if (a && a.defaultProps) for (d in g2 = a.defaultProps, g2) void 0 === c[d] && (c[d] = g2[d]);
  return { $$typeof: l$1, type: a, key: k2, ref: h, props: c, _owner: K$1.current };
}
function N$1(a, b) {
  return { $$typeof: l$1, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
}
function O$1(a) {
  return "object" === typeof a && null !== a && a.$$typeof === l$1;
}
function escape(a) {
  var b = { "=": "=0", ":": "=2" };
  return "$" + a.replace(/[=:]/g, function(a2) {
    return b[a2];
  });
}
var P$1 = /\/+/g;
function Q$1(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R$1(a, b, e, d, c) {
  var k2 = typeof a;
  if ("undefined" === k2 || "boolean" === k2) a = null;
  var h = false;
  if (null === a) h = true;
  else switch (k2) {
    case "string":
    case "number":
      h = true;
      break;
    case "object":
      switch (a.$$typeof) {
        case l$1:
        case n$2:
          h = true;
      }
  }
  if (h) return h = a, c = c(h), a = "" === d ? "." + Q$1(h, 0) : d, I$1(c) ? (e = "", null != a && (e = a.replace(P$1, "$&/") + "/"), R$1(c, b, e, "", function(a2) {
    return a2;
  })) : null != c && (O$1(c) && (c = N$1(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P$1, "$&/") + "/") + a)), b.push(c)), 1;
  h = 0;
  d = "" === d ? "." : d + ":";
  if (I$1(a)) for (var g2 = 0; g2 < a.length; g2++) {
    k2 = a[g2];
    var f2 = d + Q$1(k2, g2);
    h += R$1(k2, b, e, f2, c);
  }
  else if (f2 = A$1(a), "function" === typeof f2) for (a = f2.call(a), g2 = 0; !(k2 = a.next()).done; ) k2 = k2.value, f2 = d + Q$1(k2, g2++), h += R$1(k2, b, e, f2, c);
  else if ("object" === k2) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
  return h;
}
function S$1(a, b, e) {
  if (null == a) return a;
  var d = [], c = 0;
  R$1(a, d, "", "", function(a2) {
    return b.call(e, a2, c++);
  });
  return d;
}
function T$1(a) {
  if (-1 === a._status) {
    var b = a._result;
    b = b();
    b.then(function(b2) {
      if (0 === a._status || -1 === a._status) a._status = 1, a._result = b2;
    }, function(b2) {
      if (0 === a._status || -1 === a._status) a._status = 2, a._result = b2;
    });
    -1 === a._status && (a._status = 0, a._result = b);
  }
  if (1 === a._status) return a._result.default;
  throw a._result;
}
var U$1 = { current: null }, V$1 = { transition: null }, W$1 = { ReactCurrentDispatcher: U$1, ReactCurrentBatchConfig: V$1, ReactCurrentOwner: K$1 };
function X$1() {
  throw Error("act(...) is not supported in production builds of React.");
}
react_production_min.Children = { map: S$1, forEach: function(a, b, e) {
  S$1(a, function() {
    b.apply(this, arguments);
  }, e);
}, count: function(a) {
  var b = 0;
  S$1(a, function() {
    b++;
  });
  return b;
}, toArray: function(a) {
  return S$1(a, function(a2) {
    return a2;
  }) || [];
}, only: function(a) {
  if (!O$1(a)) throw Error("React.Children.only expected to receive a single React element child.");
  return a;
} };
react_production_min.Component = E$1;
react_production_min.Fragment = p$3;
react_production_min.Profiler = r$1;
react_production_min.PureComponent = G$1;
react_production_min.StrictMode = q$2;
react_production_min.Suspense = w;
react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W$1;
react_production_min.act = X$1;
react_production_min.cloneElement = function(a, b, e) {
  if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
  var d = C$1({}, a.props), c = a.key, k2 = a.ref, h = a._owner;
  if (null != b) {
    void 0 !== b.ref && (k2 = b.ref, h = K$1.current);
    void 0 !== b.key && (c = "" + b.key);
    if (a.type && a.type.defaultProps) var g2 = a.type.defaultProps;
    for (f2 in b) J.call(b, f2) && !L$1.hasOwnProperty(f2) && (d[f2] = void 0 === b[f2] && void 0 !== g2 ? g2[f2] : b[f2]);
  }
  var f2 = arguments.length - 2;
  if (1 === f2) d.children = e;
  else if (1 < f2) {
    g2 = Array(f2);
    for (var m2 = 0; m2 < f2; m2++) g2[m2] = arguments[m2 + 2];
    d.children = g2;
  }
  return { $$typeof: l$1, type: a.type, key: c, ref: k2, props: d, _owner: h };
};
react_production_min.createContext = function(a) {
  a = { $$typeof: u$1, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
  a.Provider = { $$typeof: t$1, _context: a };
  return a.Consumer = a;
};
react_production_min.createElement = M$1;
react_production_min.createFactory = function(a) {
  var b = M$1.bind(null, a);
  b.type = a;
  return b;
};
react_production_min.createRef = function() {
  return { current: null };
};
react_production_min.forwardRef = function(a) {
  return { $$typeof: v$2, render: a };
};
react_production_min.isValidElement = O$1;
react_production_min.lazy = function(a) {
  return { $$typeof: y, _payload: { _status: -1, _result: a }, _init: T$1 };
};
react_production_min.memo = function(a, b) {
  return { $$typeof: x, type: a, compare: void 0 === b ? null : b };
};
react_production_min.startTransition = function(a) {
  var b = V$1.transition;
  V$1.transition = {};
  try {
    a();
  } finally {
    V$1.transition = b;
  }
};
react_production_min.unstable_act = X$1;
react_production_min.useCallback = function(a, b) {
  return U$1.current.useCallback(a, b);
};
react_production_min.useContext = function(a) {
  return U$1.current.useContext(a);
};
react_production_min.useDebugValue = function() {
};
react_production_min.useDeferredValue = function(a) {
  return U$1.current.useDeferredValue(a);
};
react_production_min.useEffect = function(a, b) {
  return U$1.current.useEffect(a, b);
};
react_production_min.useId = function() {
  return U$1.current.useId();
};
react_production_min.useImperativeHandle = function(a, b, e) {
  return U$1.current.useImperativeHandle(a, b, e);
};
react_production_min.useInsertionEffect = function(a, b) {
  return U$1.current.useInsertionEffect(a, b);
};
react_production_min.useLayoutEffect = function(a, b) {
  return U$1.current.useLayoutEffect(a, b);
};
react_production_min.useMemo = function(a, b) {
  return U$1.current.useMemo(a, b);
};
react_production_min.useReducer = function(a, b, e) {
  return U$1.current.useReducer(a, b, e);
};
react_production_min.useRef = function(a) {
  return U$1.current.useRef(a);
};
react_production_min.useState = function(a) {
  return U$1.current.useState(a);
};
react_production_min.useSyncExternalStore = function(a, b, e) {
  return U$1.current.useSyncExternalStore(a, b, e);
};
react_production_min.useTransition = function() {
  return U$1.current.useTransition();
};
react_production_min.version = "18.3.1";
{
  react.exports = react_production_min;
}
var reactExports = react.exports;
const React$1 = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
const ReactOriginal = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: React$1
}, [reactExports]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = reactExports, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m$1 = Object.prototype.hasOwnProperty, n$1 = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$2 = { key: true, ref: true, __self: true, __source: true };
function q$1(c, a, g2) {
  var b, d = {}, e = null, h = null;
  void 0 !== g2 && (e = "" + g2);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a) m$1.call(a, b) && !p$2.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n$1.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
var jsxRuntimeExports = jsxRuntime.exports;
var client = {};
var reactDom = { exports: {} };
var reactDom_production_min = {};
var scheduler = { exports: {} };
var scheduler_production_min = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(exports) {
  function f2(a, b) {
    var c = a.length;
    a.push(b);
    a: for (; 0 < c; ) {
      var d = c - 1 >>> 1, e = a[d];
      if (0 < g2(e, b)) a[d] = b, a[c] = e, c = d;
      else break a;
    }
  }
  function h(a) {
    return 0 === a.length ? null : a[0];
  }
  function k2(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
      a[0] = c;
      a: for (var d = 0, e = a.length, w2 = e >>> 1; d < w2; ) {
        var m2 = 2 * (d + 1) - 1, C2 = a[m2], n2 = m2 + 1, x2 = a[n2];
        if (0 > g2(C2, c)) n2 < e && 0 > g2(x2, C2) ? (a[d] = x2, a[n2] = c, d = n2) : (a[d] = C2, a[m2] = c, d = m2);
        else if (n2 < e && 0 > g2(x2, c)) a[d] = x2, a[n2] = c, d = n2;
        else break a;
      }
    }
    return b;
  }
  function g2(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }
  if ("object" === typeof performance && "function" === typeof performance.now) {
    var l2 = performance;
    exports.unstable_now = function() {
      return l2.now();
    };
  } else {
    var p2 = Date, q2 = p2.now();
    exports.unstable_now = function() {
      return p2.now() - q2;
    };
  }
  var r2 = [], t2 = [], u2 = 1, v2 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E2 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
  "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function G2(a) {
    for (var b = h(t2); null !== b; ) {
      if (null === b.callback) k2(t2);
      else if (b.startTime <= a) k2(t2), b.sortIndex = b.expirationTime, f2(r2, b);
      else break;
      b = h(t2);
    }
  }
  function H2(a) {
    B2 = false;
    G2(a);
    if (!A2) if (null !== h(r2)) A2 = true, I2(J2);
    else {
      var b = h(t2);
      null !== b && K2(H2, b.startTime - a);
    }
  }
  function J2(a, b) {
    A2 = false;
    B2 && (B2 = false, E2(L2), L2 = -1);
    z2 = true;
    var c = y2;
    try {
      G2(b);
      for (v2 = h(r2); null !== v2 && (!(v2.expirationTime > b) || a && !M2()); ) {
        var d = v2.callback;
        if ("function" === typeof d) {
          v2.callback = null;
          y2 = v2.priorityLevel;
          var e = d(v2.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? v2.callback = e : v2 === h(r2) && k2(r2);
          G2(b);
        } else k2(r2);
        v2 = h(r2);
      }
      if (null !== v2) var w2 = true;
      else {
        var m2 = h(t2);
        null !== m2 && K2(H2, m2.startTime - b);
        w2 = false;
      }
      return w2;
    } finally {
      v2 = null, y2 = c, z2 = false;
    }
  }
  var N2 = false, O2 = null, L2 = -1, P2 = 5, Q2 = -1;
  function M2() {
    return exports.unstable_now() - Q2 < P2 ? false : true;
  }
  function R2() {
    if (null !== O2) {
      var a = exports.unstable_now();
      Q2 = a;
      var b = true;
      try {
        b = O2(true, a);
      } finally {
        b ? S2() : (N2 = false, O2 = null);
      }
    } else N2 = false;
  }
  var S2;
  if ("function" === typeof F2) S2 = function() {
    F2(R2);
  };
  else if ("undefined" !== typeof MessageChannel) {
    var T2 = new MessageChannel(), U2 = T2.port2;
    T2.port1.onmessage = R2;
    S2 = function() {
      U2.postMessage(null);
    };
  } else S2 = function() {
    D2(R2, 0);
  };
  function I2(a) {
    O2 = a;
    N2 || (N2 = true, S2());
  }
  function K2(a, b) {
    L2 = D2(function() {
      a(exports.unstable_now());
    }, b);
  }
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_cancelCallback = function(a) {
    a.callback = null;
  };
  exports.unstable_continueExecution = function() {
    A2 || z2 || (A2 = true, I2(J2));
  };
  exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P2 = 0 < a ? Math.floor(1e3 / a) : 5;
  };
  exports.unstable_getCurrentPriorityLevel = function() {
    return y2;
  };
  exports.unstable_getFirstCallbackNode = function() {
    return h(r2);
  };
  exports.unstable_next = function(a) {
    switch (y2) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;
      default:
        b = y2;
    }
    var c = y2;
    y2 = b;
    try {
      return a();
    } finally {
      y2 = c;
    }
  };
  exports.unstable_pauseExecution = function() {
  };
  exports.unstable_requestPaint = function() {
  };
  exports.unstable_runWithPriority = function(a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a = 3;
    }
    var c = y2;
    y2 = a;
    try {
      return b();
    } finally {
      y2 = c;
    }
  };
  exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch (a) {
      case 1:
        var e = -1;
        break;
      case 2:
        e = 250;
        break;
      case 5:
        e = 1073741823;
        break;
      case 4:
        e = 1e4;
        break;
      default:
        e = 5e3;
    }
    e = c + e;
    a = { id: u2++, callback: b, priorityLevel: a, startTime: c, expirationTime: e, sortIndex: -1 };
    c > d ? (a.sortIndex = c, f2(t2, a), null === h(r2) && a === h(t2) && (B2 ? (E2(L2), L2 = -1) : B2 = true, K2(H2, c - d))) : (a.sortIndex = e, f2(r2, a), A2 || z2 || (A2 = true, I2(J2)));
    return a;
  };
  exports.unstable_shouldYield = M2;
  exports.unstable_wrapCallback = function(a) {
    var b = y2;
    return function() {
      var c = y2;
      y2 = b;
      try {
        return a.apply(this, arguments);
      } finally {
        y2 = c;
      }
    };
  };
})(scheduler_production_min);
{
  scheduler.exports = scheduler_production_min;
}
var schedulerExports = scheduler.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa = reactExports, ca = schedulerExports;
function p$1(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = /* @__PURE__ */ new Set(), ea = {};
function fa(a, b) {
  ha(a, b);
  ha(a + "Capture", b);
}
function ha(a, b) {
  ea[a] = b;
  for (a = 0; a < b.length; a++) da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
  if (ja.call(ma, a)) return true;
  if (ja.call(la, a)) return false;
  if (ka.test(a)) return ma[a] = true;
  la[a] = true;
  return false;
}
function pa(a, b, c, d) {
  if (null !== c && 0 === c.type) return false;
  switch (typeof b) {
    case "function":
    case "symbol":
      return true;
    case "boolean":
      if (d) return false;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;
    default:
      return false;
  }
}
function qa(a, b, c, d) {
  if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return true;
  if (d) return false;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;
    case 4:
      return false === b;
    case 5:
      return isNaN(b);
    case 6:
      return isNaN(b) || 1 > b;
  }
  return false;
}
function v$1(a, b, c, d, e, f2, g2) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f2;
  this.removeEmptyString = g2;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
  z[a] = new v$1(a, 0, false, a, null, false, false);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
  var b = a[0];
  z[b] = new v$1(b, 1, false, a[1], null, false, false);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
  z[a] = new v$1(a, 2, false, a.toLowerCase(), null, false, false);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
  z[a] = new v$1(a, 2, false, a, null, false, false);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
  z[a] = new v$1(a, 3, false, a.toLowerCase(), null, false, false);
});
["checked", "multiple", "muted", "selected"].forEach(function(a) {
  z[a] = new v$1(a, 3, true, a, null, false, false);
});
["capture", "download"].forEach(function(a) {
  z[a] = new v$1(a, 4, false, a, null, false, false);
});
["cols", "rows", "size", "span"].forEach(function(a) {
  z[a] = new v$1(a, 6, false, a, null, false, false);
});
["rowSpan", "start"].forEach(function(a) {
  z[a] = new v$1(a, 5, false, a.toLowerCase(), null, false, false);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
  var b = a.replace(
    ra,
    sa
  );
  z[b] = new v$1(b, 1, false, a, null, false, false);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
  var b = a.replace(ra, sa);
  z[b] = new v$1(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
  var b = a.replace(ra, sa);
  z[b] = new v$1(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
});
["tabIndex", "crossOrigin"].forEach(function(a) {
  z[a] = new v$1(a, 1, false, a.toLowerCase(), null, false, false);
});
z.xlinkHref = new v$1("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
["src", "href", "action", "formAction"].forEach(function(a) {
  z[a] = new v$1(a, 1, false, a.toLowerCase(), null, true, true);
});
function ta(a, b, c, d) {
  var e = z.hasOwnProperty(b) ? z[b] : null;
  if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? false : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && true === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
var Ia = Symbol.for("react.offscreen");
var Ja = Symbol.iterator;
function Ka(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ja && a[Ja] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
  if (void 0 === La) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    La = b && b[1] || "";
  }
  return "\n" + La + a;
}
var Na = false;
function Oa(a, b) {
  if (!a || Na) return "";
  Na = true;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (b) if (b = function() {
      throw Error();
    }, Object.defineProperty(b.prototype, "props", { set: function() {
      throw Error();
    } }), "object" === typeof Reflect && Reflect.construct) {
      try {
        Reflect.construct(b, []);
      } catch (l2) {
        var d = l2;
      }
      Reflect.construct(a, [], b);
    } else {
      try {
        b.call();
      } catch (l2) {
        d = l2;
      }
      a.call(b.prototype);
    }
    else {
      try {
        throw Error();
      } catch (l2) {
        d = l2;
      }
      a();
    }
  } catch (l2) {
    if (l2 && d && "string" === typeof l2.stack) {
      for (var e = l2.stack.split("\n"), f2 = d.stack.split("\n"), g2 = e.length - 1, h = f2.length - 1; 1 <= g2 && 0 <= h && e[g2] !== f2[h]; ) h--;
      for (; 1 <= g2 && 0 <= h; g2--, h--) if (e[g2] !== f2[h]) {
        if (1 !== g2 || 1 !== h) {
          do
            if (g2--, h--, 0 > h || e[g2] !== f2[h]) {
              var k2 = "\n" + e[g2].replace(" at new ", " at ");
              a.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a.displayName));
              return k2;
            }
          while (1 <= g2 && 0 <= h);
        }
        break;
      }
    }
  } finally {
    Na = false, Error.prepareStackTrace = c;
  }
  return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
  switch (a.tag) {
    case 5:
      return Ma(a.type);
    case 16:
      return Ma("Lazy");
    case 13:
      return Ma("Suspense");
    case 19:
      return Ma("SuspenseList");
    case 0:
    case 2:
    case 15:
      return a = Oa(a.type, false), a;
    case 11:
      return a = Oa(a.type.render, false), a;
    case 1:
      return a = Oa(a.type, true), a;
    default:
      return "";
  }
}
function Qa(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;
  switch (a) {
    case ya:
      return "Fragment";
    case wa:
      return "Portal";
    case Aa:
      return "Profiler";
    case za:
      return "StrictMode";
    case Ea:
      return "Suspense";
    case Fa:
      return "SuspenseList";
  }
  if ("object" === typeof a) switch (a.$$typeof) {
    case Ca:
      return (a.displayName || "Context") + ".Consumer";
    case Ba:
      return (a._context.displayName || "Context") + ".Provider";
    case Da:
      var b = a.render;
      a = a.displayName;
      a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
      return a;
    case Ga:
      return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
    case Ha:
      b = a._payload;
      a = a._init;
      try {
        return Qa(a(b));
      } catch (c) {
      }
  }
  return null;
}
function Ra(a) {
  var b = a.type;
  switch (a.tag) {
    case 24:
      return "Cache";
    case 9:
      return (b.displayName || "Context") + ".Consumer";
    case 10:
      return (b._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return b;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return Qa(b);
    case 8:
      return b === za ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if ("function" === typeof b) return b.displayName || b.name || null;
      if ("string" === typeof b) return b;
  }
  return null;
}
function Sa(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return a;
    case "object":
      return a;
    default:
      return "";
  }
}
function Ta(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
  var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get, f2 = c.set;
    Object.defineProperty(a, b, { configurable: true, get: function() {
      return e.call(this);
    }, set: function(a2) {
      d = "" + a2;
      f2.call(this, a2);
    } });
    Object.defineProperty(a, b, { enumerable: c.enumerable });
    return { getValue: function() {
      return d;
    }, setValue: function(a2) {
      d = "" + a2;
    }, stopTracking: function() {
      a._valueTracker = null;
      delete a[b];
    } };
  }
}
function Va(a) {
  a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
  if (!a) return false;
  var b = a._valueTracker;
  if (!b) return true;
  var c = b.getValue();
  var d = "";
  a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), true) : false;
}
function Xa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;
  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}
function Ya(a, b) {
  var c = b.checked;
  return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}
function Za(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
  c = Sa(null != b.value ? b.value : c);
  a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}
function ab(a, b) {
  b = b.checked;
  null != b && ta(a, "checked", b, false);
}
function bb(a, b) {
  ab(a, b);
  var c = Sa(b.value), d = b.type;
  if (null != c) if ("number" === d) {
    if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
  } else a.value !== "" + c && (a.value = "" + c);
  else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }
  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}
function cb(a, b, c) {
  if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
  a = a.options;
  if (b) {
    b = {};
    for (var e = 0; e < c.length; e++) b["$" + c[e]] = true;
    for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = true);
  } else {
    c = "" + Sa(c);
    b = null;
    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = true;
        d && (a[e].defaultSelected = true);
        return;
      }
      null !== b || a[e].disabled || (b = a[e]);
    }
    null !== b && (b.selected = true);
  }
}
function gb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(p$1(91));
  return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}
function hb(a, b) {
  var c = b.value;
  if (null == c) {
    c = b.children;
    b = b.defaultValue;
    if (null != c) {
      if (null != b) throw Error(p$1(92));
      if (eb(c)) {
        if (1 < c.length) throw Error(p$1(93));
        c = c[0];
      }
      b = c;
    }
    null == b && (b = "");
    c = b;
  }
  a._wrapperState = { initialValue: Sa(c) };
}
function ib(a, b) {
  var c = Sa(b.value), d = Sa(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}
function jb(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function lb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function() {
      return a(b, c, d, e);
    });
  } : a;
}(function(a, b) {
  if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
  else {
    mb = mb || document.createElement("div");
    mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
    for (b = mb.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
    for (; b.firstChild; ) a.appendChild(b.firstChild);
  }
});
function ob(a, b) {
  if (b) {
    var c = a.firstChild;
    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }
  a.textContent = b;
}
var pb = {
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
}, qb = ["Webkit", "ms", "Moz", "O"];
Object.keys(pb).forEach(function(a) {
  qb.forEach(function(b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    pb[b] = pb[a];
  });
});
function rb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
  a = a.style;
  for (var c in b) if (b.hasOwnProperty(c)) {
    var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
    "float" === c && (c = "cssFloat");
    d ? a.setProperty(c, e) : a[c] = e;
  }
}
var tb = A({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
function ub(a, b) {
  if (b) {
    if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p$1(137, a));
    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(p$1(60));
      if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p$1(61));
    }
    if (null != b.style && "object" !== typeof b.style) throw Error(p$1(62));
  }
}
function vb(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;
  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
var wb = null;
function xb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
  if (a = Cb(a)) {
    if ("function" !== typeof yb) throw Error(p$1(280));
    var b = a.stateNode;
    b && (b = Db(b), yb(a.stateNode, a.type, b));
  }
}
function Eb(a) {
  zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
}
function Fb() {
  if (zb) {
    var a = zb, b = Ab;
    Ab = zb = null;
    Bb(a);
    if (b) for (a = 0; a < b.length; a++) Bb(b[a]);
  }
}
function Gb(a, b) {
  return a(b);
}
function Hb() {
}
var Ib = false;
function Jb(a, b, c) {
  if (Ib) return a(b, c);
  Ib = true;
  try {
    return Gb(a, b, c);
  } finally {
    if (Ib = false, null !== zb || null !== Ab) Hb(), Fb();
  }
}
function Kb(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Db(c);
  if (null === d) return null;
  c = d[b];
  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;
    default:
      a = false;
  }
  if (a) return null;
  if (c && "function" !== typeof c) throw Error(p$1(231, b, typeof c));
  return c;
}
var Lb = false;
if (ia) try {
  var Mb = {};
  Object.defineProperty(Mb, "passive", { get: function() {
    Lb = true;
  } });
  window.addEventListener("test", Mb, Mb);
  window.removeEventListener("test", Mb, Mb);
} catch (a) {
  Lb = false;
}
function Nb(a, b, c, d, e, f2, g2, h, k2) {
  var l2 = Array.prototype.slice.call(arguments, 3);
  try {
    b.apply(c, l2);
  } catch (m2) {
    this.onError(m2);
  }
}
var Ob = false, Pb = null, Qb = false, Rb = null, Sb = { onError: function(a) {
  Ob = true;
  Pb = a;
} };
function Tb(a, b, c, d, e, f2, g2, h, k2) {
  Ob = false;
  Pb = null;
  Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f2, g2, h, k2) {
  Tb.apply(this, arguments);
  if (Ob) {
    if (Ob) {
      var l2 = Pb;
      Ob = false;
      Pb = null;
    } else throw Error(p$1(198));
    Qb || (Qb = true, Rb = l2);
  }
}
function Vb(a) {
  var b = a, c = a;
  if (a.alternate) for (; b.return; ) b = b.return;
  else {
    a = b;
    do
      b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
    while (a);
  }
  return 3 === b.tag ? c : null;
}
function Wb(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }
  return null;
}
function Xb(a) {
  if (Vb(a) !== a) throw Error(p$1(188));
}
function Yb(a) {
  var b = a.alternate;
  if (!b) {
    b = Vb(a);
    if (null === b) throw Error(p$1(188));
    return b !== a ? null : a;
  }
  for (var c = a, d = b; ; ) {
    var e = c.return;
    if (null === e) break;
    var f2 = e.alternate;
    if (null === f2) {
      d = e.return;
      if (null !== d) {
        c = d;
        continue;
      }
      break;
    }
    if (e.child === f2.child) {
      for (f2 = e.child; f2; ) {
        if (f2 === c) return Xb(e), a;
        if (f2 === d) return Xb(e), b;
        f2 = f2.sibling;
      }
      throw Error(p$1(188));
    }
    if (c.return !== d.return) c = e, d = f2;
    else {
      for (var g2 = false, h = e.child; h; ) {
        if (h === c) {
          g2 = true;
          c = e;
          d = f2;
          break;
        }
        if (h === d) {
          g2 = true;
          d = e;
          c = f2;
          break;
        }
        h = h.sibling;
      }
      if (!g2) {
        for (h = f2.child; h; ) {
          if (h === c) {
            g2 = true;
            c = f2;
            d = e;
            break;
          }
          if (h === d) {
            g2 = true;
            d = f2;
            c = e;
            break;
          }
          h = h.sibling;
        }
        if (!g2) throw Error(p$1(189));
      }
    }
    if (c.alternate !== d) throw Error(p$1(190));
  }
  if (3 !== c.tag) throw Error(p$1(188));
  return c.stateNode.current === c ? a : b;
}
function Zb(a) {
  a = Yb(a);
  return null !== a ? $b(a) : null;
}
function $b(a) {
  if (5 === a.tag || 6 === a.tag) return a;
  for (a = a.child; null !== a; ) {
    var b = $b(a);
    if (null !== b) return b;
    a = a.sibling;
  }
  return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
  if (lc && "function" === typeof lc.onCommitFiberRoot) try {
    lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
  } catch (b) {
  }
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
  a >>>= 0;
  return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
  switch (a & -a) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return a & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return a & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return a;
  }
}
function uc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return 0;
  var d = 0, e = a.suspendedLanes, f2 = a.pingedLanes, g2 = c & 268435455;
  if (0 !== g2) {
    var h = g2 & ~e;
    0 !== h ? d = tc(h) : (f2 &= g2, 0 !== f2 && (d = tc(f2)));
  } else g2 = c & ~e, 0 !== g2 ? d = tc(g2) : 0 !== f2 && (d = tc(f2));
  if (0 === d) return 0;
  if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f2 = b & -b, e >= f2 || 16 === e && 0 !== (f2 & 4194240))) return b;
  0 !== (d & 4) && (d |= c & 16);
  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b; ) c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
  return d;
}
function vc(a, b) {
  switch (a) {
    case 1:
    case 2:
    case 4:
      return b + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return b + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function wc(a, b) {
  for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f2 = a.pendingLanes; 0 < f2; ) {
    var g2 = 31 - oc(f2), h = 1 << g2, k2 = e[g2];
    if (-1 === k2) {
      if (0 === (h & c) || 0 !== (h & d)) e[g2] = vc(h, b);
    } else k2 <= b && (a.expiredLanes |= h);
    f2 &= ~h;
  }
}
function xc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
  var a = rc;
  rc <<= 1;
  0 === (rc & 4194240) && (rc = 64);
  return a;
}
function zc(a) {
  for (var b = [], c = 0; 31 > c; c++) b.push(a);
  return b;
}
function Ac(a, b, c) {
  a.pendingLanes |= b;
  536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
  a = a.eventTimes;
  b = 31 - oc(b);
  a[b] = c;
}
function Bc(a, b) {
  var c = a.pendingLanes & ~b;
  a.pendingLanes = b;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= b;
  a.mutableReadLanes &= b;
  a.entangledLanes &= b;
  b = a.entanglements;
  var d = a.eventTimes;
  for (a = a.expirationTimes; 0 < c; ) {
    var e = 31 - oc(c), f2 = 1 << e;
    b[e] = 0;
    d[e] = -1;
    a[e] = -1;
    c &= ~f2;
  }
}
function Cc(a, b) {
  var c = a.entangledLanes |= b;
  for (a = a.entanglements; c; ) {
    var d = 31 - oc(c), e = 1 << d;
    e & b | a[d] & b && (a[d] |= b);
    c &= ~e;
  }
}
var C = 0;
function Dc(a) {
  a &= -a;
  return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = false, Kc = [], Lc = null, Mc = null, Nc = null, Oc = /* @__PURE__ */ new Map(), Pc = /* @__PURE__ */ new Map(), Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      Lc = null;
      break;
    case "dragenter":
    case "dragleave":
      Mc = null;
      break;
    case "mouseover":
    case "mouseout":
      Nc = null;
      break;
    case "pointerover":
    case "pointerout":
      Oc.delete(b.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Pc.delete(b.pointerId);
  }
}
function Tc(a, b, c, d, e, f2) {
  if (null === a || a.nativeEvent !== f2) return a = { blockedOn: b, domEventName: c, eventSystemFlags: d, nativeEvent: f2, targetContainers: [e] }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}
function Uc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return Lc = Tc(Lc, a, b, c, d, e), true;
    case "dragenter":
      return Mc = Tc(Mc, a, b, c, d, e), true;
    case "mouseover":
      return Nc = Tc(Nc, a, b, c, d, e), true;
    case "pointerover":
      var f2 = e.pointerId;
      Oc.set(f2, Tc(Oc.get(f2) || null, a, b, c, d, e));
      return true;
    case "gotpointercapture":
      return f2 = e.pointerId, Pc.set(f2, Tc(Pc.get(f2) || null, a, b, c, d, e)), true;
  }
  return false;
}
function Vc(a) {
  var b = Wc(a.target);
  if (null !== b) {
    var c = Vb(b);
    if (null !== c) {
      if (b = c.tag, 13 === b) {
        if (b = Wb(c), null !== b) {
          a.blockedOn = b;
          Ic(a.priority, function() {
            Gc(c);
          });
          return;
        }
      } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
        a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
        return;
      }
    }
  }
  a.blockedOn = null;
}
function Xc(a) {
  if (null !== a.blockedOn) return false;
  for (var b = a.targetContainers; 0 < b.length; ) {
    var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
    if (null === c) {
      c = a.nativeEvent;
      var d = new c.constructor(c.type, c);
      wb = d;
      c.target.dispatchEvent(d);
      wb = null;
    } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, false;
    b.shift();
  }
  return true;
}
function Zc(a, b, c) {
  Xc(a) && c.delete(b);
}
function $c() {
  Jc = false;
  null !== Lc && Xc(Lc) && (Lc = null);
  null !== Mc && Xc(Mc) && (Mc = null);
  null !== Nc && Xc(Nc) && (Nc = null);
  Oc.forEach(Zc);
  Pc.forEach(Zc);
}
function ad(a, b) {
  a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = true, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
  function b(b2) {
    return ad(b2, a);
  }
  if (0 < Kc.length) {
    ad(Kc[0], a);
    for (var c = 1; c < Kc.length; c++) {
      var d = Kc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }
  null !== Lc && ad(Lc, a);
  null !== Mc && ad(Mc, a);
  null !== Nc && ad(Nc, a);
  Oc.forEach(b);
  Pc.forEach(b);
  for (c = 0; c < Qc.length; c++) d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
  for (; 0 < Qc.length && (c = Qc[0], null === c.blockedOn); ) Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = true;
function ed(a, b, c, d) {
  var e = C, f2 = cd.transition;
  cd.transition = null;
  try {
    C = 1, fd(a, b, c, d);
  } finally {
    C = e, cd.transition = f2;
  }
}
function gd(a, b, c, d) {
  var e = C, f2 = cd.transition;
  cd.transition = null;
  try {
    C = 4, fd(a, b, c, d);
  } finally {
    C = e, cd.transition = f2;
  }
}
function fd(a, b, c, d) {
  if (dd) {
    var e = Yc(a, b, c, d);
    if (null === e) hd(a, b, d, id, c), Sc(a, d);
    else if (Uc(e, a, b, c, d)) d.stopPropagation();
    else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
      for (; null !== e; ) {
        var f2 = Cb(e);
        null !== f2 && Ec(f2);
        f2 = Yc(a, b, c, d);
        null === f2 && hd(a, b, d, id, c);
        if (f2 === e) break;
        e = f2;
      }
      null !== e && d.stopPropagation();
    } else hd(a, b, d, null, c);
  }
}
var id = null;
function Yc(a, b, c, d) {
  id = null;
  a = xb(d);
  a = Wc(a);
  if (null !== a) if (b = Vb(a), null === b) a = null;
  else if (c = b.tag, 13 === c) {
    a = Wb(b);
    if (null !== a) return a;
    a = null;
  } else if (3 === c) {
    if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
    a = null;
  } else b !== a && (a = null);
  id = a;
  return null;
}
function jd(a) {
  switch (a) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (ec()) {
        case fc:
          return 1;
        case gc:
          return 4;
        case hc:
        case ic:
          return 16;
        case jc:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var kd = null, ld = null, md = null;
function nd() {
  if (md) return md;
  var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f2 = e.length;
  for (a = 0; a < c && b[a] === e[a]; a++) ;
  var g2 = c - a;
  for (d = 1; d <= g2 && b[c - d] === e[f2 - d]; d++) ;
  return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}
function pd() {
  return true;
}
function qd() {
  return false;
}
function rd(a) {
  function b(b2, d, e, f2, g2) {
    this._reactName = b2;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f2;
    this.target = g2;
    this.currentTarget = null;
    for (var c in a) a.hasOwnProperty(c) && (b2 = a[c], this[c] = b2 ? b2(f2) : f2[c]);
    this.isDefaultPrevented = (null != f2.defaultPrevented ? f2.defaultPrevented : false === f2.returnValue) ? pd : qd;
    this.isPropagationStopped = qd;
    return this;
  }
  A(b.prototype, { preventDefault: function() {
    this.defaultPrevented = true;
    var a2 = this.nativeEvent;
    a2 && (a2.preventDefault ? a2.preventDefault() : "unknown" !== typeof a2.returnValue && (a2.returnValue = false), this.isDefaultPrevented = pd);
  }, stopPropagation: function() {
    var a2 = this.nativeEvent;
    a2 && (a2.stopPropagation ? a2.stopPropagation() : "unknown" !== typeof a2.cancelBubble && (a2.cancelBubble = true), this.isPropagationStopped = pd);
  }, persist: function() {
  }, isPersistent: pd });
  return b;
}
var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a) {
  return a.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = A({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a) {
  return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
}, movementX: function(a) {
  if ("movementX" in a) return a.movementX;
  a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
  return wd;
}, movementY: function(a) {
  return "movementY" in a ? a.movementY : xd;
} }), Bd = rd(Ad), Cd = A({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = A({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = A({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = A({}, sd, { clipboardData: function(a) {
  return "clipboardData" in a ? a.clipboardData : window.clipboardData;
} }), Jd = rd(Id), Kd = A({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Nd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Pd(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : false;
}
function zd() {
  return Pd;
}
var Qd = A({}, ud, { key: function(a) {
  if (a.key) {
    var b = Md[a.key] || a.key;
    if ("Unidentified" !== b) return b;
  }
  return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a) {
  return "keypress" === a.type ? od(a) : 0;
}, keyCode: function(a) {
  return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
}, which: function(a) {
  return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
} }), Rd = rd(Qd), Sd = A({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = A({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = A({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = A({}, Ad, {
  deltaX: function(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
function ge(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== $d.indexOf(b.keyCode);
    case "keydown":
      return 229 !== b.keyCode;
    case "keypress":
    case "mousedown":
    case "focusout":
      return true;
    default:
      return false;
  }
}
function he(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = false;
function je(a, b) {
  switch (a) {
    case "compositionend":
      return he(b);
    case "keypress":
      if (32 !== b.which) return null;
      fe = true;
      return ee;
    case "textInput":
      return a = b.data, a === ee && fe ? null : a;
    default:
      return null;
  }
}
function ke(a, b) {
  if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = false, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;
        if (b.which) return String.fromCharCode(b.which);
      }
      return null;
    case "compositionend":
      return de && "ko" !== b.locale ? null : b.data;
    default:
      return null;
  }
}
var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
function me(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!le[a.type] : "textarea" === b ? true : false;
}
function ne(a, b, c, d) {
  Eb(d);
  b = oe(b, "onChange");
  0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({ event: c, listeners: b }));
}
var pe = null, qe = null;
function re(a) {
  se(a, 0);
}
function te(a) {
  var b = ue(a);
  if (Wa(b)) return a;
}
function ve(a, b) {
  if ("change" === a) return b;
}
var we = false;
if (ia) {
  var xe;
  if (ia) {
    var ye = "oninput" in document;
    if (!ye) {
      var ze = document.createElement("div");
      ze.setAttribute("oninput", "return;");
      ye = "function" === typeof ze.oninput;
    }
    xe = ye;
  } else xe = false;
  we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
  pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
  if ("value" === a.propertyName && te(qe)) {
    var b = [];
    ne(b, qe, a, xb(a));
    Jb(re, b);
  }
}
function Ce(a, b, c) {
  "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
  if ("click" === a) return te(b);
}
function Fe(a, b) {
  if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
  if (He(a, b)) return true;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return false;
  var c = Object.keys(a), d = Object.keys(b);
  if (c.length !== d.length) return false;
  for (d = 0; d < c.length; d++) {
    var e = c[d];
    if (!ja.call(b, e) || !He(a[e], b[e])) return false;
  }
  return true;
}
function Je(a) {
  for (; a && a.firstChild; ) a = a.firstChild;
  return a;
}
function Ke(a, b) {
  var c = Je(a);
  a = 0;
  for (var d; c; ) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return { node: c, offset: b - a };
      a = d;
    }
    a: {
      for (; c; ) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }
        c = c.parentNode;
      }
      c = void 0;
    }
    c = Je(c);
  }
}
function Le(a, b) {
  return a && b ? a === b ? true : a && 3 === a.nodeType ? false : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
}
function Me() {
  for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement; ) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = false;
    }
    if (c) a = b.contentWindow;
    else break;
    b = Xa(a.document);
  }
  return b;
}
function Ne(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
  var b = Me(), c = a.focusedElem, d = a.selectionRange;
  if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
    if (null !== d && Ne(c)) {
      if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
      else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
        a = a.getSelection();
        var e = c.textContent.length, f2 = Math.min(d.start, e);
        d = void 0 === d.end ? f2 : Math.min(d.end, e);
        !a.extend && f2 > d && (e = d, d = f2, f2 = e);
        e = Ke(c, f2);
        var g2 = Ke(
          c,
          d
        );
        e && g2 && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g2.node || a.focusOffset !== g2.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f2 > d ? (a.addRange(b), a.extend(g2.node, g2.offset)) : (b.setEnd(g2.node, g2.offset), a.addRange(b)));
      }
    }
    b = [];
    for (a = c; a = a.parentNode; ) 1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
    "function" === typeof c.focus && c.focus();
    for (c = 0; c < b.length; c++) a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
  }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
function Ue(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({ event: b, listeners: d }), b.target = Qe)));
}
function Ve(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}
var We = { animationend: Ve("Animation", "AnimationEnd"), animationiteration: Ve("Animation", "AnimationIteration"), animationstart: Ve("Animation", "AnimationStart"), transitionend: Ve("Transition", "TransitionEnd") }, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
  if (Xe[a]) return Xe[a];
  if (!We[a]) return a;
  var b = We[a], c;
  for (c in b) if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
  return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = /* @__PURE__ */ new Map(), ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
  df.set(a, b);
  fa(b, [a]);
}
for (var gf = 0; gf < ef.length; gf++) {
  var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
  ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", ["mouseout", "mouseover"]);
ha("onMouseLeave", ["mouseout", "mouseover"]);
ha("onPointerEnter", ["pointerout", "pointerover"]);
ha("onPointerLeave", ["pointerout", "pointerover"]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Ub(d, b, void 0, a);
  a.currentTarget = null;
}
function se(a, b) {
  b = 0 !== (b & 4);
  for (var c = 0; c < a.length; c++) {
    var d = a[c], e = d.event;
    d = d.listeners;
    a: {
      var f2 = void 0;
      if (b) for (var g2 = d.length - 1; 0 <= g2; g2--) {
        var h = d[g2], k2 = h.instance, l2 = h.currentTarget;
        h = h.listener;
        if (k2 !== f2 && e.isPropagationStopped()) break a;
        nf(e, h, l2);
        f2 = k2;
      }
      else for (g2 = 0; g2 < d.length; g2++) {
        h = d[g2];
        k2 = h.instance;
        l2 = h.currentTarget;
        h = h.listener;
        if (k2 !== f2 && e.isPropagationStopped()) break a;
        nf(e, h, l2);
        f2 = k2;
      }
    }
  }
  if (Qb) throw a = Rb, Qb = false, Rb = null, a;
}
function D(a, b) {
  var c = b[of];
  void 0 === c && (c = b[of] = /* @__PURE__ */ new Set());
  var d = a + "__bubble";
  c.has(d) || (pf(b, a, 2, false), c.add(d));
}
function qf(a, b, c) {
  var d = 0;
  b && (d |= 4);
  pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
  if (!a[rf]) {
    a[rf] = true;
    da.forEach(function(b2) {
      "selectionchange" !== b2 && (mf.has(b2) || qf(b2, false, a), qf(b2, true, a));
    });
    var b = 9 === a.nodeType ? a : a.ownerDocument;
    null === b || b[rf] || (b[rf] = true, qf("selectionchange", false, b));
  }
}
function pf(a, b, c, d) {
  switch (jd(b)) {
    case 1:
      var e = ed;
      break;
    case 4:
      e = gd;
      break;
    default:
      e = fd;
  }
  c = e.bind(null, b, c, a);
  e = void 0;
  !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = true);
  d ? void 0 !== e ? a.addEventListener(b, c, { capture: true, passive: e }) : a.addEventListener(b, c, true) : void 0 !== e ? a.addEventListener(b, c, { passive: e }) : a.addEventListener(b, c, false);
}
function hd(a, b, c, d, e) {
  var f2 = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (; ; ) {
    if (null === d) return;
    var g2 = d.tag;
    if (3 === g2 || 4 === g2) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g2) for (g2 = d.return; null !== g2; ) {
        var k2 = g2.tag;
        if (3 === k2 || 4 === k2) {
          if (k2 = g2.stateNode.containerInfo, k2 === e || 8 === k2.nodeType && k2.parentNode === e) return;
        }
        g2 = g2.return;
      }
      for (; null !== h; ) {
        g2 = Wc(h);
        if (null === g2) return;
        k2 = g2.tag;
        if (5 === k2 || 6 === k2) {
          d = f2 = g2;
          continue a;
        }
        h = h.parentNode;
      }
    }
    d = d.return;
  }
  Jb(function() {
    var d2 = f2, e2 = xb(c), g3 = [];
    a: {
      var h2 = df.get(a);
      if (void 0 !== h2) {
        var k3 = td, n2 = a;
        switch (a) {
          case "keypress":
            if (0 === od(c)) break a;
          case "keydown":
          case "keyup":
            k3 = Rd;
            break;
          case "focusin":
            n2 = "focus";
            k3 = Fd;
            break;
          case "focusout":
            n2 = "blur";
            k3 = Fd;
            break;
          case "beforeblur":
          case "afterblur":
            k3 = Fd;
            break;
          case "click":
            if (2 === c.button) break a;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k3 = Bd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k3 = Dd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k3 = Vd;
            break;
          case $e:
          case af:
          case bf:
            k3 = Hd;
            break;
          case cf:
            k3 = Xd;
            break;
          case "scroll":
            k3 = vd;
            break;
          case "wheel":
            k3 = Zd;
            break;
          case "copy":
          case "cut":
          case "paste":
            k3 = Jd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k3 = Td;
        }
        var t2 = 0 !== (b & 4), J2 = !t2 && "scroll" === a, x2 = t2 ? null !== h2 ? h2 + "Capture" : null : h2;
        t2 = [];
        for (var w2 = d2, u2; null !== w2; ) {
          u2 = w2;
          var F2 = u2.stateNode;
          5 === u2.tag && null !== F2 && (u2 = F2, null !== x2 && (F2 = Kb(w2, x2), null != F2 && t2.push(tf(w2, F2, u2))));
          if (J2) break;
          w2 = w2.return;
        }
        0 < t2.length && (h2 = new k3(h2, n2, null, c, e2), g3.push({ event: h2, listeners: t2 }));
      }
    }
    if (0 === (b & 7)) {
      a: {
        h2 = "mouseover" === a || "pointerover" === a;
        k3 = "mouseout" === a || "pointerout" === a;
        if (h2 && c !== wb && (n2 = c.relatedTarget || c.fromElement) && (Wc(n2) || n2[uf])) break a;
        if (k3 || h2) {
          h2 = e2.window === e2 ? e2 : (h2 = e2.ownerDocument) ? h2.defaultView || h2.parentWindow : window;
          if (k3) {
            if (n2 = c.relatedTarget || c.toElement, k3 = d2, n2 = n2 ? Wc(n2) : null, null !== n2 && (J2 = Vb(n2), n2 !== J2 || 5 !== n2.tag && 6 !== n2.tag)) n2 = null;
          } else k3 = null, n2 = d2;
          if (k3 !== n2) {
            t2 = Bd;
            F2 = "onMouseLeave";
            x2 = "onMouseEnter";
            w2 = "mouse";
            if ("pointerout" === a || "pointerover" === a) t2 = Td, F2 = "onPointerLeave", x2 = "onPointerEnter", w2 = "pointer";
            J2 = null == k3 ? h2 : ue(k3);
            u2 = null == n2 ? h2 : ue(n2);
            h2 = new t2(F2, w2 + "leave", k3, c, e2);
            h2.target = J2;
            h2.relatedTarget = u2;
            F2 = null;
            Wc(e2) === d2 && (t2 = new t2(x2, w2 + "enter", n2, c, e2), t2.target = u2, t2.relatedTarget = J2, F2 = t2);
            J2 = F2;
            if (k3 && n2) b: {
              t2 = k3;
              x2 = n2;
              w2 = 0;
              for (u2 = t2; u2; u2 = vf(u2)) w2++;
              u2 = 0;
              for (F2 = x2; F2; F2 = vf(F2)) u2++;
              for (; 0 < w2 - u2; ) t2 = vf(t2), w2--;
              for (; 0 < u2 - w2; ) x2 = vf(x2), u2--;
              for (; w2--; ) {
                if (t2 === x2 || null !== x2 && t2 === x2.alternate) break b;
                t2 = vf(t2);
                x2 = vf(x2);
              }
              t2 = null;
            }
            else t2 = null;
            null !== k3 && wf(g3, h2, k3, t2, false);
            null !== n2 && null !== J2 && wf(g3, J2, n2, t2, true);
          }
        }
      }
      a: {
        h2 = d2 ? ue(d2) : window;
        k3 = h2.nodeName && h2.nodeName.toLowerCase();
        if ("select" === k3 || "input" === k3 && "file" === h2.type) var na = ve;
        else if (me(h2)) if (we) na = Fe;
        else {
          na = De;
          var xa = Ce;
        }
        else (k3 = h2.nodeName) && "input" === k3.toLowerCase() && ("checkbox" === h2.type || "radio" === h2.type) && (na = Ee);
        if (na && (na = na(a, d2))) {
          ne(g3, na, c, e2);
          break a;
        }
        xa && xa(a, h2, d2);
        "focusout" === a && (xa = h2._wrapperState) && xa.controlled && "number" === h2.type && cb(h2, "number", h2.value);
      }
      xa = d2 ? ue(d2) : window;
      switch (a) {
        case "focusin":
          if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d2, Se = null;
          break;
        case "focusout":
          Se = Re = Qe = null;
          break;
        case "mousedown":
          Te = true;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Te = false;
          Ue(g3, c, e2);
          break;
        case "selectionchange":
          if (Pe) break;
        case "keydown":
        case "keyup":
          Ue(g3, c, e2);
      }
      var $a;
      if (ae) b: {
        switch (a) {
          case "compositionstart":
            var ba = "onCompositionStart";
            break b;
          case "compositionend":
            ba = "onCompositionEnd";
            break b;
          case "compositionupdate":
            ba = "onCompositionUpdate";
            break b;
        }
        ba = void 0;
      }
      else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
      ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e2, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), xa = oe(d2, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e2), g3.push({ event: ba, listeners: xa }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
      if ($a = ce ? je(a, c) : ke(a, c)) d2 = oe(d2, "onBeforeInput"), 0 < d2.length && (e2 = new Ld("onBeforeInput", "beforeinput", null, c, e2), g3.push({ event: e2, listeners: d2 }), e2.data = $a);
    }
    se(g3, b);
  });
}
function tf(a, b, c) {
  return { instance: a, listener: b, currentTarget: c };
}
function oe(a, b) {
  for (var c = b + "Capture", d = []; null !== a; ) {
    var e = a, f2 = e.stateNode;
    5 === e.tag && null !== f2 && (e = f2, f2 = Kb(a, c), null != f2 && d.unshift(tf(a, f2, e)), f2 = Kb(a, b), null != f2 && d.push(tf(a, f2, e)));
    a = a.return;
  }
  return d;
}
function vf(a) {
  if (null === a) return null;
  do
    a = a.return;
  while (a && 5 !== a.tag);
  return a ? a : null;
}
function wf(a, b, c, d, e) {
  for (var f2 = b._reactName, g2 = []; null !== c && c !== d; ) {
    var h = c, k2 = h.alternate, l2 = h.stateNode;
    if (null !== k2 && k2 === d) break;
    5 === h.tag && null !== l2 && (h = l2, e ? (k2 = Kb(c, f2), null != k2 && g2.unshift(tf(c, k2, h))) : e || (k2 = Kb(c, f2), null != k2 && g2.push(tf(c, k2, h))));
    c = c.return;
  }
  0 !== g2.length && a.push({ event: b, listeners: g2 });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
  return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
  b = zf(b);
  if (zf(a) !== b && c) throw Error(p$1(425));
}
function Bf() {
}
var Cf = null, Df = null;
function Ef(a, b) {
  return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
  return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
  setTimeout(function() {
    throw a;
  });
}
function Kf(a, b) {
  var c = b, d = 0;
  do {
    var e = c.nextSibling;
    a.removeChild(c);
    if (e && 8 === e.nodeType) if (c = e.data, "/$" === c) {
      if (0 === d) {
        a.removeChild(e);
        bd(b);
        return;
      }
      d--;
    } else "$" !== c && "$?" !== c && "$!" !== c || d++;
    c = e;
  } while (c);
  bd(b);
}
function Lf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;
    if (8 === b) {
      b = a.data;
      if ("$" === b || "$!" === b || "$?" === b) break;
      if ("/$" === b) return null;
    }
  }
  return a;
}
function Mf(a) {
  a = a.previousSibling;
  for (var b = 0; a; ) {
    if (8 === a.nodeType) {
      var c = a.data;
      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }
    a = a.previousSibling;
  }
  return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
  var b = a[Of];
  if (b) return b;
  for (var c = a.parentNode; c; ) {
    if (b = c[uf] || c[Of]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = Mf(a); null !== a; ) {
        if (c = a[Of]) return c;
        a = Mf(a);
      }
      return b;
    }
    a = c;
    c = a.parentNode;
  }
  return null;
}
function Cb(a) {
  a = a[Of] || a[uf];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(p$1(33));
}
function Db(a) {
  return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
  return { current: a };
}
function E(a) {
  0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
  Tf++;
  Sf[Tf] = a.current;
  a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(false), Xf = Vf;
function Yf(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Vf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {}, f2;
  for (f2 in c) e[f2] = b[f2];
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}
function Zf(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}
function $f() {
  E(Wf);
  E(H);
}
function ag(a, b, c) {
  if (H.current !== Vf) throw Error(p$1(168));
  G(H, b);
  G(Wf, c);
}
function bg(a, b, c) {
  var d = a.stateNode;
  b = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();
  for (var e in d) if (!(e in b)) throw Error(p$1(108, Ra(a) || "Unknown", e));
  return A({}, c, d);
}
function cg(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
  Xf = H.current;
  G(H, a);
  G(Wf, Wf.current);
  return true;
}
function dg(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(p$1(169));
  c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
  G(Wf, c);
}
var eg = null, fg = false, gg = false;
function hg(a) {
  null === eg ? eg = [a] : eg.push(a);
}
function ig(a) {
  fg = true;
  hg(a);
}
function jg() {
  if (!gg && null !== eg) {
    gg = true;
    var a = 0, b = C;
    try {
      var c = eg;
      for (C = 1; a < c.length; a++) {
        var d = c[a];
        do
          d = d(true);
        while (null !== d);
      }
      eg = null;
      fg = false;
    } catch (e) {
      throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
    } finally {
      C = b, gg = false;
    }
  }
  return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
  kg[lg++] = ng;
  kg[lg++] = mg;
  mg = a;
  ng = b;
}
function ug(a, b, c) {
  og[pg++] = rg;
  og[pg++] = sg;
  og[pg++] = qg;
  qg = a;
  var d = rg;
  a = sg;
  var e = 32 - oc(d) - 1;
  d &= ~(1 << e);
  c += 1;
  var f2 = 32 - oc(b) + e;
  if (30 < f2) {
    var g2 = e - e % 5;
    f2 = (d & (1 << g2) - 1).toString(32);
    d >>= g2;
    e -= g2;
    rg = 1 << 32 - oc(b) + e | c << e | d;
    sg = f2 + a;
  } else rg = 1 << f2 | c << e | d, sg = a;
}
function vg(a) {
  null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
  for (; a === mg; ) mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
  for (; a === qg; ) qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = false, zg = null;
function Ag(a, b) {
  var c = Bg(5, null, null, 0);
  c.elementType = "DELETED";
  c.stateNode = b;
  c.return = a;
  b = a.deletions;
  null === b ? (a.deletions = [c], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), true) : false;
    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, true) : false;
    case 13:
      return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? { id: rg, overflow: sg } : null, a.memoizedState = { dehydrated: b, treeContext: c, retryLane: 1073741824 }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, true) : false;
    default:
      return false;
  }
}
function Dg(a) {
  return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
  if (I) {
    var b = yg;
    if (b) {
      var c = b;
      if (!Cg(a, b)) {
        if (Dg(a)) throw Error(p$1(418));
        b = Lf(c.nextSibling);
        var d = xg;
        b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = false, xg = a);
      }
    } else {
      if (Dg(a)) throw Error(p$1(418));
      a.flags = a.flags & -4097 | 2;
      I = false;
      xg = a;
    }
  }
}
function Fg(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; ) a = a.return;
  xg = a;
}
function Gg(a) {
  if (a !== xg) return false;
  if (!I) return Fg(a), I = true, false;
  var b;
  (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
  if (b && (b = yg)) {
    if (Dg(a)) throw Hg(), Error(p$1(418));
    for (; b; ) Ag(a, b), b = Lf(b.nextSibling);
  }
  Fg(a);
  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(p$1(317));
    a: {
      a = a.nextSibling;
      for (b = 0; a; ) {
        if (8 === a.nodeType) {
          var c = a.data;
          if ("/$" === c) {
            if (0 === b) {
              yg = Lf(a.nextSibling);
              break a;
            }
            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }
        a = a.nextSibling;
      }
      yg = null;
    }
  } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
  return true;
}
function Hg() {
  for (var a = yg; a; ) a = Lf(a.nextSibling);
}
function Ig() {
  yg = xg = null;
  I = false;
}
function Jg(a) {
  null === zg ? zg = [a] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
  a = c.ref;
  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;
      if (c) {
        if (1 !== c.tag) throw Error(p$1(309));
        var d = c.stateNode;
      }
      if (!d) throw Error(p$1(147, a));
      var e = d, f2 = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f2) return b.ref;
      b = function(a2) {
        var b2 = e.refs;
        null === a2 ? delete b2[f2] : b2[f2] = a2;
      };
      b._stringRef = f2;
      return b;
    }
    if ("string" !== typeof a) throw Error(p$1(284));
    if (!c._owner) throw Error(p$1(290, a));
  }
  return a;
}
function Mg(a, b) {
  a = Object.prototype.toString.call(b);
  throw Error(p$1(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
  var b = a._init;
  return b(a._payload);
}
function Og(a) {
  function b(b2, c2) {
    if (a) {
      var d2 = b2.deletions;
      null === d2 ? (b2.deletions = [c2], b2.flags |= 16) : d2.push(c2);
    }
  }
  function c(c2, d2) {
    if (!a) return null;
    for (; null !== d2; ) b(c2, d2), d2 = d2.sibling;
    return null;
  }
  function d(a2, b2) {
    for (a2 = /* @__PURE__ */ new Map(); null !== b2; ) null !== b2.key ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
    return a2;
  }
  function e(a2, b2) {
    a2 = Pg(a2, b2);
    a2.index = 0;
    a2.sibling = null;
    return a2;
  }
  function f2(b2, c2, d2) {
    b2.index = d2;
    if (!a) return b2.flags |= 1048576, c2;
    d2 = b2.alternate;
    if (null !== d2) return d2 = d2.index, d2 < c2 ? (b2.flags |= 2, c2) : d2;
    b2.flags |= 2;
    return c2;
  }
  function g2(b2) {
    a && null === b2.alternate && (b2.flags |= 2);
    return b2;
  }
  function h(a2, b2, c2, d2) {
    if (null === b2 || 6 !== b2.tag) return b2 = Qg(c2, a2.mode, d2), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function k2(a2, b2, c2, d2) {
    var f3 = c2.type;
    if (f3 === ya) return m2(a2, b2, c2.props.children, d2, c2.key);
    if (null !== b2 && (b2.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === Ha && Ng(f3) === b2.type)) return d2 = e(b2, c2.props), d2.ref = Lg(a2, b2, c2), d2.return = a2, d2;
    d2 = Rg(c2.type, c2.key, c2.props, null, a2.mode, d2);
    d2.ref = Lg(a2, b2, c2);
    d2.return = a2;
    return d2;
  }
  function l2(a2, b2, c2, d2) {
    if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation) return b2 = Sg(c2, a2.mode, d2), b2.return = a2, b2;
    b2 = e(b2, c2.children || []);
    b2.return = a2;
    return b2;
  }
  function m2(a2, b2, c2, d2, f3) {
    if (null === b2 || 7 !== b2.tag) return b2 = Tg(c2, a2.mode, d2, f3), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function q2(a2, b2, c2) {
    if ("string" === typeof b2 && "" !== b2 || "number" === typeof b2) return b2 = Qg("" + b2, a2.mode, c2), b2.return = a2, b2;
    if ("object" === typeof b2 && null !== b2) {
      switch (b2.$$typeof) {
        case va:
          return c2 = Rg(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = Lg(a2, null, b2), c2.return = a2, c2;
        case wa:
          return b2 = Sg(b2, a2.mode, c2), b2.return = a2, b2;
        case Ha:
          var d2 = b2._init;
          return q2(a2, d2(b2._payload), c2);
      }
      if (eb(b2) || Ka(b2)) return b2 = Tg(b2, a2.mode, c2, null), b2.return = a2, b2;
      Mg(a2, b2);
    }
    return null;
  }
  function r2(a2, b2, c2, d2) {
    var e2 = null !== b2 ? b2.key : null;
    if ("string" === typeof c2 && "" !== c2 || "number" === typeof c2) return null !== e2 ? null : h(a2, b2, "" + c2, d2);
    if ("object" === typeof c2 && null !== c2) {
      switch (c2.$$typeof) {
        case va:
          return c2.key === e2 ? k2(a2, b2, c2, d2) : null;
        case wa:
          return c2.key === e2 ? l2(a2, b2, c2, d2) : null;
        case Ha:
          return e2 = c2._init, r2(
            a2,
            b2,
            e2(c2._payload),
            d2
          );
      }
      if (eb(c2) || Ka(c2)) return null !== e2 ? null : m2(a2, b2, c2, d2, null);
      Mg(a2, c2);
    }
    return null;
  }
  function y2(a2, b2, c2, d2, e2) {
    if ("string" === typeof d2 && "" !== d2 || "number" === typeof d2) return a2 = a2.get(c2) || null, h(b2, a2, "" + d2, e2);
    if ("object" === typeof d2 && null !== d2) {
      switch (d2.$$typeof) {
        case va:
          return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, k2(b2, a2, d2, e2);
        case wa:
          return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, l2(b2, a2, d2, e2);
        case Ha:
          var f3 = d2._init;
          return y2(a2, b2, c2, f3(d2._payload), e2);
      }
      if (eb(d2) || Ka(d2)) return a2 = a2.get(c2) || null, m2(b2, a2, d2, e2, null);
      Mg(b2, d2);
    }
    return null;
  }
  function n2(e2, g3, h2, k3) {
    for (var l3 = null, m3 = null, u2 = g3, w2 = g3 = 0, x2 = null; null !== u2 && w2 < h2.length; w2++) {
      u2.index > w2 ? (x2 = u2, u2 = null) : x2 = u2.sibling;
      var n3 = r2(e2, u2, h2[w2], k3);
      if (null === n3) {
        null === u2 && (u2 = x2);
        break;
      }
      a && u2 && null === n3.alternate && b(e2, u2);
      g3 = f2(n3, g3, w2);
      null === m3 ? l3 = n3 : m3.sibling = n3;
      m3 = n3;
      u2 = x2;
    }
    if (w2 === h2.length) return c(e2, u2), I && tg(e2, w2), l3;
    if (null === u2) {
      for (; w2 < h2.length; w2++) u2 = q2(e2, h2[w2], k3), null !== u2 && (g3 = f2(u2, g3, w2), null === m3 ? l3 = u2 : m3.sibling = u2, m3 = u2);
      I && tg(e2, w2);
      return l3;
    }
    for (u2 = d(e2, u2); w2 < h2.length; w2++) x2 = y2(u2, e2, w2, h2[w2], k3), null !== x2 && (a && null !== x2.alternate && u2.delete(null === x2.key ? w2 : x2.key), g3 = f2(x2, g3, w2), null === m3 ? l3 = x2 : m3.sibling = x2, m3 = x2);
    a && u2.forEach(function(a2) {
      return b(e2, a2);
    });
    I && tg(e2, w2);
    return l3;
  }
  function t2(e2, g3, h2, k3) {
    var l3 = Ka(h2);
    if ("function" !== typeof l3) throw Error(p$1(150));
    h2 = l3.call(h2);
    if (null == h2) throw Error(p$1(151));
    for (var u2 = l3 = null, m3 = g3, w2 = g3 = 0, x2 = null, n3 = h2.next(); null !== m3 && !n3.done; w2++, n3 = h2.next()) {
      m3.index > w2 ? (x2 = m3, m3 = null) : x2 = m3.sibling;
      var t3 = r2(e2, m3, n3.value, k3);
      if (null === t3) {
        null === m3 && (m3 = x2);
        break;
      }
      a && m3 && null === t3.alternate && b(e2, m3);
      g3 = f2(t3, g3, w2);
      null === u2 ? l3 = t3 : u2.sibling = t3;
      u2 = t3;
      m3 = x2;
    }
    if (n3.done) return c(
      e2,
      m3
    ), I && tg(e2, w2), l3;
    if (null === m3) {
      for (; !n3.done; w2++, n3 = h2.next()) n3 = q2(e2, n3.value, k3), null !== n3 && (g3 = f2(n3, g3, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
      I && tg(e2, w2);
      return l3;
    }
    for (m3 = d(e2, m3); !n3.done; w2++, n3 = h2.next()) n3 = y2(m3, e2, w2, n3.value, k3), null !== n3 && (a && null !== n3.alternate && m3.delete(null === n3.key ? w2 : n3.key), g3 = f2(n3, g3, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
    a && m3.forEach(function(a2) {
      return b(e2, a2);
    });
    I && tg(e2, w2);
    return l3;
  }
  function J2(a2, d2, f3, h2) {
    "object" === typeof f3 && null !== f3 && f3.type === ya && null === f3.key && (f3 = f3.props.children);
    if ("object" === typeof f3 && null !== f3) {
      switch (f3.$$typeof) {
        case va:
          a: {
            for (var k3 = f3.key, l3 = d2; null !== l3; ) {
              if (l3.key === k3) {
                k3 = f3.type;
                if (k3 === ya) {
                  if (7 === l3.tag) {
                    c(a2, l3.sibling);
                    d2 = e(l3, f3.props.children);
                    d2.return = a2;
                    a2 = d2;
                    break a;
                  }
                } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === Ha && Ng(k3) === l3.type) {
                  c(a2, l3.sibling);
                  d2 = e(l3, f3.props);
                  d2.ref = Lg(a2, l3, f3);
                  d2.return = a2;
                  a2 = d2;
                  break a;
                }
                c(a2, l3);
                break;
              } else b(a2, l3);
              l3 = l3.sibling;
            }
            f3.type === ya ? (d2 = Tg(f3.props.children, a2.mode, h2, f3.key), d2.return = a2, a2 = d2) : (h2 = Rg(f3.type, f3.key, f3.props, null, a2.mode, h2), h2.ref = Lg(a2, d2, f3), h2.return = a2, a2 = h2);
          }
          return g2(a2);
        case wa:
          a: {
            for (l3 = f3.key; null !== d2; ) {
              if (d2.key === l3) if (4 === d2.tag && d2.stateNode.containerInfo === f3.containerInfo && d2.stateNode.implementation === f3.implementation) {
                c(a2, d2.sibling);
                d2 = e(d2, f3.children || []);
                d2.return = a2;
                a2 = d2;
                break a;
              } else {
                c(a2, d2);
                break;
              }
              else b(a2, d2);
              d2 = d2.sibling;
            }
            d2 = Sg(f3, a2.mode, h2);
            d2.return = a2;
            a2 = d2;
          }
          return g2(a2);
        case Ha:
          return l3 = f3._init, J2(a2, d2, l3(f3._payload), h2);
      }
      if (eb(f3)) return n2(a2, d2, f3, h2);
      if (Ka(f3)) return t2(a2, d2, f3, h2);
      Mg(a2, f3);
    }
    return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d2 && 6 === d2.tag ? (c(a2, d2.sibling), d2 = e(d2, f3), d2.return = a2, a2 = d2) : (c(a2, d2), d2 = Qg(f3, a2.mode, h2), d2.return = a2, a2 = d2), g2(a2)) : c(a2, d2);
  }
  return J2;
}
var Ug = Og(true), Vg = Og(false), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
  Zg = Yg = Xg = null;
}
function ah(a) {
  var b = Wg.current;
  E(Wg);
  a._currentValue = b;
}
function bh(a, b, c) {
  for (; null !== a; ) {
    var d = a.alternate;
    (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
    if (a === c) break;
    a = a.return;
  }
}
function ch(a, b) {
  Xg = a;
  Zg = Yg = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = true), a.firstContext = null);
}
function eh(a) {
  var b = a._currentValue;
  if (Zg !== a) if (a = { context: a, memoizedValue: b, next: null }, null === Yg) {
    if (null === Xg) throw Error(p$1(308));
    Yg = a;
    Xg.dependencies = { lanes: 0, firstContext: a };
  } else Yg = Yg.next = a;
  return b;
}
var fh = null;
function gh(a) {
  null === fh ? fh = [a] : fh.push(a);
}
function hh(a, b, c, d) {
  var e = b.interleaved;
  null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
  b.interleaved = c;
  return ih(a, d);
}
function ih(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;
  for (a = a.return; null !== a; ) a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
  return 3 === c.tag ? c.stateNode : null;
}
var jh = false;
function kh(a) {
  a.updateQueue = { baseState: a.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function lh(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, firstBaseUpdate: a.firstBaseUpdate, lastBaseUpdate: a.lastBaseUpdate, shared: a.shared, effects: a.effects });
}
function mh(a, b) {
  return { eventTime: a, lane: b, tag: 0, payload: null, callback: null, next: null };
}
function nh(a, b, c) {
  var d = a.updateQueue;
  if (null === d) return null;
  d = d.shared;
  if (0 !== (K & 2)) {
    var e = d.pending;
    null === e ? b.next = b : (b.next = e.next, e.next = b);
    d.pending = b;
    return ih(a, c);
  }
  e = d.interleaved;
  null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
  d.interleaved = b;
  return ih(a, c);
}
function oh(a, b, c) {
  b = b.updateQueue;
  if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Cc(a, c);
  }
}
function ph(a, b) {
  var c = a.updateQueue, d = a.alternate;
  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null, f2 = null;
    c = c.firstBaseUpdate;
    if (null !== c) {
      do {
        var g2 = { eventTime: c.eventTime, lane: c.lane, tag: c.tag, payload: c.payload, callback: c.callback, next: null };
        null === f2 ? e = f2 = g2 : f2 = f2.next = g2;
        c = c.next;
      } while (null !== c);
      null === f2 ? e = f2 = b : f2 = f2.next = b;
    } else e = f2 = b;
    c = { baseState: d.baseState, firstBaseUpdate: e, lastBaseUpdate: f2, shared: d.shared, effects: d.effects };
    a.updateQueue = c;
    return;
  }
  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
  var e = a.updateQueue;
  jh = false;
  var f2 = e.firstBaseUpdate, g2 = e.lastBaseUpdate, h = e.shared.pending;
  if (null !== h) {
    e.shared.pending = null;
    var k2 = h, l2 = k2.next;
    k2.next = null;
    null === g2 ? f2 = l2 : g2.next = l2;
    g2 = k2;
    var m2 = a.alternate;
    null !== m2 && (m2 = m2.updateQueue, h = m2.lastBaseUpdate, h !== g2 && (null === h ? m2.firstBaseUpdate = l2 : h.next = l2, m2.lastBaseUpdate = k2));
  }
  if (null !== f2) {
    var q2 = e.baseState;
    g2 = 0;
    m2 = l2 = k2 = null;
    h = f2;
    do {
      var r2 = h.lane, y2 = h.eventTime;
      if ((d & r2) === r2) {
        null !== m2 && (m2 = m2.next = {
          eventTime: y2,
          lane: 0,
          tag: h.tag,
          payload: h.payload,
          callback: h.callback,
          next: null
        });
        a: {
          var n2 = a, t2 = h;
          r2 = b;
          y2 = c;
          switch (t2.tag) {
            case 1:
              n2 = t2.payload;
              if ("function" === typeof n2) {
                q2 = n2.call(y2, q2, r2);
                break a;
              }
              q2 = n2;
              break a;
            case 3:
              n2.flags = n2.flags & -65537 | 128;
            case 0:
              n2 = t2.payload;
              r2 = "function" === typeof n2 ? n2.call(y2, q2, r2) : n2;
              if (null === r2 || void 0 === r2) break a;
              q2 = A({}, q2, r2);
              break a;
            case 2:
              jh = true;
          }
        }
        null !== h.callback && 0 !== h.lane && (a.flags |= 64, r2 = e.effects, null === r2 ? e.effects = [h] : r2.push(h));
      } else y2 = { eventTime: y2, lane: r2, tag: h.tag, payload: h.payload, callback: h.callback, next: null }, null === m2 ? (l2 = m2 = y2, k2 = q2) : m2 = m2.next = y2, g2 |= r2;
      h = h.next;
      if (null === h) if (h = e.shared.pending, null === h) break;
      else r2 = h, h = r2.next, r2.next = null, e.lastBaseUpdate = r2, e.shared.pending = null;
    } while (1);
    null === m2 && (k2 = q2);
    e.baseState = k2;
    e.firstBaseUpdate = l2;
    e.lastBaseUpdate = m2;
    b = e.shared.interleaved;
    if (null !== b) {
      e = b;
      do
        g2 |= e.lane, e = e.next;
      while (e !== b);
    } else null === f2 && (e.shared.lanes = 0);
    rh |= g2;
    a.lanes = g2;
    a.memoizedState = q2;
  }
}
function sh(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b], e = d.callback;
    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(p$1(191, e));
      e.call(d);
    }
  }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
  if (a === th) throw Error(p$1(174));
  return a;
}
function yh(a, b) {
  G(wh, b);
  G(vh, a);
  G(uh, th);
  a = b.nodeType;
  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
      break;
    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
  }
  E(uh);
  G(uh, b);
}
function zh() {
  E(uh);
  E(vh);
  E(wh);
}
function Ah(a) {
  xh(wh.current);
  var b = xh(uh.current);
  var c = lb(b, a.type);
  b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
  vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
  for (var b = a; null !== b; ) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 128)) return b;
    } else if (null !== b.child) {
      b.child.return = b;
      b = b.child;
      continue;
    }
    if (b === a) break;
    for (; null === b.sibling; ) {
      if (null === b.return || b.return === a) return null;
      b = b.return;
    }
    b.sibling.return = b.return;
    b = b.sibling;
  }
  return null;
}
var Dh = [];
function Eh() {
  for (var a = 0; a < Dh.length; a++) Dh[a]._workInProgressVersionPrimary = null;
  Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = false, Jh = false, Kh = 0, Lh = 0;
function P() {
  throw Error(p$1(321));
}
function Mh(a, b) {
  if (null === b) return false;
  for (var c = 0; c < b.length && c < a.length; c++) if (!He(a[c], b[c])) return false;
  return true;
}
function Nh(a, b, c, d, e, f2) {
  Hh = f2;
  M = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
  a = c(d, e);
  if (Jh) {
    f2 = 0;
    do {
      Jh = false;
      Kh = 0;
      if (25 <= f2) throw Error(p$1(301));
      f2 += 1;
      O = N = null;
      b.updateQueue = null;
      Fh.current = Qh;
      a = c(d, e);
    } while (Jh);
  }
  Fh.current = Rh;
  b = null !== N && null !== N.next;
  Hh = 0;
  O = N = M = null;
  Ih = false;
  if (b) throw Error(p$1(300));
  return a;
}
function Sh() {
  var a = 0 !== Kh;
  Kh = 0;
  return a;
}
function Th() {
  var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  null === O ? M.memoizedState = O = a : O = O.next = a;
  return O;
}
function Uh() {
  if (null === N) {
    var a = M.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = N.next;
  var b = null === O ? M.memoizedState : O.next;
  if (null !== b) O = b, N = a;
  else {
    if (null === a) throw Error(p$1(310));
    N = a;
    a = { memoizedState: N.memoizedState, baseState: N.baseState, baseQueue: N.baseQueue, queue: N.queue, next: null };
    null === O ? M.memoizedState = O = a : O = O.next = a;
  }
  return O;
}
function Vh(a, b) {
  return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
  var b = Uh(), c = b.queue;
  if (null === c) throw Error(p$1(311));
  c.lastRenderedReducer = a;
  var d = N, e = d.baseQueue, f2 = c.pending;
  if (null !== f2) {
    if (null !== e) {
      var g2 = e.next;
      e.next = f2.next;
      f2.next = g2;
    }
    d.baseQueue = e = f2;
    c.pending = null;
  }
  if (null !== e) {
    f2 = e.next;
    d = d.baseState;
    var h = g2 = null, k2 = null, l2 = f2;
    do {
      var m2 = l2.lane;
      if ((Hh & m2) === m2) null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d = l2.hasEagerState ? l2.eagerState : a(d, l2.action);
      else {
        var q2 = {
          lane: m2,
          action: l2.action,
          hasEagerState: l2.hasEagerState,
          eagerState: l2.eagerState,
          next: null
        };
        null === k2 ? (h = k2 = q2, g2 = d) : k2 = k2.next = q2;
        M.lanes |= m2;
        rh |= m2;
      }
      l2 = l2.next;
    } while (null !== l2 && l2 !== f2);
    null === k2 ? g2 = d : k2.next = h;
    He(d, b.memoizedState) || (dh = true);
    b.memoizedState = d;
    b.baseState = g2;
    b.baseQueue = k2;
    c.lastRenderedState = d;
  }
  a = c.interleaved;
  if (null !== a) {
    e = a;
    do
      f2 = e.lane, M.lanes |= f2, rh |= f2, e = e.next;
    while (e !== a);
  } else null === e && (c.lanes = 0);
  return [b.memoizedState, c.dispatch];
}
function Xh(a) {
  var b = Uh(), c = b.queue;
  if (null === c) throw Error(p$1(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch, e = c.pending, f2 = b.memoizedState;
  if (null !== e) {
    c.pending = null;
    var g2 = e = e.next;
    do
      f2 = a(f2, g2.action), g2 = g2.next;
    while (g2 !== e);
    He(f2, b.memoizedState) || (dh = true);
    b.memoizedState = f2;
    null === b.baseQueue && (b.baseState = f2);
    c.lastRenderedState = f2;
  }
  return [f2, d];
}
function Yh() {
}
function Zh(a, b) {
  var c = M, d = Uh(), e = b(), f2 = !He(d.memoizedState, e);
  f2 && (d.memoizedState = e, dh = true);
  d = d.queue;
  $h(ai.bind(null, c, d, a), [a]);
  if (d.getSnapshot !== b || f2 || null !== O && O.memoizedState.tag & 1) {
    c.flags |= 2048;
    bi(9, ci.bind(null, c, d, e, b), void 0, null);
    if (null === Q) throw Error(p$1(349));
    0 !== (Hh & 30) || di(c, b, e);
  }
  return e;
}
function di(a, b, c) {
  a.flags |= 16384;
  a = { getSnapshot: b, value: c };
  b = M.updateQueue;
  null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.stores = [a]) : (c = b.stores, null === c ? b.stores = [a] : c.push(a));
}
function ci(a, b, c, d) {
  b.value = c;
  b.getSnapshot = d;
  ei(b) && fi(a);
}
function ai(a, b, c) {
  return c(function() {
    ei(b) && fi(a);
  });
}
function ei(a) {
  var b = a.getSnapshot;
  a = a.value;
  try {
    var c = b();
    return !He(a, c);
  } catch (d) {
    return true;
  }
}
function fi(a) {
  var b = ih(a, 1);
  null !== b && gi(b, a, 1, -1);
}
function hi(a) {
  var b = Th();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vh, lastRenderedState: a };
  b.queue = a;
  a = a.dispatch = ii.bind(null, M, a);
  return [b.memoizedState, a];
}
function bi(a, b, c, d) {
  a = { tag: a, create: b, destroy: c, deps: d, next: null };
  b = M.updateQueue;
  null === b ? (b = { lastEffect: null, stores: null }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}
function ji() {
  return Uh().memoizedState;
}
function ki(a, b, c, d) {
  var e = Th();
  M.flags |= a;
  e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
  var e = Uh();
  d = void 0 === d ? null : d;
  var f2 = void 0;
  if (null !== N) {
    var g2 = N.memoizedState;
    f2 = g2.destroy;
    if (null !== d && Mh(d, g2.deps)) {
      e.memoizedState = bi(b, c, f2, d);
      return;
    }
  }
  M.flags |= a;
  e.memoizedState = bi(1 | b, c, f2, d);
}
function mi(a, b) {
  return ki(8390656, 8, a, b);
}
function $h(a, b) {
  return li(2048, 8, a, b);
}
function ni(a, b) {
  return li(4, 2, a, b);
}
function oi(a, b) {
  return li(4, 4, a, b);
}
function pi(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function() {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
    b.current = null;
  };
}
function qi(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {
}
function si(a, b) {
  var c = Uh();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Mh(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}
function ti(a, b) {
  var c = Uh();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Mh(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}
function ui(a, b, c) {
  if (0 === (Hh & 21)) return a.baseState && (a.baseState = false, dh = true), a.memoizedState = c;
  He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = true);
  return b;
}
function vi(a, b) {
  var c = C;
  C = 0 !== c && 4 > c ? c : 4;
  a(true);
  var d = Gh.transition;
  Gh.transition = {};
  try {
    a(false), b();
  } finally {
    C = c, Gh.transition = d;
  }
}
function wi() {
  return Uh().memoizedState;
}
function xi(a, b, c) {
  var d = yi(a);
  c = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
  if (zi(a)) Ai(b, c);
  else if (c = hh(a, b, c, d), null !== c) {
    var e = R();
    gi(c, a, d, e);
    Bi(c, b, d);
  }
}
function ii(a, b, c) {
  var d = yi(a), e = { lane: d, action: c, hasEagerState: false, eagerState: null, next: null };
  if (zi(a)) Ai(b, e);
  else {
    var f2 = a.alternate;
    if (0 === a.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b.lastRenderedReducer, null !== f2)) try {
      var g2 = b.lastRenderedState, h = f2(g2, c);
      e.hasEagerState = true;
      e.eagerState = h;
      if (He(h, g2)) {
        var k2 = b.interleaved;
        null === k2 ? (e.next = e, gh(b)) : (e.next = k2.next, k2.next = e);
        b.interleaved = e;
        return;
      }
    } catch (l2) {
    } finally {
    }
    c = hh(a, b, e, d);
    null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
  }
}
function zi(a) {
  var b = a.alternate;
  return a === M || null !== b && b === M;
}
function Ai(a, b) {
  Jh = Ih = true;
  var c = a.pending;
  null === c ? b.next = b : (b.next = c.next, c.next = b);
  a.pending = b;
}
function Bi(a, b, c) {
  if (0 !== (c & 4194240)) {
    var d = b.lanes;
    d &= a.pendingLanes;
    c |= d;
    b.lanes = c;
    Cc(a, c);
  }
}
var Rh = { readContext: eh, useCallback: P, useContext: P, useEffect: P, useImperativeHandle: P, useInsertionEffect: P, useLayoutEffect: P, useMemo: P, useReducer: P, useRef: P, useState: P, useDebugValue: P, useDeferredValue: P, useTransition: P, useMutableSource: P, useSyncExternalStore: P, useId: P, unstable_isNewReconciler: false }, Oh = { readContext: eh, useCallback: function(a, b) {
  Th().memoizedState = [a, void 0 === b ? null : b];
  return a;
}, useContext: eh, useEffect: mi, useImperativeHandle: function(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return ki(
    4194308,
    4,
    pi.bind(null, b, a),
    c
  );
}, useLayoutEffect: function(a, b) {
  return ki(4194308, 4, a, b);
}, useInsertionEffect: function(a, b) {
  return ki(4, 2, a, b);
}, useMemo: function(a, b) {
  var c = Th();
  b = void 0 === b ? null : b;
  a = a();
  c.memoizedState = [a, b];
  return a;
}, useReducer: function(a, b, c) {
  var d = Th();
  b = void 0 !== c ? c(b) : b;
  d.memoizedState = d.baseState = b;
  a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
  d.queue = a;
  a = a.dispatch = xi.bind(null, M, a);
  return [d.memoizedState, a];
}, useRef: function(a) {
  var b = Th();
  a = { current: a };
  return b.memoizedState = a;
}, useState: hi, useDebugValue: ri, useDeferredValue: function(a) {
  return Th().memoizedState = a;
}, useTransition: function() {
  var a = hi(false), b = a[0];
  a = vi.bind(null, a[1]);
  Th().memoizedState = a;
  return [b, a];
}, useMutableSource: function() {
}, useSyncExternalStore: function(a, b, c) {
  var d = M, e = Th();
  if (I) {
    if (void 0 === c) throw Error(p$1(407));
    c = c();
  } else {
    c = b();
    if (null === Q) throw Error(p$1(349));
    0 !== (Hh & 30) || di(d, b, c);
  }
  e.memoizedState = c;
  var f2 = { value: c, getSnapshot: b };
  e.queue = f2;
  mi(ai.bind(
    null,
    d,
    f2,
    a
  ), [a]);
  d.flags |= 2048;
  bi(9, ci.bind(null, d, f2, c, b), void 0, null);
  return c;
}, useId: function() {
  var a = Th(), b = Q.identifierPrefix;
  if (I) {
    var c = sg;
    var d = rg;
    c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
    b = ":" + b + "R" + c;
    c = Kh++;
    0 < c && (b += "H" + c.toString(32));
    b += ":";
  } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
  return a.memoizedState = b;
}, unstable_isNewReconciler: false }, Ph = {
  readContext: eh,
  useCallback: si,
  useContext: eh,
  useEffect: $h,
  useImperativeHandle: qi,
  useInsertionEffect: ni,
  useLayoutEffect: oi,
  useMemo: ti,
  useReducer: Wh,
  useRef: ji,
  useState: function() {
    return Wh(Vh);
  },
  useDebugValue: ri,
  useDeferredValue: function(a) {
    var b = Uh();
    return ui(b, N.memoizedState, a);
  },
  useTransition: function() {
    var a = Wh(Vh)[0], b = Uh().memoizedState;
    return [a, b];
  },
  useMutableSource: Yh,
  useSyncExternalStore: Zh,
  useId: wi,
  unstable_isNewReconciler: false
}, Qh = { readContext: eh, useCallback: si, useContext: eh, useEffect: $h, useImperativeHandle: qi, useInsertionEffect: ni, useLayoutEffect: oi, useMemo: ti, useReducer: Xh, useRef: ji, useState: function() {
  return Xh(Vh);
}, useDebugValue: ri, useDeferredValue: function(a) {
  var b = Uh();
  return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
}, useTransition: function() {
  var a = Xh(Vh)[0], b = Uh().memoizedState;
  return [a, b];
}, useMutableSource: Yh, useSyncExternalStore: Zh, useId: wi, unstable_isNewReconciler: false };
function Ci(a, b) {
  if (a && a.defaultProps) {
    b = A({}, b);
    a = a.defaultProps;
    for (var c in a) void 0 === b[c] && (b[c] = a[c]);
    return b;
  }
  return b;
}
function Di(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : A({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = { isMounted: function(a) {
  return (a = a._reactInternals) ? Vb(a) === a : false;
}, enqueueSetState: function(a, b, c) {
  a = a._reactInternals;
  var d = R(), e = yi(a), f2 = mh(d, e);
  f2.payload = b;
  void 0 !== c && null !== c && (f2.callback = c);
  b = nh(a, f2, e);
  null !== b && (gi(b, a, e, d), oh(b, a, e));
}, enqueueReplaceState: function(a, b, c) {
  a = a._reactInternals;
  var d = R(), e = yi(a), f2 = mh(d, e);
  f2.tag = 1;
  f2.payload = b;
  void 0 !== c && null !== c && (f2.callback = c);
  b = nh(a, f2, e);
  null !== b && (gi(b, a, e, d), oh(b, a, e));
}, enqueueForceUpdate: function(a, b) {
  a = a._reactInternals;
  var c = R(), d = yi(a), e = mh(c, d);
  e.tag = 2;
  void 0 !== b && null !== b && (e.callback = b);
  b = nh(a, e, d);
  null !== b && (gi(b, a, d, c), oh(b, a, d));
} };
function Fi(a, b, c, d, e, f2, g2) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f2, g2) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f2) : true;
}
function Gi(a, b, c) {
  var d = false, e = Vf;
  var f2 = b.contextType;
  "object" === typeof f2 && null !== f2 ? f2 = eh(f2) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f2 = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
  b = new b(c, f2);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Ei;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f2);
  return b;
}
function Hi(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = {};
  kh(a);
  var f2 = b.contextType;
  "object" === typeof f2 && null !== f2 ? e.context = eh(f2) : (f2 = Zf(b) ? Xf : H.current, e.context = Yf(a, f2));
  e.state = a.memoizedState;
  f2 = b.getDerivedStateFromProps;
  "function" === typeof f2 && (Di(a, b, f2, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
  try {
    var c = "", d = b;
    do
      c += Pa(d), d = d.return;
    while (d);
    var e = c;
  } catch (f2) {
    e = "\nError generating stack: " + f2.message + "\n" + f2.stack;
  }
  return { value: a, source: b, stack: e, digest: null };
}
function Ki(a, b, c) {
  return { value: a, source: null, stack: null != c ? c : null, digest: null != b ? b : null };
}
function Li(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function() {
      throw c;
    });
  }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
  c = mh(-1, c);
  c.tag = 3;
  c.payload = { element: null };
  var d = b.value;
  c.callback = function() {
    Oi || (Oi = true, Pi = d);
    Li(a, b);
  };
  return c;
}
function Qi(a, b, c) {
  c = mh(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;
  if ("function" === typeof d) {
    var e = b.value;
    c.payload = function() {
      return d(e);
    };
    c.callback = function() {
      Li(a, b);
    };
  }
  var f2 = a.stateNode;
  null !== f2 && "function" === typeof f2.componentDidCatch && (c.callback = function() {
    Li(a, b);
    "function" !== typeof d && (null === Ri ? Ri = /* @__PURE__ */ new Set([this]) : Ri.add(this));
    var c2 = b.stack;
    this.componentDidCatch(b.value, { componentStack: null !== c2 ? c2 : "" });
  });
  return c;
}
function Si(a, b, c) {
  var d = a.pingCache;
  if (null === d) {
    d = a.pingCache = new Mi();
    var e = /* @__PURE__ */ new Set();
    d.set(b, e);
  } else e = d.get(b), void 0 === e && (e = /* @__PURE__ */ new Set(), d.set(b, e));
  e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
  do {
    var b;
    if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? true : false : true;
    if (b) return a;
    a = a.return;
  } while (null !== a);
  return null;
}
function Vi(a, b, c, d, e) {
  if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
  a.flags |= 65536;
  a.lanes = e;
  return a;
}
var Wi = ua.ReactCurrentOwner, dh = false;
function Xi(a, b, c, d) {
  b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
  c = c.render;
  var f2 = b.ref;
  ch(b, e);
  d = Nh(a, b, c, d, f2, e);
  c = Sh();
  if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
  I && c && vg(b);
  b.flags |= 1;
  Xi(a, b, d, e);
  return b.child;
}
function $i(a, b, c, d, e) {
  if (null === a) {
    var f2 = c.type;
    if ("function" === typeof f2 && !aj(f2) && void 0 === f2.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f2, bj(a, b, f2, d, e);
    a = Rg(c.type, null, d, b, b.mode, e);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  f2 = a.child;
  if (0 === (a.lanes & e)) {
    var g2 = f2.memoizedProps;
    c = c.compare;
    c = null !== c ? c : Ie;
    if (c(g2, d) && a.ref === b.ref) return Zi(a, b, e);
  }
  b.flags |= 1;
  a = Pg(f2, d);
  a.ref = b.ref;
  a.return = b;
  return b.child = a;
}
function bj(a, b, c, d, e) {
  if (null !== a) {
    var f2 = a.memoizedProps;
    if (Ie(f2, d) && a.ref === b.ref) if (dh = false, b.pendingProps = d = f2, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = true);
    else return b.lanes = a.lanes, Zi(a, b, e);
  }
  return cj(a, b, c, d, e);
}
function dj(a, b, c) {
  var d = b.pendingProps, e = d.children, f2 = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode) if (0 === (b.mode & 1)) b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G(ej, fj), fj |= c;
  else {
    if (0 === (c & 1073741824)) return a = null !== f2 ? f2.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = { baseLanes: a, cachePool: null, transitions: null }, b.updateQueue = null, G(ej, fj), fj |= a, null;
    b.memoizedState = { baseLanes: 0, cachePool: null, transitions: null };
    d = null !== f2 ? f2.baseLanes : c;
    G(ej, fj);
    fj |= d;
  }
  else null !== f2 ? (d = f2.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
  Xi(a, b, e, c);
  return b.child;
}
function gj(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
  var f2 = Zf(c) ? Xf : H.current;
  f2 = Yf(b, f2);
  ch(b, e);
  c = Nh(a, b, c, d, f2, e);
  d = Sh();
  if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
  I && d && vg(b);
  b.flags |= 1;
  Xi(a, b, c, e);
  return b.child;
}
function hj(a, b, c, d, e) {
  if (Zf(c)) {
    var f2 = true;
    cg(b);
  } else f2 = false;
  ch(b, e);
  if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = true;
  else if (null === a) {
    var g2 = b.stateNode, h = b.memoizedProps;
    g2.props = h;
    var k2 = g2.context, l2 = c.contextType;
    "object" === typeof l2 && null !== l2 ? l2 = eh(l2) : (l2 = Zf(c) ? Xf : H.current, l2 = Yf(b, l2));
    var m2 = c.getDerivedStateFromProps, q2 = "function" === typeof m2 || "function" === typeof g2.getSnapshotBeforeUpdate;
    q2 || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h !== d || k2 !== l2) && Hi(b, g2, d, l2);
    jh = false;
    var r2 = b.memoizedState;
    g2.state = r2;
    qh(b, d, g2, e);
    k2 = b.memoizedState;
    h !== d || r2 !== k2 || Wf.current || jh ? ("function" === typeof m2 && (Di(b, c, m2, d), k2 = b.memoizedState), (h = jh || Fi(b, c, h, d, r2, k2, l2)) ? (q2 || "function" !== typeof g2.UNSAFE_componentWillMount && "function" !== typeof g2.componentWillMount || ("function" === typeof g2.componentWillMount && g2.componentWillMount(), "function" === typeof g2.UNSAFE_componentWillMount && g2.UNSAFE_componentWillMount()), "function" === typeof g2.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g2.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k2), g2.props = d, g2.state = k2, g2.context = l2, d = h) : ("function" === typeof g2.componentDidMount && (b.flags |= 4194308), d = false);
  } else {
    g2 = b.stateNode;
    lh(a, b);
    h = b.memoizedProps;
    l2 = b.type === b.elementType ? h : Ci(b.type, h);
    g2.props = l2;
    q2 = b.pendingProps;
    r2 = g2.context;
    k2 = c.contextType;
    "object" === typeof k2 && null !== k2 ? k2 = eh(k2) : (k2 = Zf(c) ? Xf : H.current, k2 = Yf(b, k2));
    var y2 = c.getDerivedStateFromProps;
    (m2 = "function" === typeof y2 || "function" === typeof g2.getSnapshotBeforeUpdate) || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h !== q2 || r2 !== k2) && Hi(b, g2, d, k2);
    jh = false;
    r2 = b.memoizedState;
    g2.state = r2;
    qh(b, d, g2, e);
    var n2 = b.memoizedState;
    h !== q2 || r2 !== n2 || Wf.current || jh ? ("function" === typeof y2 && (Di(b, c, y2, d), n2 = b.memoizedState), (l2 = jh || Fi(b, c, l2, d, r2, n2, k2) || false) ? (m2 || "function" !== typeof g2.UNSAFE_componentWillUpdate && "function" !== typeof g2.componentWillUpdate || ("function" === typeof g2.componentWillUpdate && g2.componentWillUpdate(d, n2, k2), "function" === typeof g2.UNSAFE_componentWillUpdate && g2.UNSAFE_componentWillUpdate(d, n2, k2)), "function" === typeof g2.componentDidUpdate && (b.flags |= 4), "function" === typeof g2.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g2.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n2), g2.props = d, g2.state = n2, g2.context = k2, d = l2) : ("function" !== typeof g2.componentDidUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h === a.memoizedProps && r2 === a.memoizedState || (b.flags |= 1024), d = false);
  }
  return jj(a, b, c, d, f2, e);
}
function jj(a, b, c, d, e, f2) {
  gj(a, b);
  var g2 = 0 !== (b.flags & 128);
  if (!d && !g2) return e && dg(b, c, false), Zi(a, b, f2);
  d = b.stateNode;
  Wi.current = b;
  var h = g2 && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g2 ? (b.child = Ug(b, a.child, null, f2), b.child = Ug(b, null, h, f2)) : Xi(a, b, h, f2);
  b.memoizedState = d.state;
  e && dg(b, c, true);
  return b.child;
}
function kj(a) {
  var b = a.stateNode;
  b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, false);
  yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
  Ig();
  Jg(e);
  b.flags |= 256;
  Xi(a, b, c, d);
  return b.child;
}
var mj = { dehydrated: null, treeContext: null, retryLane: 0 };
function nj(a) {
  return { baseLanes: a, cachePool: null, transitions: null };
}
function oj(a, b, c) {
  var d = b.pendingProps, e = L.current, f2 = false, g2 = 0 !== (b.flags & 128), h;
  (h = g2) || (h = null !== a && null === a.memoizedState ? false : 0 !== (e & 2));
  if (h) f2 = true, b.flags &= -129;
  else if (null === a || null !== a.memoizedState) e |= 1;
  G(L, e & 1);
  if (null === a) {
    Eg(b);
    a = b.memoizedState;
    if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
    g2 = d.children;
    a = d.fallback;
    return f2 ? (d = b.mode, f2 = b.child, g2 = { mode: "hidden", children: g2 }, 0 === (d & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = g2) : f2 = pj(g2, d, 0, null), a = Tg(a, d, c, null), f2.return = b, a.return = b, f2.sibling = a, b.child = f2, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g2);
  }
  e = a.memoizedState;
  if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g2, d, h, e, c);
  if (f2) {
    f2 = d.fallback;
    g2 = b.mode;
    e = a.child;
    h = e.sibling;
    var k2 = { mode: "hidden", children: d.children };
    0 === (g2 & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k2, b.deletions = null) : (d = Pg(e, k2), d.subtreeFlags = e.subtreeFlags & 14680064);
    null !== h ? f2 = Pg(h, f2) : (f2 = Tg(f2, g2, c, null), f2.flags |= 2);
    f2.return = b;
    d.return = b;
    d.sibling = f2;
    b.child = d;
    d = f2;
    f2 = b.child;
    g2 = a.child.memoizedState;
    g2 = null === g2 ? nj(c) : { baseLanes: g2.baseLanes | c, cachePool: null, transitions: g2.transitions };
    f2.memoizedState = g2;
    f2.childLanes = a.childLanes & ~c;
    b.memoizedState = mj;
    return d;
  }
  f2 = a.child;
  a = f2.sibling;
  d = Pg(f2, { mode: "visible", children: d.children });
  0 === (b.mode & 1) && (d.lanes = c);
  d.return = b;
  d.sibling = null;
  null !== a && (c = b.deletions, null === c ? (b.deletions = [a], b.flags |= 16) : c.push(a));
  b.child = d;
  b.memoizedState = null;
  return d;
}
function qj(a, b) {
  b = pj({ mode: "visible", children: b }, a.mode, 0, null);
  b.return = a;
  return a.child = b;
}
function sj(a, b, c, d) {
  null !== d && Jg(d);
  Ug(b, a.child, null, c);
  a = qj(b, b.pendingProps.children);
  a.flags |= 2;
  b.memoizedState = null;
  return a;
}
function rj(a, b, c, d, e, f2, g2) {
  if (c) {
    if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p$1(422))), sj(a, b, g2, d);
    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
    f2 = d.fallback;
    e = b.mode;
    d = pj({ mode: "visible", children: d.children }, e, 0, null);
    f2 = Tg(f2, e, g2, null);
    f2.flags |= 2;
    d.return = b;
    f2.return = b;
    d.sibling = f2;
    b.child = d;
    0 !== (b.mode & 1) && Ug(b, a.child, null, g2);
    b.child.memoizedState = nj(g2);
    b.memoizedState = mj;
    return f2;
  }
  if (0 === (b.mode & 1)) return sj(a, b, g2, null);
  if ("$!" === e.data) {
    d = e.nextSibling && e.nextSibling.dataset;
    if (d) var h = d.dgst;
    d = h;
    f2 = Error(p$1(419));
    d = Ki(f2, d, void 0);
    return sj(a, b, g2, d);
  }
  h = 0 !== (g2 & a.childLanes);
  if (dh || h) {
    d = Q;
    if (null !== d) {
      switch (g2 & -g2) {
        case 4:
          e = 2;
          break;
        case 16:
          e = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          e = 32;
          break;
        case 536870912:
          e = 268435456;
          break;
        default:
          e = 0;
      }
      e = 0 !== (e & (d.suspendedLanes | g2)) ? 0 : e;
      0 !== e && e !== f2.retryLane && (f2.retryLane = e, ih(a, e), gi(d, a, e, -1));
    }
    tj();
    d = Ki(Error(p$1(421)));
    return sj(a, b, g2, d);
  }
  if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
  a = f2.treeContext;
  yg = Lf(e.nextSibling);
  xg = b;
  I = true;
  zg = null;
  null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
  b = qj(b, d.children);
  b.flags |= 4096;
  return b;
}
function vj(a, b, c) {
  a.lanes |= b;
  var d = a.alternate;
  null !== d && (d.lanes |= b);
  bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
  var f2 = a.memoizedState;
  null === f2 ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailMode: e } : (f2.isBackwards = b, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d, f2.tail = c, f2.tailMode = e);
}
function xj(a, b, c) {
  var d = b.pendingProps, e = d.revealOrder, f2 = d.tail;
  Xi(a, b, d.children, c);
  d = L.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
  else {
    if (null !== a && 0 !== (a.flags & 128)) a: for (a = b.child; null !== a; ) {
      if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
      else if (19 === a.tag) vj(a, c, b);
      else if (null !== a.child) {
        a.child.return = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;
      for (; null === a.sibling; ) {
        if (null === a.return || a.return === b) break a;
        a = a.return;
      }
      a.sibling.return = a.return;
      a = a.sibling;
    }
    d &= 1;
  }
  G(L, d);
  if (0 === (b.mode & 1)) b.memoizedState = null;
  else switch (e) {
    case "forwards":
      c = b.child;
      for (e = null; null !== c; ) a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      wj(b, false, e, c, f2);
      break;
    case "backwards":
      c = null;
      e = b.child;
      for (b.child = null; null !== e; ) {
        a = e.alternate;
        if (null !== a && null === Ch(a)) {
          b.child = e;
          break;
        }
        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }
      wj(b, true, c, null, f2);
      break;
    case "together":
      wj(b, false, null, null, void 0);
      break;
    default:
      b.memoizedState = null;
  }
  return b.child;
}
function ij(a, b) {
  0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  rh |= b.lanes;
  if (0 === (c & b.childLanes)) return null;
  if (null !== a && b.child !== a.child) throw Error(p$1(153));
  if (null !== b.child) {
    a = b.child;
    c = Pg(a, a.pendingProps);
    b.child = c;
    for (c.return = b; null !== a.sibling; ) a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
    c.sibling = null;
  }
  return b.child;
}
function yj(a, b, c) {
  switch (b.tag) {
    case 3:
      kj(b);
      Ig();
      break;
    case 5:
      Ah(b);
      break;
    case 1:
      Zf(b.type) && cg(b);
      break;
    case 4:
      yh(b, b.stateNode.containerInfo);
      break;
    case 10:
      var d = b.type._context, e = b.memoizedProps.value;
      G(Wg, d._currentValue);
      d._currentValue = e;
      break;
    case 13:
      d = b.memoizedState;
      if (null !== d) {
        if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
        if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
        G(L, L.current & 1);
        a = Zi(a, b, c);
        return null !== a ? a.sibling : null;
      }
      G(L, L.current & 1);
      break;
    case 19:
      d = 0 !== (c & b.childLanes);
      if (0 !== (a.flags & 128)) {
        if (d) return xj(a, b, c);
        b.flags |= 128;
      }
      e = b.memoizedState;
      null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
      G(L, L.current);
      if (d) break;
      else return null;
    case 22:
    case 23:
      return b.lanes = 0, dj(a, b, c);
  }
  return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
  for (var c = b.child; null !== c; ) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
    else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b) break;
    for (; null === c.sibling; ) {
      if (null === c.return || c.return === b) return;
      c = c.return;
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
};
Aj = function() {
};
Bj = function(a, b, c, d) {
  var e = a.memoizedProps;
  if (e !== d) {
    a = b.stateNode;
    xh(uh.current);
    var f2 = null;
    switch (c) {
      case "input":
        e = Ya(a, e);
        d = Ya(a, d);
        f2 = [];
        break;
      case "select":
        e = A({}, e, { value: void 0 });
        d = A({}, d, { value: void 0 });
        f2 = [];
        break;
      case "textarea":
        e = gb(a, e);
        d = gb(a, d);
        f2 = [];
        break;
      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
    }
    ub(c, d);
    var g2;
    c = null;
    for (l2 in e) if (!d.hasOwnProperty(l2) && e.hasOwnProperty(l2) && null != e[l2]) if ("style" === l2) {
      var h = e[l2];
      for (g2 in h) h.hasOwnProperty(g2) && (c || (c = {}), c[g2] = "");
    } else "dangerouslySetInnerHTML" !== l2 && "children" !== l2 && "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && "autoFocus" !== l2 && (ea.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
    for (l2 in d) {
      var k2 = d[l2];
      h = null != e ? e[l2] : void 0;
      if (d.hasOwnProperty(l2) && k2 !== h && (null != k2 || null != h)) if ("style" === l2) if (h) {
        for (g2 in h) !h.hasOwnProperty(g2) || k2 && k2.hasOwnProperty(g2) || (c || (c = {}), c[g2] = "");
        for (g2 in k2) k2.hasOwnProperty(g2) && h[g2] !== k2[g2] && (c || (c = {}), c[g2] = k2[g2]);
      } else c || (f2 || (f2 = []), f2.push(
        l2,
        c
      )), c = k2;
      else "dangerouslySetInnerHTML" === l2 ? (k2 = k2 ? k2.__html : void 0, h = h ? h.__html : void 0, null != k2 && h !== k2 && (f2 = f2 || []).push(l2, k2)) : "children" === l2 ? "string" !== typeof k2 && "number" !== typeof k2 || (f2 = f2 || []).push(l2, "" + k2) : "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && (ea.hasOwnProperty(l2) ? (null != k2 && "onScroll" === l2 && D("scroll", a), f2 || h === k2 || (f2 = [])) : (f2 = f2 || []).push(l2, k2));
    }
    c && (f2 = f2 || []).push("style", c);
    var l2 = f2;
    if (b.updateQueue = l2) b.flags |= 4;
  }
};
Cj = function(a, b, c, d) {
  c !== d && (b.flags |= 4);
};
function Dj(a, b) {
  if (!I) switch (a.tailMode) {
    case "hidden":
      b = a.tail;
      for (var c = null; null !== b; ) null !== b.alternate && (c = b), b = b.sibling;
      null === c ? a.tail = null : c.sibling = null;
      break;
    case "collapsed":
      c = a.tail;
      for (var d = null; null !== c; ) null !== c.alternate && (d = c), c = c.sibling;
      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}
function S(a) {
  var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
  if (b) for (var e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
  else for (e = a.child; null !== e; ) c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
  a.subtreeFlags |= d;
  a.childLanes = c;
  return b;
}
function Ej(a, b, c) {
  var d = b.pendingProps;
  wg(b);
  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return S(b), null;
    case 1:
      return Zf(b.type) && $f(), S(b), null;
    case 3:
      d = b.stateNode;
      zh();
      E(Wf);
      E(H);
      Eh();
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
      Aj(a, b);
      S(b);
      return null;
    case 5:
      Bh(b);
      var e = xh(wh.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
      else {
        if (!d) {
          if (null === b.stateNode) throw Error(p$1(166));
          S(b);
          return null;
        }
        a = xh(uh.current);
        if (Gg(b)) {
          d = b.stateNode;
          c = b.type;
          var f2 = b.memoizedProps;
          d[Of] = b;
          d[Pf] = f2;
          a = 0 !== (b.mode & 1);
          switch (c) {
            case "dialog":
              D("cancel", d);
              D("close", d);
              break;
            case "iframe":
            case "object":
            case "embed":
              D("load", d);
              break;
            case "video":
            case "audio":
              for (e = 0; e < lf.length; e++) D(lf[e], d);
              break;
            case "source":
              D("error", d);
              break;
            case "img":
            case "image":
            case "link":
              D(
                "error",
                d
              );
              D("load", d);
              break;
            case "details":
              D("toggle", d);
              break;
            case "input":
              Za(d, f2);
              D("invalid", d);
              break;
            case "select":
              d._wrapperState = { wasMultiple: !!f2.multiple };
              D("invalid", d);
              break;
            case "textarea":
              hb(d, f2), D("invalid", d);
          }
          ub(c, f2);
          e = null;
          for (var g2 in f2) if (f2.hasOwnProperty(g2)) {
            var h = f2[g2];
            "children" === g2 ? "string" === typeof h ? d.textContent !== h && (true !== f2.suppressHydrationWarning && Af(d.textContent, h, a), e = ["children", h]) : "number" === typeof h && d.textContent !== "" + h && (true !== f2.suppressHydrationWarning && Af(
              d.textContent,
              h,
              a
            ), e = ["children", "" + h]) : ea.hasOwnProperty(g2) && null != h && "onScroll" === g2 && D("scroll", d);
          }
          switch (c) {
            case "input":
              Va(d);
              db(d, f2, true);
              break;
            case "textarea":
              Va(d);
              jb(d);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" === typeof f2.onClick && (d.onclick = Bf);
          }
          d = e;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g2 = 9 === e.nodeType ? e : e.ownerDocument;
          "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
          "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g2.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g2.createElement(c, { is: d.is }) : (a = g2.createElement(c), "select" === c && (g2 = a, d.multiple ? g2.multiple = true : d.size && (g2.size = d.size))) : a = g2.createElementNS(a, c);
          a[Of] = b;
          a[Pf] = d;
          zj(a, b, false, false);
          b.stateNode = a;
          a: {
            g2 = vb(c, d);
            switch (c) {
              case "dialog":
                D("cancel", a);
                D("close", a);
                e = d;
                break;
              case "iframe":
              case "object":
              case "embed":
                D("load", a);
                e = d;
                break;
              case "video":
              case "audio":
                for (e = 0; e < lf.length; e++) D(lf[e], a);
                e = d;
                break;
              case "source":
                D("error", a);
                e = d;
                break;
              case "img":
              case "image":
              case "link":
                D(
                  "error",
                  a
                );
                D("load", a);
                e = d;
                break;
              case "details":
                D("toggle", a);
                e = d;
                break;
              case "input":
                Za(a, d);
                e = Ya(a, d);
                D("invalid", a);
                break;
              case "option":
                e = d;
                break;
              case "select":
                a._wrapperState = { wasMultiple: !!d.multiple };
                e = A({}, d, { value: void 0 });
                D("invalid", a);
                break;
              case "textarea":
                hb(a, d);
                e = gb(a, d);
                D("invalid", a);
                break;
              default:
                e = d;
            }
            ub(c, e);
            h = e;
            for (f2 in h) if (h.hasOwnProperty(f2)) {
              var k2 = h[f2];
              "style" === f2 ? sb(a, k2) : "dangerouslySetInnerHTML" === f2 ? (k2 = k2 ? k2.__html : void 0, null != k2 && nb(a, k2)) : "children" === f2 ? "string" === typeof k2 ? ("textarea" !== c || "" !== k2) && ob(a, k2) : "number" === typeof k2 && ob(a, "" + k2) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (ea.hasOwnProperty(f2) ? null != k2 && "onScroll" === f2 && D("scroll", a) : null != k2 && ta(a, f2, k2, g2));
            }
            switch (c) {
              case "input":
                Va(a);
                db(a, d, false);
                break;
              case "textarea":
                Va(a);
                jb(a);
                break;
              case "option":
                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                break;
              case "select":
                a.multiple = !!d.multiple;
                f2 = d.value;
                null != f2 ? fb(a, !!d.multiple, f2, false) : null != d.defaultValue && fb(
                  a,
                  !!d.multiple,
                  d.defaultValue,
                  true
                );
                break;
              default:
                "function" === typeof e.onClick && (a.onclick = Bf);
            }
            switch (c) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                d = !!d.autoFocus;
                break a;
              case "img":
                d = true;
                break a;
              default:
                d = false;
            }
          }
          d && (b.flags |= 4);
        }
        null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
      }
      S(b);
      return null;
    case 6:
      if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
      else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(p$1(166));
        c = xh(wh.current);
        xh(uh.current);
        if (Gg(b)) {
          d = b.stateNode;
          c = b.memoizedProps;
          d[Of] = b;
          if (f2 = d.nodeValue !== c) {
            if (a = xg, null !== a) switch (a.tag) {
              case 3:
                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                break;
              case 5:
                true !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
            }
          }
          f2 && (b.flags |= 4);
        } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
      }
      S(b);
      return null;
    case 13:
      E(L);
      d = b.memoizedState;
      if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
        if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f2 = false;
        else if (f2 = Gg(b), null !== d && null !== d.dehydrated) {
          if (null === a) {
            if (!f2) throw Error(p$1(318));
            f2 = b.memoizedState;
            f2 = null !== f2 ? f2.dehydrated : null;
            if (!f2) throw Error(p$1(317));
            f2[Of] = b;
          } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
          S(b);
          f2 = false;
        } else null !== zg && (Fj(zg), zg = null), f2 = true;
        if (!f2) return b.flags & 65536 ? b : null;
      }
      if (0 !== (b.flags & 128)) return b.lanes = c, b;
      d = null !== d;
      d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
      null !== b.updateQueue && (b.flags |= 4);
      S(b);
      return null;
    case 4:
      return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
    case 10:
      return ah(b.type._context), S(b), null;
    case 17:
      return Zf(b.type) && $f(), S(b), null;
    case 19:
      E(L);
      f2 = b.memoizedState;
      if (null === f2) return S(b), null;
      d = 0 !== (b.flags & 128);
      g2 = f2.rendering;
      if (null === g2) if (d) Dj(f2, false);
      else {
        if (0 !== T || null !== a && 0 !== (a.flags & 128)) for (a = b.child; null !== a; ) {
          g2 = Ch(a);
          if (null !== g2) {
            b.flags |= 128;
            Dj(f2, false);
            d = g2.updateQueue;
            null !== d && (b.updateQueue = d, b.flags |= 4);
            b.subtreeFlags = 0;
            d = c;
            for (c = b.child; null !== c; ) f2 = c, a = d, f2.flags &= 14680066, g2 = f2.alternate, null === g2 ? (f2.childLanes = 0, f2.lanes = a, f2.child = null, f2.subtreeFlags = 0, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g2.childLanes, f2.lanes = g2.lanes, f2.child = g2.child, f2.subtreeFlags = 0, f2.deletions = null, f2.memoizedProps = g2.memoizedProps, f2.memoizedState = g2.memoizedState, f2.updateQueue = g2.updateQueue, f2.type = g2.type, a = g2.dependencies, f2.dependencies = null === a ? null : { lanes: a.lanes, firstContext: a.firstContext }), c = c.sibling;
            G(L, L.current & 1 | 2);
            return b.child;
          }
          a = a.sibling;
        }
        null !== f2.tail && B() > Gj && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
      }
      else {
        if (!d) if (a = Ch(g2), null !== a) {
          if (b.flags |= 128, d = true, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f2, true), null === f2.tail && "hidden" === f2.tailMode && !g2.alternate && !I) return S(b), null;
        } else 2 * B() - f2.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = true, Dj(f2, false), b.lanes = 4194304);
        f2.isBackwards ? (g2.sibling = b.child, b.child = g2) : (c = f2.last, null !== c ? c.sibling = g2 : b.child = g2, f2.last = g2);
      }
      if (null !== f2.tail) return b = f2.tail, f2.rendering = b, f2.tail = b.sibling, f2.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
      S(b);
      return null;
    case 22:
    case 23:
      return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(p$1(156, b.tag));
}
function Ij(a, b) {
  wg(b);
  switch (b.tag) {
    case 1:
      return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
    case 3:
      return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
    case 5:
      return Bh(b), null;
    case 13:
      E(L);
      a = b.memoizedState;
      if (null !== a && null !== a.dehydrated) {
        if (null === b.alternate) throw Error(p$1(340));
        Ig();
      }
      a = b.flags;
      return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
    case 19:
      return E(L), null;
    case 4:
      return zh(), null;
    case 10:
      return ah(b.type._context), null;
    case 22:
    case 23:
      return Hj(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Jj = false, U = false, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
  var c = a.ref;
  if (null !== c) if ("function" === typeof c) try {
    c(null);
  } catch (d) {
    W(a, b, d);
  }
  else c.current = null;
}
function Mj(a, b, c) {
  try {
    c();
  } catch (d) {
    W(a, b, d);
  }
}
var Nj = false;
function Oj(a, b) {
  Cf = dd;
  a = Me();
  if (Ne(a)) {
    if ("selectionStart" in a) var c = { start: a.selectionStart, end: a.selectionEnd };
    else a: {
      c = (c = a.ownerDocument) && c.defaultView || window;
      var d = c.getSelection && c.getSelection();
      if (d && 0 !== d.rangeCount) {
        c = d.anchorNode;
        var e = d.anchorOffset, f2 = d.focusNode;
        d = d.focusOffset;
        try {
          c.nodeType, f2.nodeType;
        } catch (F2) {
          c = null;
          break a;
        }
        var g2 = 0, h = -1, k2 = -1, l2 = 0, m2 = 0, q2 = a, r2 = null;
        b: for (; ; ) {
          for (var y2; ; ) {
            q2 !== c || 0 !== e && 3 !== q2.nodeType || (h = g2 + e);
            q2 !== f2 || 0 !== d && 3 !== q2.nodeType || (k2 = g2 + d);
            3 === q2.nodeType && (g2 += q2.nodeValue.length);
            if (null === (y2 = q2.firstChild)) break;
            r2 = q2;
            q2 = y2;
          }
          for (; ; ) {
            if (q2 === a) break b;
            r2 === c && ++l2 === e && (h = g2);
            r2 === f2 && ++m2 === d && (k2 = g2);
            if (null !== (y2 = q2.nextSibling)) break;
            q2 = r2;
            r2 = q2.parentNode;
          }
          q2 = y2;
        }
        c = -1 === h || -1 === k2 ? null : { start: h, end: k2 };
      } else c = null;
    }
    c = c || { start: 0, end: 0 };
  } else c = null;
  Df = { focusedElem: a, selectionRange: c };
  dd = false;
  for (V = b; null !== V; ) if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
  else for (; null !== V; ) {
    b = V;
    try {
      var n2 = b.alternate;
      if (0 !== (b.flags & 1024)) switch (b.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (null !== n2) {
            var t2 = n2.memoizedProps, J2 = n2.memoizedState, x2 = b.stateNode, w2 = x2.getSnapshotBeforeUpdate(b.elementType === b.type ? t2 : Ci(b.type, t2), J2);
            x2.__reactInternalSnapshotBeforeUpdate = w2;
          }
          break;
        case 3:
          var u2 = b.stateNode.containerInfo;
          1 === u2.nodeType ? u2.textContent = "" : 9 === u2.nodeType && u2.documentElement && u2.removeChild(u2.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(p$1(163));
      }
    } catch (F2) {
      W(b, b.return, F2);
    }
    a = b.sibling;
    if (null !== a) {
      a.return = b.return;
      V = a;
      break;
    }
    V = b.return;
  }
  n2 = Nj;
  Nj = false;
  return n2;
}
function Pj(a, b, c) {
  var d = b.updateQueue;
  d = null !== d ? d.lastEffect : null;
  if (null !== d) {
    var e = d = d.next;
    do {
      if ((e.tag & a) === a) {
        var f2 = e.destroy;
        e.destroy = void 0;
        void 0 !== f2 && Mj(b, c, f2);
      }
      e = e.next;
    } while (e !== d);
  }
}
function Qj(a, b) {
  b = b.updateQueue;
  b = null !== b ? b.lastEffect : null;
  if (null !== b) {
    var c = b = b.next;
    do {
      if ((c.tag & a) === a) {
        var d = c.create;
        c.destroy = d();
      }
      c = c.next;
    } while (c !== b);
  }
}
function Rj(a) {
  var b = a.ref;
  if (null !== b) {
    var c = a.stateNode;
    switch (a.tag) {
      case 5:
        a = c;
        break;
      default:
        a = c;
    }
    "function" === typeof b ? b(a) : b.current = a;
  }
}
function Sj(a) {
  var b = a.alternate;
  null !== b && (a.alternate = null, Sj(b));
  a.child = null;
  a.deletions = null;
  a.sibling = null;
  5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
  a.stateNode = null;
  a.return = null;
  a.dependencies = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a.stateNode = null;
  a.updateQueue = null;
}
function Tj(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
  a: for (; ; ) {
    for (; null === a.sibling; ) {
      if (null === a.return || Tj(a.return)) return null;
      a = a.return;
    }
    a.sibling.return = a.return;
    for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag; ) {
      if (a.flags & 2) continue a;
      if (null === a.child || 4 === a.tag) continue a;
      else a.child.return = a, a = a.child;
    }
    if (!(a.flags & 2)) return a.stateNode;
  }
}
function Vj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
  else if (4 !== d && (a = a.child, null !== a)) for (Vj(a, b, c), a = a.sibling; null !== a; ) Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
  var d = a.tag;
  if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
  else if (4 !== d && (a = a.child, null !== a)) for (Wj(a, b, c), a = a.sibling; null !== a; ) Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = false;
function Yj(a, b, c) {
  for (c = c.child; null !== c; ) Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
  if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
    lc.onCommitFiberUnmount(kc, c);
  } catch (h) {
  }
  switch (c.tag) {
    case 5:
      U || Lj(c, b);
    case 6:
      var d = X, e = Xj;
      X = null;
      Yj(a, b, c);
      X = d;
      Xj = e;
      null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
      break;
    case 18:
      null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
      break;
    case 4:
      d = X;
      e = Xj;
      X = c.stateNode.containerInfo;
      Xj = true;
      Yj(a, b, c);
      X = d;
      Xj = e;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
        e = d = d.next;
        do {
          var f2 = e, g2 = f2.destroy;
          f2 = f2.tag;
          void 0 !== g2 && (0 !== (f2 & 2) ? Mj(c, b, g2) : 0 !== (f2 & 4) && Mj(c, b, g2));
          e = e.next;
        } while (e !== d);
      }
      Yj(a, b, c);
      break;
    case 1:
      if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
        d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
      } catch (h) {
        W(c, b, h);
      }
      Yj(a, b, c);
      break;
    case 21:
      Yj(a, b, c);
      break;
    case 22:
      c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
      break;
    default:
      Yj(a, b, c);
  }
}
function ak(a) {
  var b = a.updateQueue;
  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Kj());
    b.forEach(function(b2) {
      var d = bk.bind(null, a, b2);
      c.has(b2) || (c.add(b2), b2.then(d, d));
    });
  }
}
function ck(a, b) {
  var c = b.deletions;
  if (null !== c) for (var d = 0; d < c.length; d++) {
    var e = c[d];
    try {
      var f2 = a, g2 = b, h = g2;
      a: for (; null !== h; ) {
        switch (h.tag) {
          case 5:
            X = h.stateNode;
            Xj = false;
            break a;
          case 3:
            X = h.stateNode.containerInfo;
            Xj = true;
            break a;
          case 4:
            X = h.stateNode.containerInfo;
            Xj = true;
            break a;
        }
        h = h.return;
      }
      if (null === X) throw Error(p$1(160));
      Zj(f2, g2, e);
      X = null;
      Xj = false;
      var k2 = e.alternate;
      null !== k2 && (k2.return = null);
      e.return = null;
    } catch (l2) {
      W(e, b, l2);
    }
  }
  if (b.subtreeFlags & 12854) for (b = b.child; null !== b; ) dk(b, a), b = b.sibling;
}
function dk(a, b) {
  var c = a.alternate, d = a.flags;
  switch (a.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      ck(b, a);
      ek(a);
      if (d & 4) {
        try {
          Pj(3, a, a.return), Qj(3, a);
        } catch (t2) {
          W(a, a.return, t2);
        }
        try {
          Pj(5, a, a.return);
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      break;
    case 1:
      ck(b, a);
      ek(a);
      d & 512 && null !== c && Lj(c, c.return);
      break;
    case 5:
      ck(b, a);
      ek(a);
      d & 512 && null !== c && Lj(c, c.return);
      if (a.flags & 32) {
        var e = a.stateNode;
        try {
          ob(e, "");
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      if (d & 4 && (e = a.stateNode, null != e)) {
        var f2 = a.memoizedProps, g2 = null !== c ? c.memoizedProps : f2, h = a.type, k2 = a.updateQueue;
        a.updateQueue = null;
        if (null !== k2) try {
          "input" === h && "radio" === f2.type && null != f2.name && ab(e, f2);
          vb(h, g2);
          var l2 = vb(h, f2);
          for (g2 = 0; g2 < k2.length; g2 += 2) {
            var m2 = k2[g2], q2 = k2[g2 + 1];
            "style" === m2 ? sb(e, q2) : "dangerouslySetInnerHTML" === m2 ? nb(e, q2) : "children" === m2 ? ob(e, q2) : ta(e, m2, q2, l2);
          }
          switch (h) {
            case "input":
              bb(e, f2);
              break;
            case "textarea":
              ib(e, f2);
              break;
            case "select":
              var r2 = e._wrapperState.wasMultiple;
              e._wrapperState.wasMultiple = !!f2.multiple;
              var y2 = f2.value;
              null != y2 ? fb(e, !!f2.multiple, y2, false) : r2 !== !!f2.multiple && (null != f2.defaultValue ? fb(
                e,
                !!f2.multiple,
                f2.defaultValue,
                true
              ) : fb(e, !!f2.multiple, f2.multiple ? [] : "", false));
          }
          e[Pf] = f2;
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      break;
    case 6:
      ck(b, a);
      ek(a);
      if (d & 4) {
        if (null === a.stateNode) throw Error(p$1(162));
        e = a.stateNode;
        f2 = a.memoizedProps;
        try {
          e.nodeValue = f2;
        } catch (t2) {
          W(a, a.return, t2);
        }
      }
      break;
    case 3:
      ck(b, a);
      ek(a);
      if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
        bd(b.containerInfo);
      } catch (t2) {
        W(a, a.return, t2);
      }
      break;
    case 4:
      ck(b, a);
      ek(a);
      break;
    case 13:
      ck(b, a);
      ek(a);
      e = a.child;
      e.flags & 8192 && (f2 = null !== e.memoizedState, e.stateNode.isHidden = f2, !f2 || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
      d & 4 && ak(a);
      break;
    case 22:
      m2 = null !== c && null !== c.memoizedState;
      a.mode & 1 ? (U = (l2 = U) || m2, ck(b, a), U = l2) : ck(b, a);
      ek(a);
      if (d & 8192) {
        l2 = null !== a.memoizedState;
        if ((a.stateNode.isHidden = l2) && !m2 && 0 !== (a.mode & 1)) for (V = a, m2 = a.child; null !== m2; ) {
          for (q2 = V = m2; null !== V; ) {
            r2 = V;
            y2 = r2.child;
            switch (r2.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Pj(4, r2, r2.return);
                break;
              case 1:
                Lj(r2, r2.return);
                var n2 = r2.stateNode;
                if ("function" === typeof n2.componentWillUnmount) {
                  d = r2;
                  c = r2.return;
                  try {
                    b = d, n2.props = b.memoizedProps, n2.state = b.memoizedState, n2.componentWillUnmount();
                  } catch (t2) {
                    W(d, c, t2);
                  }
                }
                break;
              case 5:
                Lj(r2, r2.return);
                break;
              case 22:
                if (null !== r2.memoizedState) {
                  gk(q2);
                  continue;
                }
            }
            null !== y2 ? (y2.return = r2, V = y2) : gk(q2);
          }
          m2 = m2.sibling;
        }
        a: for (m2 = null, q2 = a; ; ) {
          if (5 === q2.tag) {
            if (null === m2) {
              m2 = q2;
              try {
                e = q2.stateNode, l2 ? (f2 = e.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (h = q2.stateNode, k2 = q2.memoizedProps.style, g2 = void 0 !== k2 && null !== k2 && k2.hasOwnProperty("display") ? k2.display : null, h.style.display = rb("display", g2));
              } catch (t2) {
                W(a, a.return, t2);
              }
            }
          } else if (6 === q2.tag) {
            if (null === m2) try {
              q2.stateNode.nodeValue = l2 ? "" : q2.memoizedProps;
            } catch (t2) {
              W(a, a.return, t2);
            }
          } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === a) && null !== q2.child) {
            q2.child.return = q2;
            q2 = q2.child;
            continue;
          }
          if (q2 === a) break a;
          for (; null === q2.sibling; ) {
            if (null === q2.return || q2.return === a) break a;
            m2 === q2 && (m2 = null);
            q2 = q2.return;
          }
          m2 === q2 && (m2 = null);
          q2.sibling.return = q2.return;
          q2 = q2.sibling;
        }
      }
      break;
    case 19:
      ck(b, a);
      ek(a);
      d & 4 && ak(a);
      break;
    case 21:
      break;
    default:
      ck(
        b,
        a
      ), ek(a);
  }
}
function ek(a) {
  var b = a.flags;
  if (b & 2) {
    try {
      a: {
        for (var c = a.return; null !== c; ) {
          if (Tj(c)) {
            var d = c;
            break a;
          }
          c = c.return;
        }
        throw Error(p$1(160));
      }
      switch (d.tag) {
        case 5:
          var e = d.stateNode;
          d.flags & 32 && (ob(e, ""), d.flags &= -33);
          var f2 = Uj(a);
          Wj(a, f2, e);
          break;
        case 3:
        case 4:
          var g2 = d.stateNode.containerInfo, h = Uj(a);
          Vj(a, h, g2);
          break;
        default:
          throw Error(p$1(161));
      }
    } catch (k2) {
      W(a, a.return, k2);
    }
    a.flags &= -3;
  }
  b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
  V = a;
  ik(a);
}
function ik(a, b, c) {
  for (var d = 0 !== (a.mode & 1); null !== V; ) {
    var e = V, f2 = e.child;
    if (22 === e.tag && d) {
      var g2 = null !== e.memoizedState || Jj;
      if (!g2) {
        var h = e.alternate, k2 = null !== h && null !== h.memoizedState || U;
        h = Jj;
        var l2 = U;
        Jj = g2;
        if ((U = k2) && !l2) for (V = e; null !== V; ) g2 = V, k2 = g2.child, 22 === g2.tag && null !== g2.memoizedState ? jk(e) : null !== k2 ? (k2.return = g2, V = k2) : jk(e);
        for (; null !== f2; ) V = f2, ik(f2), f2 = f2.sibling;
        V = e;
        Jj = h;
        U = l2;
      }
      kk(a);
    } else 0 !== (e.subtreeFlags & 8772) && null !== f2 ? (f2.return = e, V = f2) : kk(a);
  }
}
function kk(a) {
  for (; null !== V; ) {
    var b = V;
    if (0 !== (b.flags & 8772)) {
      var c = b.alternate;
      try {
        if (0 !== (b.flags & 8772)) switch (b.tag) {
          case 0:
          case 11:
          case 15:
            U || Qj(5, b);
            break;
          case 1:
            var d = b.stateNode;
            if (b.flags & 4 && !U) if (null === c) d.componentDidMount();
            else {
              var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
              d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
            }
            var f2 = b.updateQueue;
            null !== f2 && sh(b, f2, d);
            break;
          case 3:
            var g2 = b.updateQueue;
            if (null !== g2) {
              c = null;
              if (null !== b.child) switch (b.child.tag) {
                case 5:
                  c = b.child.stateNode;
                  break;
                case 1:
                  c = b.child.stateNode;
              }
              sh(b, g2, c);
            }
            break;
          case 5:
            var h = b.stateNode;
            if (null === c && b.flags & 4) {
              c = h;
              var k2 = b.memoizedProps;
              switch (b.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  k2.autoFocus && c.focus();
                  break;
                case "img":
                  k2.src && (c.src = k2.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (null === b.memoizedState) {
              var l2 = b.alternate;
              if (null !== l2) {
                var m2 = l2.memoizedState;
                if (null !== m2) {
                  var q2 = m2.dehydrated;
                  null !== q2 && bd(q2);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(p$1(163));
        }
        U || b.flags & 512 && Rj(b);
      } catch (r2) {
        W(b, b.return, r2);
      }
    }
    if (b === a) {
      V = null;
      break;
    }
    c = b.sibling;
    if (null !== c) {
      c.return = b.return;
      V = c;
      break;
    }
    V = b.return;
  }
}
function gk(a) {
  for (; null !== V; ) {
    var b = V;
    if (b === a) {
      V = null;
      break;
    }
    var c = b.sibling;
    if (null !== c) {
      c.return = b.return;
      V = c;
      break;
    }
    V = b.return;
  }
}
function jk(a) {
  for (; null !== V; ) {
    var b = V;
    try {
      switch (b.tag) {
        case 0:
        case 11:
        case 15:
          var c = b.return;
          try {
            Qj(4, b);
          } catch (k2) {
            W(b, c, k2);
          }
          break;
        case 1:
          var d = b.stateNode;
          if ("function" === typeof d.componentDidMount) {
            var e = b.return;
            try {
              d.componentDidMount();
            } catch (k2) {
              W(b, e, k2);
            }
          }
          var f2 = b.return;
          try {
            Rj(b);
          } catch (k2) {
            W(b, f2, k2);
          }
          break;
        case 5:
          var g2 = b.return;
          try {
            Rj(b);
          } catch (k2) {
            W(b, g2, k2);
          }
      }
    } catch (k2) {
      W(b, b.return, k2);
    }
    if (b === a) {
      V = null;
      break;
    }
    var h = b.sibling;
    if (null !== h) {
      h.return = b.return;
      V = h;
      break;
    }
    V = b.return;
  }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = false, Pi = null, Ri = null, vk = false, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
  return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
  if (0 === (a.mode & 1)) return 1;
  if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
  if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
  a = C;
  if (0 !== a) return a;
  a = window.event;
  a = void 0 === a ? 16 : jd(a.type);
  return a;
}
function gi(a, b, c, d) {
  if (50 < yk) throw yk = 0, zk = null, Error(p$1(185));
  Ac(a, c, d);
  if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
  var c = a.callbackNode;
  wc(a, b);
  var d = uc(a, a === Q ? Z : 0);
  if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
  else if (b = d & -d, a.callbackPriority !== b) {
    null != c && bc(c);
    if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
      0 === (K & 6) && jg();
    }), c = null;
    else {
      switch (Dc(d)) {
        case 1:
          c = fc;
          break;
        case 4:
          c = gc;
          break;
        case 16:
          c = hc;
          break;
        case 536870912:
          c = jc;
          break;
        default:
          c = hc;
      }
      c = Fk(c, Gk.bind(null, a));
    }
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}
function Gk(a, b) {
  Ak = -1;
  Bk = 0;
  if (0 !== (K & 6)) throw Error(p$1(327));
  var c = a.callbackNode;
  if (Hk() && a.callbackNode !== c) return null;
  var d = uc(a, a === Q ? Z : 0);
  if (0 === d) return null;
  if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
  else {
    b = d;
    var e = K;
    K |= 2;
    var f2 = Jk();
    if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
    do
      try {
        Lk();
        break;
      } catch (h) {
        Mk(a, h);
      }
    while (1);
    $g();
    mk.current = f2;
    K = e;
    null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
  }
  if (0 !== b) {
    2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
    if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
    if (6 === b) Ck(a, d);
    else {
      e = a.current.alternate;
      if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f2 = xc(a), 0 !== f2 && (d = f2, b = Nk(a, f2))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
      a.finishedWork = e;
      a.finishedLanes = d;
      switch (b) {
        case 0:
        case 1:
          throw Error(p$1(345));
        case 2:
          Pk(a, tk, uk);
          break;
        case 3:
          Ck(a, d);
          if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
            if (0 !== uc(a, 0)) break;
            e = a.suspendedLanes;
            if ((e & d) !== d) {
              R();
              a.pingedLanes |= a.suspendedLanes & e;
              break;
            }
            a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
            break;
          }
          Pk(a, tk, uk);
          break;
        case 4:
          Ck(a, d);
          if ((d & 4194240) === d) break;
          b = a.eventTimes;
          for (e = -1; 0 < d; ) {
            var g2 = 31 - oc(d);
            f2 = 1 << g2;
            g2 = b[g2];
            g2 > e && (e = g2);
            d &= ~f2;
          }
          d = e;
          d = B() - d;
          d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
          if (10 < d) {
            a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
            break;
          }
          Pk(a, tk, uk);
          break;
        case 5:
          Pk(a, tk, uk);
          break;
        default:
          throw Error(p$1(329));
      }
    }
  }
  Dk(a, B());
  return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
  var c = sk;
  a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
  a = Ik(a, b);
  2 !== a && (b = tk, tk = c, null !== b && Fj(b));
  return a;
}
function Fj(a) {
  null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
  for (var b = a; ; ) {
    if (b.flags & 16384) {
      var c = b.updateQueue;
      if (null !== c && (c = c.stores, null !== c)) for (var d = 0; d < c.length; d++) {
        var e = c[d], f2 = e.getSnapshot;
        e = e.value;
        try {
          if (!He(f2(), e)) return false;
        } catch (g2) {
          return false;
        }
      }
    }
    c = b.child;
    if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
    else {
      if (b === a) break;
      for (; null === b.sibling; ) {
        if (null === b.return || b.return === a) return true;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
  }
  return true;
}
function Ck(a, b) {
  b &= ~rk;
  b &= ~qk;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;
  for (a = a.expirationTimes; 0 < b; ) {
    var c = 31 - oc(b), d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}
function Ek(a) {
  if (0 !== (K & 6)) throw Error(p$1(327));
  Hk();
  var b = uc(a, 0);
  if (0 === (b & 1)) return Dk(a, B()), null;
  var c = Ik(a, b);
  if (0 !== a.tag && 2 === c) {
    var d = xc(a);
    0 !== d && (b = d, c = Nk(a, d));
  }
  if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
  if (6 === c) throw Error(p$1(345));
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Pk(a, tk, uk);
  Dk(a, B());
  return null;
}
function Qk(a, b) {
  var c = K;
  K |= 1;
  try {
    return a(b);
  } finally {
    K = c, 0 === K && (Gj = B() + 500, fg && jg());
  }
}
function Rk(a) {
  null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
  var b = K;
  K |= 1;
  var c = ok.transition, d = C;
  try {
    if (ok.transition = null, C = 1, a) return a();
  } finally {
    C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
  }
}
function Hj() {
  fj = ej.current;
  E(ej);
}
function Kk(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, Gf(c));
  if (null !== Y) for (c = Y.return; null !== c; ) {
    var d = c;
    wg(d);
    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && $f();
        break;
      case 3:
        zh();
        E(Wf);
        E(H);
        Eh();
        break;
      case 5:
        Bh(d);
        break;
      case 4:
        zh();
        break;
      case 13:
        E(L);
        break;
      case 19:
        E(L);
        break;
      case 10:
        ah(d.type._context);
        break;
      case 22:
      case 23:
        Hj();
    }
    c = c.return;
  }
  Q = a;
  Y = a = Pg(a.current, null);
  Z = fj = b;
  T = 0;
  pk = null;
  rk = qk = rh = 0;
  tk = sk = null;
  if (null !== fh) {
    for (b = 0; b < fh.length; b++) if (c = fh[b], d = c.interleaved, null !== d) {
      c.interleaved = null;
      var e = d.next, f2 = c.pending;
      if (null !== f2) {
        var g2 = f2.next;
        f2.next = e;
        d.next = g2;
      }
      c.pending = d;
    }
    fh = null;
  }
  return a;
}
function Mk(a, b) {
  do {
    var c = Y;
    try {
      $g();
      Fh.current = Rh;
      if (Ih) {
        for (var d = M.memoizedState; null !== d; ) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }
        Ih = false;
      }
      Hh = 0;
      O = N = M = null;
      Jh = false;
      Kh = 0;
      nk.current = null;
      if (null === c || null === c.return) {
        T = 1;
        pk = b;
        Y = null;
        break;
      }
      a: {
        var f2 = a, g2 = c.return, h = c, k2 = b;
        b = Z;
        h.flags |= 32768;
        if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
          var l2 = k2, m2 = h, q2 = m2.tag;
          if (0 === (m2.mode & 1) && (0 === q2 || 11 === q2 || 15 === q2)) {
            var r2 = m2.alternate;
            r2 ? (m2.updateQueue = r2.updateQueue, m2.memoizedState = r2.memoizedState, m2.lanes = r2.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
          }
          var y2 = Ui(g2);
          if (null !== y2) {
            y2.flags &= -257;
            Vi(y2, g2, h, f2, b);
            y2.mode & 1 && Si(f2, l2, b);
            b = y2;
            k2 = l2;
            var n2 = b.updateQueue;
            if (null === n2) {
              var t2 = /* @__PURE__ */ new Set();
              t2.add(k2);
              b.updateQueue = t2;
            } else n2.add(k2);
            break a;
          } else {
            if (0 === (b & 1)) {
              Si(f2, l2, b);
              tj();
              break a;
            }
            k2 = Error(p$1(426));
          }
        } else if (I && h.mode & 1) {
          var J2 = Ui(g2);
          if (null !== J2) {
            0 === (J2.flags & 65536) && (J2.flags |= 256);
            Vi(J2, g2, h, f2, b);
            Jg(Ji(k2, h));
            break a;
          }
        }
        f2 = k2 = Ji(k2, h);
        4 !== T && (T = 2);
        null === sk ? sk = [f2] : sk.push(f2);
        f2 = g2;
        do {
          switch (f2.tag) {
            case 3:
              f2.flags |= 65536;
              b &= -b;
              f2.lanes |= b;
              var x2 = Ni(f2, k2, b);
              ph(f2, x2);
              break a;
            case 1:
              h = k2;
              var w2 = f2.type, u2 = f2.stateNode;
              if (0 === (f2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ri || !Ri.has(u2)))) {
                f2.flags |= 65536;
                b &= -b;
                f2.lanes |= b;
                var F2 = Qi(f2, h, b);
                ph(f2, F2);
                break a;
              }
          }
          f2 = f2.return;
        } while (null !== f2);
      }
      Sk(c);
    } catch (na) {
      b = na;
      Y === c && null !== c && (Y = c = c.return);
      continue;
    }
    break;
  } while (1);
}
function Jk() {
  var a = mk.current;
  mk.current = Rh;
  return null === a ? Rh : a;
}
function tj() {
  if (0 === T || 3 === T || 2 === T) T = 4;
  null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
  var c = K;
  K |= 2;
  var d = Jk();
  if (Q !== a || Z !== b) uk = null, Kk(a, b);
  do
    try {
      Tk();
      break;
    } catch (e) {
      Mk(a, e);
    }
  while (1);
  $g();
  K = c;
  mk.current = d;
  if (null !== Y) throw Error(p$1(261));
  Q = null;
  Z = 0;
  return T;
}
function Tk() {
  for (; null !== Y; ) Uk(Y);
}
function Lk() {
  for (; null !== Y && !cc(); ) Uk(Y);
}
function Uk(a) {
  var b = Vk(a.alternate, a, fj);
  a.memoizedProps = a.pendingProps;
  null === b ? Sk(a) : Y = b;
  nk.current = null;
}
function Sk(a) {
  var b = a;
  do {
    var c = b.alternate;
    a = b.return;
    if (0 === (b.flags & 32768)) {
      if (c = Ej(c, b, fj), null !== c) {
        Y = c;
        return;
      }
    } else {
      c = Ij(c, b);
      if (null !== c) {
        c.flags &= 32767;
        Y = c;
        return;
      }
      if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
      else {
        T = 6;
        Y = null;
        return;
      }
    }
    b = b.sibling;
    if (null !== b) {
      Y = b;
      return;
    }
    Y = b = a;
  } while (null !== b);
  0 === T && (T = 5);
}
function Pk(a, b, c) {
  var d = C, e = ok.transition;
  try {
    ok.transition = null, C = 1, Wk(a, b, c, d);
  } finally {
    ok.transition = e, C = d;
  }
  return null;
}
function Wk(a, b, c, d) {
  do
    Hk();
  while (null !== wk);
  if (0 !== (K & 6)) throw Error(p$1(327));
  c = a.finishedWork;
  var e = a.finishedLanes;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(p$1(177));
  a.callbackNode = null;
  a.callbackPriority = 0;
  var f2 = c.lanes | c.childLanes;
  Bc(a, f2);
  a === Q && (Y = Q = null, Z = 0);
  0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = true, Fk(hc, function() {
    Hk();
    return null;
  }));
  f2 = 0 !== (c.flags & 15990);
  if (0 !== (c.subtreeFlags & 15990) || f2) {
    f2 = ok.transition;
    ok.transition = null;
    var g2 = C;
    C = 1;
    var h = K;
    K |= 4;
    nk.current = null;
    Oj(a, c);
    dk(c, a);
    Oe(Df);
    dd = !!Cf;
    Df = Cf = null;
    a.current = c;
    hk(c);
    dc();
    K = h;
    C = g2;
    ok.transition = f2;
  } else a.current = c;
  vk && (vk = false, wk = a, xk = e);
  f2 = a.pendingLanes;
  0 === f2 && (Ri = null);
  mc(c.stateNode);
  Dk(a, B());
  if (null !== b) for (d = a.onRecoverableError, c = 0; c < b.length; c++) e = b[c], d(e.value, { componentStack: e.stack, digest: e.digest });
  if (Oi) throw Oi = false, a = Pi, Pi = null, a;
  0 !== (xk & 1) && 0 !== a.tag && Hk();
  f2 = a.pendingLanes;
  0 !== (f2 & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
  jg();
  return null;
}
function Hk() {
  if (null !== wk) {
    var a = Dc(xk), b = ok.transition, c = C;
    try {
      ok.transition = null;
      C = 16 > a ? 16 : a;
      if (null === wk) var d = false;
      else {
        a = wk;
        wk = null;
        xk = 0;
        if (0 !== (K & 6)) throw Error(p$1(331));
        var e = K;
        K |= 4;
        for (V = a.current; null !== V; ) {
          var f2 = V, g2 = f2.child;
          if (0 !== (V.flags & 16)) {
            var h = f2.deletions;
            if (null !== h) {
              for (var k2 = 0; k2 < h.length; k2++) {
                var l2 = h[k2];
                for (V = l2; null !== V; ) {
                  var m2 = V;
                  switch (m2.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Pj(8, m2, f2);
                  }
                  var q2 = m2.child;
                  if (null !== q2) q2.return = m2, V = q2;
                  else for (; null !== V; ) {
                    m2 = V;
                    var r2 = m2.sibling, y2 = m2.return;
                    Sj(m2);
                    if (m2 === l2) {
                      V = null;
                      break;
                    }
                    if (null !== r2) {
                      r2.return = y2;
                      V = r2;
                      break;
                    }
                    V = y2;
                  }
                }
              }
              var n2 = f2.alternate;
              if (null !== n2) {
                var t2 = n2.child;
                if (null !== t2) {
                  n2.child = null;
                  do {
                    var J2 = t2.sibling;
                    t2.sibling = null;
                    t2 = J2;
                  } while (null !== t2);
                }
              }
              V = f2;
            }
          }
          if (0 !== (f2.subtreeFlags & 2064) && null !== g2) g2.return = f2, V = g2;
          else b: for (; null !== V; ) {
            f2 = V;
            if (0 !== (f2.flags & 2048)) switch (f2.tag) {
              case 0:
              case 11:
              case 15:
                Pj(9, f2, f2.return);
            }
            var x2 = f2.sibling;
            if (null !== x2) {
              x2.return = f2.return;
              V = x2;
              break b;
            }
            V = f2.return;
          }
        }
        var w2 = a.current;
        for (V = w2; null !== V; ) {
          g2 = V;
          var u2 = g2.child;
          if (0 !== (g2.subtreeFlags & 2064) && null !== u2) u2.return = g2, V = u2;
          else b: for (g2 = w2; null !== V; ) {
            h = V;
            if (0 !== (h.flags & 2048)) try {
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  Qj(9, h);
              }
            } catch (na) {
              W(h, h.return, na);
            }
            if (h === g2) {
              V = null;
              break b;
            }
            var F2 = h.sibling;
            if (null !== F2) {
              F2.return = h.return;
              V = F2;
              break b;
            }
            V = h.return;
          }
        }
        K = e;
        jg();
        if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
          lc.onPostCommitFiberRoot(kc, a);
        } catch (na) {
        }
        d = true;
      }
      return d;
    } finally {
      C = c, ok.transition = b;
    }
  }
  return false;
}
function Xk(a, b, c) {
  b = Ji(c, b);
  b = Ni(a, b, 1);
  a = nh(a, b, 1);
  b = R();
  null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
  if (3 === a.tag) Xk(a, a, c);
  else for (; null !== b; ) {
    if (3 === b.tag) {
      Xk(b, a, c);
      break;
    } else if (1 === b.tag) {
      var d = b.stateNode;
      if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
        a = Ji(c, a);
        a = Qi(b, a, 1);
        b = nh(b, a, 1);
        a = R();
        null !== b && (Ac(b, 1, a), Dk(b, a));
        break;
      }
    }
    b = b.return;
  }
}
function Ti(a, b, c) {
  var d = a.pingCache;
  null !== d && d.delete(b);
  b = R();
  a.pingedLanes |= a.suspendedLanes & c;
  Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
  Dk(a, b);
}
function Yk(a, b) {
  0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
  var c = R();
  a = ih(a, b);
  null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
  var b = a.memoizedState, c = 0;
  null !== b && (c = b.retryLane);
  Yk(a, c);
}
function bk(a, b) {
  var c = 0;
  switch (a.tag) {
    case 13:
      var d = a.stateNode;
      var e = a.memoizedState;
      null !== e && (c = e.retryLane);
      break;
    case 19:
      d = a.stateNode;
      break;
    default:
      throw Error(p$1(314));
  }
  null !== d && d.delete(b);
  Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
  if (null !== a) if (a.memoizedProps !== b.pendingProps || Wf.current) dh = true;
  else {
    if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = false, yj(a, b, c);
    dh = 0 !== (a.flags & 131072) ? true : false;
  }
  else dh = false, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
  b.lanes = 0;
  switch (b.tag) {
    case 2:
      var d = b.type;
      ij(a, b);
      a = b.pendingProps;
      var e = Yf(b, H.current);
      ch(b, c);
      e = Nh(null, b, d, a, e, c);
      var f2 = Sh();
      b.flags |= 1;
      "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f2 = true, cg(b)) : f2 = false, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, true, f2, c)) : (b.tag = 0, I && f2 && vg(b), Xi(null, b, e, c), b = b.child);
      return b;
    case 16:
      d = b.elementType;
      a: {
        ij(a, b);
        a = b.pendingProps;
        e = d._init;
        d = e(d._payload);
        b.type = d;
        e = b.tag = Zk(d);
        a = Ci(d, a);
        switch (e) {
          case 0:
            b = cj(null, b, d, a, c);
            break a;
          case 1:
            b = hj(null, b, d, a, c);
            break a;
          case 11:
            b = Yi(null, b, d, a, c);
            break a;
          case 14:
            b = $i(null, b, d, Ci(d.type, a), c);
            break a;
        }
        throw Error(p$1(
          306,
          d,
          ""
        ));
      }
      return b;
    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
    case 3:
      a: {
        kj(b);
        if (null === a) throw Error(p$1(387));
        d = b.pendingProps;
        f2 = b.memoizedState;
        e = f2.element;
        lh(a, b);
        qh(b, d, null, c);
        var g2 = b.memoizedState;
        d = g2.element;
        if (f2.isDehydrated) if (f2 = { element: d, isDehydrated: false, cache: g2.cache, pendingSuspenseBoundaries: g2.pendingSuspenseBoundaries, transitions: g2.transitions }, b.updateQueue.baseState = f2, b.memoizedState = f2, b.flags & 256) {
          e = Ji(Error(p$1(423)), b);
          b = lj(a, b, d, c, e);
          break a;
        } else if (d !== e) {
          e = Ji(Error(p$1(424)), b);
          b = lj(a, b, d, c, e);
          break a;
        } else for (yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = true, zg = null, c = Vg(b, null, d, c), b.child = c; c; ) c.flags = c.flags & -3 | 4096, c = c.sibling;
        else {
          Ig();
          if (d === e) {
            b = Zi(a, b, c);
            break a;
          }
          Xi(a, b, d, c);
        }
        b = b.child;
      }
      return b;
    case 5:
      return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f2 = null !== a ? a.memoizedProps : null, g2 = e.children, Ef(d, e) ? g2 = null : null !== f2 && Ef(d, f2) && (b.flags |= 32), gj(a, b), Xi(a, b, g2, c), b.child;
    case 6:
      return null === a && Eg(b), null;
    case 13:
      return oj(a, b, c);
    case 4:
      return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
    case 7:
      return Xi(a, b, b.pendingProps, c), b.child;
    case 8:
      return Xi(a, b, b.pendingProps.children, c), b.child;
    case 12:
      return Xi(a, b, b.pendingProps.children, c), b.child;
    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        f2 = b.memoizedProps;
        g2 = e.value;
        G(Wg, d._currentValue);
        d._currentValue = g2;
        if (null !== f2) if (He(f2.value, g2)) {
          if (f2.children === e.children && !Wf.current) {
            b = Zi(a, b, c);
            break a;
          }
        } else for (f2 = b.child, null !== f2 && (f2.return = b); null !== f2; ) {
          var h = f2.dependencies;
          if (null !== h) {
            g2 = f2.child;
            for (var k2 = h.firstContext; null !== k2; ) {
              if (k2.context === d) {
                if (1 === f2.tag) {
                  k2 = mh(-1, c & -c);
                  k2.tag = 2;
                  var l2 = f2.updateQueue;
                  if (null !== l2) {
                    l2 = l2.shared;
                    var m2 = l2.pending;
                    null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                    l2.pending = k2;
                  }
                }
                f2.lanes |= c;
                k2 = f2.alternate;
                null !== k2 && (k2.lanes |= c);
                bh(
                  f2.return,
                  c,
                  b
                );
                h.lanes |= c;
                break;
              }
              k2 = k2.next;
            }
          } else if (10 === f2.tag) g2 = f2.type === b.type ? null : f2.child;
          else if (18 === f2.tag) {
            g2 = f2.return;
            if (null === g2) throw Error(p$1(341));
            g2.lanes |= c;
            h = g2.alternate;
            null !== h && (h.lanes |= c);
            bh(g2, c, b);
            g2 = f2.sibling;
          } else g2 = f2.child;
          if (null !== g2) g2.return = f2;
          else for (g2 = f2; null !== g2; ) {
            if (g2 === b) {
              g2 = null;
              break;
            }
            f2 = g2.sibling;
            if (null !== f2) {
              f2.return = g2.return;
              g2 = f2;
              break;
            }
            g2 = g2.return;
          }
          f2 = g2;
        }
        Xi(a, b, e.children, c);
        b = b.child;
      }
      return b;
    case 9:
      return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
    case 14:
      return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
    case 15:
      return bj(a, b, b.type, b.pendingProps, c);
    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = true, cg(b)) : a = false, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, true, a, c);
    case 19:
      return xj(a, b, c);
    case 22:
      return dj(a, b, c);
  }
  throw Error(p$1(156, b.tag));
};
function Fk(a, b) {
  return ac(a, b);
}
function $k(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.subtreeFlags = this.flags = 0;
  this.deletions = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}
function Bg(a, b, c, d) {
  return new $k(a, b, c, d);
}
function aj(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}
function Zk(a) {
  if ("function" === typeof a) return aj(a) ? 1 : 0;
  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Da) return 11;
    if (a === Ga) return 14;
  }
  return 2;
}
function Pg(a, b) {
  var c = a.alternate;
  null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
  c.flags = a.flags & 14680064;
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : { lanes: b.lanes, firstContext: b.firstContext };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}
function Rg(a, b, c, d, e, f2) {
  var g2 = 2;
  d = a;
  if ("function" === typeof a) aj(a) && (g2 = 1);
  else if ("string" === typeof a) g2 = 5;
  else a: switch (a) {
    case ya:
      return Tg(c.children, e, f2, b);
    case za:
      g2 = 8;
      e |= 8;
      break;
    case Aa:
      return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f2, a;
    case Ea:
      return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f2, a;
    case Fa:
      return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f2, a;
    case Ia:
      return pj(c, e, f2, b);
    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case Ba:
          g2 = 10;
          break a;
        case Ca:
          g2 = 9;
          break a;
        case Da:
          g2 = 11;
          break a;
        case Ga:
          g2 = 14;
          break a;
        case Ha:
          g2 = 16;
          d = null;
          break a;
      }
      throw Error(p$1(130, null == a ? a : typeof a, ""));
  }
  b = Bg(g2, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f2;
  return b;
}
function Tg(a, b, c, d) {
  a = Bg(7, a, d, b);
  a.lanes = c;
  return a;
}
function pj(a, b, c, d) {
  a = Bg(22, a, d, b);
  a.elementType = Ia;
  a.lanes = c;
  a.stateNode = { isHidden: false };
  return a;
}
function Qg(a, b, c) {
  a = Bg(6, a, null, b);
  a.lanes = c;
  return a;
}
function Sg(a, b, c) {
  b = Bg(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
  return b;
}
function al(a, b, c, d, e) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.callbackNode = this.pendingContext = this.context = null;
  this.callbackPriority = 0;
  this.eventTimes = zc(0);
  this.expirationTimes = zc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = zc(0);
  this.identifierPrefix = d;
  this.onRecoverableError = e;
  this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f2, g2, h, k2) {
  a = new al(a, b, c, h, k2);
  1 === b ? (b = 1, true === f2 && (b |= 8)) : b = 0;
  f2 = Bg(3, null, null, b);
  a.current = f2;
  f2.stateNode = a;
  f2.memoizedState = { element: d, isDehydrated: c, cache: null, transitions: null, pendingSuspenseBoundaries: null };
  kh(f2);
  return a;
}
function cl(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return { $$typeof: wa, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}
function dl(a) {
  if (!a) return Vf;
  a = a._reactInternals;
  a: {
    if (Vb(a) !== a || 1 !== a.tag) throw Error(p$1(170));
    var b = a;
    do {
      switch (b.tag) {
        case 3:
          b = b.stateNode.context;
          break a;
        case 1:
          if (Zf(b.type)) {
            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
            break a;
          }
      }
      b = b.return;
    } while (null !== b);
    throw Error(p$1(171));
  }
  if (1 === a.tag) {
    var c = a.type;
    if (Zf(c)) return bg(a, c, b);
  }
  return b;
}
function el(a, b, c, d, e, f2, g2, h, k2) {
  a = bl(c, d, true, a, e, f2, g2, h, k2);
  a.context = dl(null);
  c = a.current;
  d = R();
  e = yi(c);
  f2 = mh(d, e);
  f2.callback = void 0 !== b && null !== b ? b : null;
  nh(c, f2, e);
  a.current.lanes = e;
  Ac(a, e, d);
  Dk(a, d);
  return a;
}
function fl(a, b, c, d) {
  var e = b.current, f2 = R(), g2 = yi(e);
  c = dl(c);
  null === b.context ? b.context = c : b.pendingContext = c;
  b = mh(f2, g2);
  b.payload = { element: a };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  a = nh(e, b, g2);
  null !== a && (gi(a, e, g2, f2), oh(a, e, g2));
  return g2;
}
function gl(a) {
  a = a.current;
  if (!a.child) return null;
  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;
    default:
      return a.child.stateNode;
  }
}
function hl(a, b) {
  a = a.memoizedState;
  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}
function il(a, b) {
  hl(a, b);
  (a = a.alternate) && hl(a, b);
}
function jl() {
  return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
  console.error(a);
};
function ll(a) {
  this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
  var b = this._internalRoot;
  if (null === b) throw Error(p$1(409));
  fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
  var a = this._internalRoot;
  if (null !== a) {
    this._internalRoot = null;
    var b = a.containerInfo;
    Rk(function() {
      fl(null, a, null, null);
    });
    b[uf] = null;
  }
};
function ml(a) {
  this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
  if (a) {
    var b = Hc();
    a = { blockedOn: null, target: a, priority: b };
    for (var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++) ;
    Qc.splice(c, 0, a);
    0 === c && Vc(a);
  }
};
function nl(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {
}
function ql(a, b, c, d, e) {
  if (e) {
    if ("function" === typeof d) {
      var f2 = d;
      d = function() {
        var a2 = gl(g2);
        f2.call(a2);
      };
    }
    var g2 = el(b, d, a, 0, null, false, false, "", pl);
    a._reactRootContainer = g2;
    a[uf] = g2.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk();
    return g2;
  }
  for (; e = a.lastChild; ) a.removeChild(e);
  if ("function" === typeof d) {
    var h = d;
    d = function() {
      var a2 = gl(k2);
      h.call(a2);
    };
  }
  var k2 = bl(a, 0, false, null, null, false, false, "", pl);
  a._reactRootContainer = k2;
  a[uf] = k2.current;
  sf(8 === a.nodeType ? a.parentNode : a);
  Rk(function() {
    fl(b, k2, c, d);
  });
  return k2;
}
function rl(a, b, c, d, e) {
  var f2 = c._reactRootContainer;
  if (f2) {
    var g2 = f2;
    if ("function" === typeof e) {
      var h = e;
      e = function() {
        var a2 = gl(g2);
        h.call(a2);
      };
    }
    fl(b, g2, a, e);
  } else g2 = ql(c, b, a, e, d);
  return gl(g2);
}
Ec = function(a) {
  switch (a.tag) {
    case 3:
      var b = a.stateNode;
      if (b.current.memoizedState.isDehydrated) {
        var c = tc(b.pendingLanes);
        0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
      }
      break;
    case 13:
      Rk(function() {
        var b2 = ih(a, 1);
        if (null !== b2) {
          var c2 = R();
          gi(b2, a, 1, c2);
        }
      }), il(a, 1);
  }
};
Fc = function(a) {
  if (13 === a.tag) {
    var b = ih(a, 134217728);
    if (null !== b) {
      var c = R();
      gi(b, a, 134217728, c);
    }
    il(a, 134217728);
  }
};
Gc = function(a) {
  if (13 === a.tag) {
    var b = yi(a), c = ih(a, b);
    if (null !== c) {
      var d = R();
      gi(c, a, b, d);
    }
    il(a, b);
  }
};
Hc = function() {
  return C;
};
Ic = function(a, b) {
  var c = C;
  try {
    return C = a, b();
  } finally {
    C = c;
  }
};
yb = function(a, b, c) {
  switch (b) {
    case "input":
      bb(a, c);
      b = c.name;
      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode; ) c = c.parentNode;
        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
        for (b = 0; b < c.length; b++) {
          var d = c[b];
          if (d !== a && d.form === a.form) {
            var e = Db(d);
            if (!e) throw Error(p$1(90));
            Wa(d);
            bb(d, e);
          }
        }
      }
      break;
    case "textarea":
      ib(a, c);
      break;
    case "select":
      b = c.value, null != b && fb(a, !!c.multiple, b, false);
  }
};
Gb = Qk;
Hb = Rk;
var sl = { usingClientEntryPoint: false, Events: [Cb, ue, Db, Eb, Fb, Qk] }, tl = { findFiberByHostInstance: Wc, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" };
var ul = { bundleType: tl.bundleType, version: tl.version, rendererPackageName: tl.rendererPackageName, rendererConfig: tl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ua.ReactCurrentDispatcher, findHostInstanceByFiber: function(a) {
  a = Zb(a);
  return null === a ? null : a.stateNode;
}, findFiberByHostInstance: tl.findFiberByHostInstance || jl, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!vl.isDisabled && vl.supportsFiber) try {
    kc = vl.inject(ul), lc = vl;
  } catch (a) {
  }
}
reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
reactDom_production_min.createPortal = function(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!nl(b)) throw Error(p$1(200));
  return cl(a, b, null, c);
};
reactDom_production_min.createRoot = function(a, b) {
  if (!nl(a)) throw Error(p$1(299));
  var c = false, d = "", e = kl;
  null !== b && void 0 !== b && (true === b.unstable_strictMode && (c = true), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
  b = bl(a, 1, false, null, null, c, false, d, e);
  a[uf] = b.current;
  sf(8 === a.nodeType ? a.parentNode : a);
  return new ll(b);
};
reactDom_production_min.findDOMNode = function(a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;
  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(p$1(188));
    a = Object.keys(a).join(",");
    throw Error(p$1(268, a));
  }
  a = Zb(b);
  a = null === a ? null : a.stateNode;
  return a;
};
reactDom_production_min.flushSync = function(a) {
  return Rk(a);
};
reactDom_production_min.hydrate = function(a, b, c) {
  if (!ol(b)) throw Error(p$1(200));
  return rl(null, a, b, true, c);
};
reactDom_production_min.hydrateRoot = function(a, b, c) {
  if (!nl(a)) throw Error(p$1(405));
  var d = null != c && c.hydratedSources || null, e = false, f2 = "", g2 = kl;
  null !== c && void 0 !== c && (true === c.unstable_strictMode && (e = true), void 0 !== c.identifierPrefix && (f2 = c.identifierPrefix), void 0 !== c.onRecoverableError && (g2 = c.onRecoverableError));
  b = el(b, null, a, 1, null != c ? c : null, e, false, f2, g2);
  a[uf] = b.current;
  sf(a);
  if (d) for (a = 0; a < d.length; a++) c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [c, e] : b.mutableSourceEagerHydrationData.push(
    c,
    e
  );
  return new ml(b);
};
reactDom_production_min.render = function(a, b, c) {
  if (!ol(b)) throw Error(p$1(200));
  return rl(null, a, b, false, c);
};
reactDom_production_min.unmountComponentAtNode = function(a) {
  if (!ol(a)) throw Error(p$1(40));
  return a._reactRootContainer ? (Rk(function() {
    rl(null, null, a, false, function() {
      a._reactRootContainer = null;
      a[uf] = null;
    });
  }), true) : false;
};
reactDom_production_min.unstable_batchedUpdates = Qk;
reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
  if (!ol(c)) throw Error(p$1(200));
  if (null == a || void 0 === a._reactInternals) throw Error(p$1(38));
  return rl(a, b, c, false, d);
};
reactDom_production_min.version = "18.3.1-next-f1338f8080-20240426";
function checkDCE() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    console.error(err);
  }
}
{
  checkDCE();
  reactDom.exports = reactDom_production_min;
}
var reactDomExports = reactDom.exports;
var m = reactDomExports;
{
  client.createRoot = m.createRoot;
  client.hydrateRoot = m.hydrateRoot;
}
var withSelector = { exports: {} };
var useSyncExternalStoreWithSelector_production_min = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g = reactExports;
function n(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var p = "function" === typeof Object.is ? Object.is : n, q = g.useSyncExternalStore, r = g.useRef, t = g.useEffect, u = g.useMemo, v = g.useDebugValue;
useSyncExternalStoreWithSelector_production_min.useSyncExternalStoreWithSelector = function(a, b, e, l2, h) {
  var c = r(null);
  if (null === c.current) {
    var f2 = { hasValue: false, value: null };
    c.current = f2;
  } else f2 = c.current;
  c = u(function() {
    function a2(a3) {
      if (!c2) {
        c2 = true;
        d2 = a3;
        a3 = l2(a3);
        if (void 0 !== h && f2.hasValue) {
          var b2 = f2.value;
          if (h(b2, a3)) return k2 = b2;
        }
        return k2 = a3;
      }
      b2 = k2;
      if (p(d2, a3)) return b2;
      var e2 = l2(a3);
      if (void 0 !== h && h(b2, e2)) return b2;
      d2 = a3;
      return k2 = e2;
    }
    var c2 = false, d2, k2, m2 = void 0 === e ? null : e;
    return [function() {
      return a2(b());
    }, null === m2 ? void 0 : function() {
      return a2(m2());
    }];
  }, [b, e, l2, h]);
  var d = q(a, c[0], c[1]);
  t(function() {
    f2.hasValue = true;
    f2.value = d;
  }, [d]);
  v(d);
  return d;
};
{
  withSelector.exports = useSyncExternalStoreWithSelector_production_min;
}
var withSelectorExports = withSelector.exports;
var React = (
  // prettier-ignore
  // @ts-ignore
  "default" in ReactOriginal ? React$1 : ReactOriginal
);
var ContextKey = Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  if (!React.createContext)
    return {};
  const contextMap = gT[ContextKey] ?? (gT[ContextKey] = /* @__PURE__ */ new Map());
  let realContext = contextMap.get(React.createContext);
  if (!realContext) {
    realContext = React.createContext(
      null
    );
    contextMap.set(React.createContext, realContext);
  }
  return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
var notInitialized = () => {
  throw new Error("uSES not initialized!");
};
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext2() {
    const contextValue = React.useContext(context);
    return contextValue;
  };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
var useSyncExternalStoreWithSelector = notInitialized;
var initializeUseSelector = (fn) => {
  useSyncExternalStoreWithSelector = fn;
};
var refEquality = (a, b) => a === b;
function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
  const useSelector2 = (selector, equalityFnOrOptions = {}) => {
    const { equalityFn = refEquality, devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? { equalityFn: equalityFnOrOptions } : equalityFnOrOptions;
    const {
      store: store2,
      subscription,
      getServerState,
      stabilityCheck,
      identityFunctionCheck
    } = useReduxContext2();
    React.useRef(true);
    const wrappedSelector = React.useCallback(
      {
        [selector.name](state) {
          const selected = selector(state);
          return selected;
        }
      }[selector.name],
      [selector, stabilityCheck, devModeChecks.stabilityCheck]
    );
    const selectedState = useSyncExternalStoreWithSelector(
      subscription.addNestedSub,
      store2.getState,
      getServerState || store2.getState,
      wrappedSelector,
      equalityFn
    );
    React.useDebugValue(selectedState);
    return selectedState;
  };
  Object.assign(useSelector2, {
    withTypes: () => useSelector2
  });
  return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
function defaultNoopBatch(callback) {
  callback();
}
function createListenerCollection() {
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },
    notify() {
      defaultNoopBatch(() => {
        let listener = first;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get() {
      const listeners = [];
      let listener = first;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe(callback) {
      let isSubscribed = true;
      const listener = last = {
        callback,
        next: null,
        prev: last
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first === null)
          return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}
var nullListeners = {
  notify() {
  },
  get: () => []
};
function createSubscription(store2, parentSub) {
  let unsubscribe;
  let listeners = nullListeners;
  let subscriptionsAmount = 0;
  let selfSubscribed = false;
  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener);
    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return selfSubscribed;
  }
  function trySubscribe() {
    subscriptionsAmount++;
    if (!unsubscribe) {
      unsubscribe = store2.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    subscriptionsAmount--;
    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = void 0;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }
  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }
  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var useIsomorphicLayoutEffect = canUseDOM || isReactNative ? React.useLayoutEffect : React.useEffect;
function Provider({
  store: store2,
  context,
  children,
  serverState,
  stabilityCheck = "once",
  identityFunctionCheck = "once"
}) {
  const contextValue = React.useMemo(() => {
    const subscription = createSubscription(store2);
    return {
      store: store2,
      subscription,
      getServerState: serverState ? () => serverState : void 0,
      stabilityCheck,
      identityFunctionCheck
    };
  }, [store2, serverState, stabilityCheck, identityFunctionCheck]);
  const previousState = React.useMemo(() => store2.getState(), [store2]);
  useIsomorphicLayoutEffect(() => {
    const { subscription } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store2.getState()) {
      subscription.notifyNestedSubs();
    }
    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = void 0;
    };
  }, [contextValue, previousState]);
  const Context = context || ReactReduxContext;
  return /* @__PURE__ */ React.createElement(Context.Provider, { value: contextValue }, children);
}
var Provider_default = Provider;
function createStoreHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : (
    // @ts-ignore
    createReduxContextHook(context)
  );
  const useStore2 = () => {
    const { store: store2 } = useReduxContext2();
    return store2;
  };
  Object.assign(useStore2, {
    withTypes: () => useStore2
  });
  return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();
function createDispatchHook(context = ReactReduxContext) {
  const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
  const useDispatch2 = () => {
    const store2 = useStore2();
    return store2.dispatch;
  };
  Object.assign(useDispatch2, {
    withTypes: () => useDispatch2
  });
  return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
initializeUseSelector(withSelectorExports.useSyncExternalStoreWithSelector);
function formatProdErrorMessage$1(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
function isPlainObject$1(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(formatProdErrorMessage$1(2));
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(formatProdErrorMessage$1(0));
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(formatProdErrorMessage$1(1));
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(3));
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(formatProdErrorMessage$1(4));
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(5));
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(formatProdErrorMessage$1(6));
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(formatProdErrorMessage$1(7));
    }
    if (typeof action.type === "undefined") {
      throw new Error(formatProdErrorMessage$1(8));
    }
    if (typeof action.type !== "string") {
      throw new Error(formatProdErrorMessage$1(17));
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(9));
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(formatProdErrorMessage$1(10));
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(formatProdErrorMessage$1(11));
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store2 = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store2;
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState2 = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState2 === "undefined") {
      throw new Error(formatProdErrorMessage$1(12));
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(formatProdErrorMessage$1(13));
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        action && action.type;
        throw new Error(formatProdErrorMessage$1(14));
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store2 = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(formatProdErrorMessage$1(15));
    };
    const middlewareAPI = {
      getState: store2.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store2.dispatch);
    return {
      ...store2,
      dispatch
    };
  };
}
function isAction(action) {
  return isPlainObject$1(action) && "type" in action && typeof action.type === "string";
}
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
function die(error, ...args) {
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  var _a2;
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a2 = value.constructor) == null ? void 0 : _a2[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 : isMap(thing) ? 2 : isSet(thing) ? 3 : 0;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t2 = getArchtype(thing);
  if (t2 === 2)
    thing.set(propOrOldValue, value);
  else if (t2 === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x2, y2) {
  if (x2 === y2) {
    return x2 !== 0 || 1 / x2 === 1 / y2;
  } else {
    return x2 !== x2 && y2 !== y2;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc == null ? void 0 : desc.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  var _a2;
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a2 = desc.get) == null ? void 0 : _a2.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self2 = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self2.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p2 = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p2, ip);
          patchListener(p2, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p2, ip) => {
        patches = p2;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    var _a2;
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i = 0, l2 = length; i < l2; i++) {
      const arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = ((_a2 = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a2.call(lastResult)) ?? lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = {
      ...createSelectorCreatorOptions,
      ...directlyPassedOptions
    };
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = [],
      devModeChecks = {}
    } = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index) => {
          composition[inputSelectorKeys[index]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
var createDraftSafeSelectorCreator = (...args) => {
  const createSelector2 = createSelectorCreator(...args);
  const createDraftSafeSelector2 = Object.assign((...args2) => {
    const selector = createSelector2(...args2);
    const wrappedSelector = (value, ...rest) => selector(isDraft(value) ? current(value) : value, ...rest);
    Object.assign(wrappedSelector, selector);
    return wrappedSelector;
  }, {
    withTypes: () => createDraftSafeSelector2
  });
  return createDraftSafeSelector2;
};
createDraftSafeSelectorCreator(weakMapMemoize);
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0)
    return void 0;
  if (typeof arguments[0] === "object")
    return compose;
  return compose.apply(null, arguments);
};
var hasMatchFunction = (v2) => {
  return v2 && typeof v2.match === "function";
};
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(formatProdErrorMessage(0));
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function emplace(map, key, handler) {
  if (map.has(key)) {
    let value = map.get(key);
    if (handler.update) {
      value = handler.update(value, key, map);
      map.set(key, value);
    }
    return value;
  }
  if (!handler.insert)
    throw new Error(formatProdErrorMessage(10));
  const inserted = handler.insert(key, map);
  map.set(key, inserted);
  return inserted;
}
function isBoolean(x2) {
  return typeof x2 === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  return middlewareArray;
};
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store2 = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l2) => l2());
    }
  };
  return Object.assign({}, store2, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store2.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      var _a2;
      try {
        notifying = !((_a2 = action == null ? void 0 : action.meta) == null ? void 0 : _a2[SHOULD_AUTOBATCH]);
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store2.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};
var IS_PRODUCTION = true;
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(formatProdErrorMessage(1));
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: !IS_PRODUCTION,
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(formatProdErrorMessage(28));
      }
      if (type in actionsMap) {
        throw new Error(formatProdErrorMessage(29));
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}
function isStateFunction(x2) {
  return typeof x2 === "function";
}
function createReducer(initialState2, mapOrBuilderCallback) {
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState2)) {
    getInitialState = () => freezeDraftable(initialState2());
  } else {
    const frozenInitialState = freezeDraftable(initialState2);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw new Error(formatProdErrorMessage(9));
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id2 = "";
  let i = size;
  while (i--) {
    id2 += urlAlphabet[Math.random() * 64 | 0];
  }
  return id2;
};
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    __publicField(this, "_type");
    this.payload = payload;
    this.meta = meta;
  }
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    __publicField(this, "_type");
    this.payload = payload;
    this.meta = meta;
  }
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: void 0,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: (error == null ? void 0 : error.name) === "AbortError",
        condition: (error == null ? void 0 : error.name) === "ConditionError"
      }
    }));
    function actionCreator(arg) {
      return (dispatch, getState, extra) => {
        const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        const promise = async function() {
          var _a2, _b2;
          let finalAction;
          try {
            let conditionResult = (_a2 = options == null ? void 0 : options.condition) == null ? void 0 : _a2.call(options, arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, (_b2 = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b2.call(options, {
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  var _a2;
  const cAT = (_a2 = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a2[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error(formatProdErrorMessage(11));
    }
    if (typeof process !== "undefined" && false) {
      if (options.initialState === void 0) {
        console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
      }
    }
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(formatProdErrorMessage(12));
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(formatProdErrorMessage(13));
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher, reducer2) {
        context.sliceMatchers.push({
          matcher,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer2) {
        context.sliceCaseReducersByName[name2] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m2 of actionMatchers) {
          builder.addMatcher(m2.matcher, m2.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer)
        _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer)
        _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getInitialState();
          }
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = emplace(injectedSelectorCache, injected, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return emplace(selectorCache, selectState, {
          insert: () => {
            const map = {};
            for (const [name2, selector] of Object.entries(options.selectors ?? {})) {
              map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
            }
            return map;
          }
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice = {
      name,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config);
        return {
          ...slice,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice;
  };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      }
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator,
      ...config
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(formatProdErrorMessage(17));
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(formatProdErrorMessage(18));
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk2 = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk2);
  if (fulfilled) {
    context.addCase(thunk2.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk2.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk2.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk2.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop,
    pending: pending || noop,
    rejected: rejected || noop,
    settled: settled || noop
  });
}
function noop() {
}
var assertFunction = (func, expected) => {
  if (typeof func !== "function") {
    throw new Error(formatProdErrorMessage(32));
  }
};
var alm = "listenerMiddleware";
var getListenerEntryPropsFrom = (options) => {
  let {
    type,
    actionCreator,
    matcher,
    predicate,
    effect
  } = options;
  if (type) {
    predicate = createAction(type).match;
  } else if (actionCreator) {
    type = actionCreator.type;
    predicate = actionCreator.match;
  } else if (matcher) {
    predicate = matcher;
  } else if (predicate) ;
  else {
    throw new Error(formatProdErrorMessage(21));
  }
  assertFunction(effect);
  return {
    predicate,
    type,
    effect
  };
};
var createListenerEntry = Object.assign((options) => {
  const {
    type,
    predicate,
    effect
  } = getListenerEntryPropsFrom(options);
  const id2 = nanoid();
  const entry = {
    id: id2,
    effect,
    type,
    predicate,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(formatProdErrorMessage(22));
    }
  };
  return entry;
}, {
  withTypes: () => createListenerEntry
});
var addListener = Object.assign(createAction(`${alm}/add`), {
  withTypes: () => addListener
});
createAction(`${alm}/removeAll`);
var removeListener = Object.assign(createAction(`${alm}/remove`), {
  withTypes: () => removeListener
});
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
const INITIAL_PLACEHOLDER_ITEMS = 4;
const MIN_ALLOWED_ITEMS = 2;
const MAX_ALLOWED_ITEMS = 100;
const PROD_BUNDLE_ID = "319bfcd1a46042cabee419a29d122168";
const DEV_BUNDLE_ID = "82ae68d1cdd9402b93dede4dad55961a";
const BUNDLE_ID = ((_a = window.Shopify) == null ? void 0 : _a.shop) === "maelove-fc-development.myshopify.com" ? DEV_BUNDLE_ID : PROD_BUNDLE_ID;
((_b = window.Shopify) == null ? void 0 : _b.shop) === "maelove-fc-development.myshopify.com" ? "69f3867637e51240a02fad234a4a254b" : "e192be3febd8014ed0ae341c84102000";
const MAX_CONCERN_ALLOWED = 2;
const MOST_POPULAR_HANDLES = [
  "glow-maker-vitamin-c-serum",
  "peptide-squad-collagen-renewal-serum",
  "moonlight-retinaldehyde-retinal-night-serum",
  "full-follicle-serum",
  "forever-firm-neck-treatment"
];
const SKIN_CONCERN_PRODUCTS = {
  "(none)": {
    "core4": []
  },
  "Wrinkles": {
    "core4": [
      { product_id: 20097630225, variant_id: null, title: "Glow Maker", quantity: 1 },
      { product_id: 5964432867523, variant_id: null, title: "Moonlight", quantity: 1 },
      { product_id: 7644265578691, variant_id: null, title: "Peptide Squad", quantity: 1 },
      { product_id: 20098744337, variant_id: null, title: "Night Renewer", quantity: 1 }
    ]
  },
  "Dark spots": {
    "core4": [
      { product_id: 7275481858243, variant_id: null, title: "Fade Away", quantity: 1 },
      { product_id: 20097630225, variant_id: null, title: "Glow Maker", quantity: 1 },
      { product_id: 5964432867523, variant_id: null, title: "Moonlight", quantity: 1 },
      { product_id: 3752973303842, variant_id: null, title: "Nia 10", quantity: 1 }
    ]
  },
  "Dryness": {
    "core4": [
      { product_id: 3813924208674, variant_id: null, title: "Hydrator", quantity: 1 },
      { product_id: 7702866428099, variant_id: null, title: "Hydro Relief", quantity: 1 },
      { product_id: 7644265578691, variant_id: null, title: "Peptide Squad", quantity: 1 },
      { product_id: 7116688130243, variant_id: null, title: "Sheer Silk", quantity: 1 }
    ]
  },
  "Oil control": {
    "core4": [
      { product_id: 6234008355011, variant_id: null, title: "Super Smooth", quantity: 1 },
      { product_id: 3752973303842, variant_id: null, title: "Nia 10", quantity: 1 },
      { product_id: 3825700831266, variant_id: null, title: "Exfoliator", quantity: 1 },
      { product_id: 20098744337, variant_id: null, title: "Night Renewer", quantity: 1 }
    ]
  },
  "Redness": {
    "core4": [
      { product_id: 3752973303842, variant_id: null, title: "Nia 10", quantity: 1 },
      { product_id: 7644265578691, variant_id: null, title: "Peptide Squad", quantity: 1 },
      { product_id: 6990562296003, variant_id: null, title: "Plush Cream", quantity: 1 },
      { product_id: 3813924208674, variant_id: null, title: "Hydrator", quantity: 1 }
    ]
  },
  "Acne": {
    "core4": [
      { product_id: 20098744337, variant_id: null, title: "Night Renewer", quantity: 1 },
      { product_id: 3752973303842, variant_id: null, title: "Nia 10", quantity: 1 },
      { product_id: 5964432867523, variant_id: null, title: "Moonlight", quantity: 1 },
      { product_id: 1666765127714, variant_id: null, title: "Refresher", quantity: 1 }
    ]
  }
};
const applyBundleDiscount = async (bundleData, selected_individual_line_items) => {
  try {
    let discounts = bundleData.discounts || [];
    discounts = discounts.filter((d) => d.conditionType === "QUANTITY" && d.purchaseType === "SUBSCRIPTION");
    if (!discounts.length) return;
    let discountCodeToApply = "";
    let percentageDiscount = 0;
    for (let discount of discounts) {
      const quantity = selected_individual_line_items.length;
      if (quantity >= discount.minConditionValue && discount.value > percentageDiscount) {
        discountCodeToApply = discount.code;
        percentageDiscount = discount.value;
      }
    }
    if (!discountCodeToApply || !percentageDiscount) return;
    let rootUrl = window.Shopify.routes.root;
    if (rootUrl.endsWith("/")) {
      rootUrl = rootUrl.slice(0, -1);
    }
    const response = await fetch(`${rootUrl}/discount/${discountCodeToApply}`);
    if (!response.ok) {
      throw new Error("Failed to apply discount");
    }
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error(error);
    return null;
  }
};
const getItemKeysByBundleIdLoopV2 = (bundleId, BUNDLE_ID_REF, shopifySellingPlanId, cartItems) => {
  var _a2, _b2, _c, _d;
  if (BUNDLE_ID_REF && shopifySellingPlanId) {
    const data = {
      updates: {}
    };
    for (const item of cartItems) {
      if (((_a2 = item.properties) == null ? void 0 : _a2._bundleRef) == BUNDLE_ID_REF && ((_b2 = item.selling_plan_allocation) == null ? void 0 : _b2.selling_plan.id) == shopifySellingPlanId) {
        data.updates[item.key] = 0;
      }
    }
    return data;
  } else {
    const data = {
      updates: {}
    };
    for (const item of cartItems) {
      const _bundleId = ((_c = item == null ? void 0 : item.properties) == null ? void 0 : _c._bundleId) ?? ((_d = item == null ? void 0 : item.properties) == null ? void 0 : _d.bundleId);
      if (!_bundleId || _bundleId !== bundleId) continue;
      data.updates[item.key] = 0;
    }
    return data;
  }
};
const removeBundleLoopV2 = async (bundleId, BUNDLE_ID2, shopifySellingPlanId, cartItems) => {
  const data = getItemKeysByBundleIdLoopV2(bundleId, BUNDLE_ID2, shopifySellingPlanId, [...cartItems]);
  const endpoint = `${window.Shopify.routes.root}cart/update.js`;
  const resp = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });
  await resp.json();
  if (window.location.pathname.split("/").pop() === "cart") {
    window.location.reload();
    return;
  }
};
const getSelectedConcernIndex = (selectingConcern) => {
  return selectingConcern === "primary" ? 0 : 1;
};
const getQuerySelectedConcernItems = ({ concern1, concern2 }) => {
  const keys = Object.keys(SKIN_CONCERN_PRODUCTS);
  const keysLowercase = keys.map((c) => c.toLowerCase());
  let selected_concerns_params = [];
  const concern1_idx = keysLowercase.indexOf(concern1.toLowerCase());
  if (concern1_idx >= 0) {
    selected_concerns_params.push(keys[concern1_idx]);
  }
  if (concern2) {
    const concern2_idx = keysLowercase.indexOf(concern2.toLowerCase());
    if (concern2_idx >= 0) {
      selected_concerns_params.push(keys[concern2_idx]);
    }
  }
  let items;
  if (selected_concerns_params.length) {
    if (selected_concerns_params.length && selected_concerns_params[0]) {
      items = SKIN_CONCERN_PRODUCTS[selected_concerns_params[0]].core4.slice();
      if (selected_concerns_params.length > 1 && selected_concerns_params[1]) {
        const secItems = SKIN_CONCERN_PRODUCTS[selected_concerns_params[1]].core4;
        for (let tempItem of secItems) {
          if (!items.find((i) => i.product_id == tempItem.product_id)) {
            items[items.length - 1] = tempItem;
            break;
          }
        }
      }
    }
  }
  return { items, selected_concerns_params };
};
const getBundleItemsFromQueryItems = (queryConcernItems, bundleData) => {
  const productItems = queryConcernItems.split(",").map((i) => i.trim());
  const shopifyProducts = [];
  for (const productId of productItems) {
    const product = bundleData.products.find((p2) => p2.shopifyProductId.toString() === productId);
    if (product) {
      shopifyProducts.push({ product_id: product.shopifyProductId, variant_id: null, title: product.title, quantity: 1 });
    }
  }
  return shopifyProducts;
};
const getDiscountForItemCount = (itemCount, discountPercentageConfigPerItem) => {
  if (!discountPercentageConfigPerItem) return 0;
  const applicableKey = Object.keys(discountPercentageConfigPerItem).map((key) => parseInt(key)).filter((key) => !isNaN(key) && key <= itemCount).sort((a, b) => a - b).pop();
  return applicableKey ? discountPercentageConfigPerItem[applicableKey] : 0;
};
const getDiscountMessage = (selected_individual_line_items, discountPercentageConfigPerItem) => {
  if (!selected_individual_line_items || !selected_individual_line_items.length) {
    return {
      message: `<span>Add products to get up to <b>${discountPercentageConfigPerItem[4] || 20}% off</b> your total price.</span>`,
      discount: 0
    };
  }
  if (selected_individual_line_items.length === 1 && discountPercentageConfigPerItem[2]) {
    return {
      message: `<span>Add 1 more product to get <b>${discountPercentageConfigPerItem[2]}% off</b> your total price.</span>`,
      discount: 0
    };
  }
  let sortedKeys = Object.keys(discountPercentageConfigPerItem).map((key) => parseInt(key)).sort((a, b) => a - b);
  const lastKey = sortedKeys[sortedKeys.length - 1];
  let maxDiscount = discountPercentageConfigPerItem[lastKey];
  let currentDiscount = discountPercentageConfigPerItem[selected_individual_line_items.length] || 0;
  if (!currentDiscount && selected_individual_line_items.length >= lastKey) {
    currentDiscount = maxDiscount;
  }
  let nextDiscoutPercentage = discountPercentageConfigPerItem[selected_individual_line_items.length + 1] || currentDiscount;
  if (nextDiscoutPercentage && currentDiscount < nextDiscoutPercentage) {
    return {
      message: `<span>Add 1 more product to get <b>${nextDiscoutPercentage}% off</b> your total price.</span>`,
      discount: currentDiscount
    };
  }
  return {
    message: `<span>You've unlocked <b>${currentDiscount}% off your total price</b>!</span>`,
    discount: currentDiscount
  };
};
const expandStickyAddToCartSection = () => {
  var _a2;
  (_a2 = document.querySelector(".cpbundle-expand-button:not(.expanded)")) == null ? void 0 : _a2.click();
};
const restartReviewsWidget = () => {
  setTimeout(() => {
    var _a2;
    if ((_a2 = window.okeWidgetApi) == null ? void 0 : _a2.initAllWidgets) {
      window.okeWidgetApi.initAllWidgets();
    }
  }, 1e3);
};
const equalizeDescriptionHeights = () => {
  const grids = document.querySelectorAll(".cpbundle__serums__cards__grid");
  grids.forEach((grid) => {
    const descriptions = grid.querySelectorAll("p.cpbundel--product__title");
    if (descriptions.length === 0) return;
    descriptions.forEach((desc) => {
      desc.style.height = "auto";
    });
    const gridComputedStyle = window.getComputedStyle(grid);
    const gridTemplateColumns = gridComputedStyle.gridTemplateColumns.split(" ").length;
    const rows = [];
    for (let i = 0; i < descriptions.length; i += gridTemplateColumns) {
      rows.push(Array.from(descriptions).slice(i, i + gridTemplateColumns));
    }
    rows.forEach((row) => {
      let maxHeight = 0;
      row.forEach((desc) => {
        const height = desc.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      row.forEach((desc) => {
        desc.style.height = `${maxHeight}px`;
      });
    });
  });
};
const getBundleSignature = (selected_variants = []) => {
  return selected_variants.map((v2) => `${v2.shopifyId}:${v2.selected_quantity}`).sort().join("|");
};
const CATEGORIES = [
  { categoryId: "treatments", title: "Treatments", position: -1 },
  { categoryId: 10628, title: "Serums", position: 0 },
  { categoryId: 10630, title: "Creams", position: 1 },
  { categoryId: 10629, title: "Hair Care", position: 2 },
  { categoryId: 10631, title: "Cleansers", position: 3 },
  { categoryId: 10632, title: "Oils", position: 4 }
];
const TREATMENTS = [
  {
    id: "wrinkle-treatment",
    title: "Wrinkle Treatment",
    image: "https://maelove.com/cdn/shop/files/plump_firm_duo_carousel_1_d64ae1a5-045d-4a21-8864-9a1a2f205eec.jpg?v=1742447408",
    // Kit's own PDP — used for the quick view modal
    shopifyProductId: 8124821012675,
    productHandle: "wrinkle-treatment",
    rating: 4.6,
    concerns: ["signs-of-aging"],
    productIds: [
      20097630225,
      // Glow Maker
      7644265578691
      // Peptide Squad
    ]
  },
  {
    id: "intensive-wrinkle-treatment",
    title: "Intensive Wrinkle Treatment",
    image: "https://maelove.com/cdn/shop/files/wr4_carousel_1.jpg?v=1729893529",
    shopifyProductId: 8065445626051,
    productHandle: "wrinkle-repair-kit-pdp",
    rating: 4.6,
    concerns: ["signs-of-aging"],
    productIds: [
      20097630225,
      // Glow Maker
      7644265578691,
      // Peptide Squad
      5964432867523,
      // Moonlight
      20098744337
      // Night Renewer
    ]
  },
  {
    id: "dark-spots-treatment",
    title: "Dark Spots Treatment",
    image: "https://maelove.com/cdn/shop/files/dark_spots_duo_carousel_1_ad6ff251-c185-460e-93a6-0e39d05d4605.jpg?v=1750376373",
    shopifyProductId: 8135531790531,
    productHandle: "advanced-dark-spots-duo",
    rating: 4.6,
    concerns: ["dark-spots"],
    productIds: [
      20097630225,
      // Glow Maker
      7275481858243
      // Fade Away
    ]
  },
  {
    id: "dryness-treatment",
    title: "Dryness Treatment",
    image: "https://maelove.com/cdn/shop/files/hydration_treatment.png?v=1755847519",
    shopifyProductId: 8208293855427,
    productHandle: "dryness-treatment",
    rating: 4.7,
    concerns: ["dry-skin"],
    productIds: [
      3813924208674,
      // Hydrator
      7702866428099
      // Hydro Relief
    ]
  },
  {
    id: "hair-treatment",
    title: "Thinning Hair Treatment",
    image: "https://maelove.com/cdn/shop/files/fullfolliclesystem.jpg?v=1749484738",
    shopifyProductId: 8168957968579,
    productHandle: "ultimate-fuller-hair-routine",
    rating: 4.3,
    concerns: ["thinning-hair"],
    productIds: [
      8168957509827,
      // Full Follicle Shampoo
      8168957542595,
      // Full Follicle Conditioner
      8168957575363
      // Full Follicle Serum
    ]
  }
];
const SELLING_PLANS = [
  {
    sellingPlanId: 26636,
    adminGraphQlApiId: "gid://shopify/SellingPlan/1608155331",
    name: "Deliver every month",
    custom_name: "1 months",
    deliveryIntervalCount: 1,
    isDefault: 0
  },
  {
    sellingPlanId: 26637,
    adminGraphQlApiId: "gid://shopify/SellingPlan/1608188099",
    name: "Deliver every 2 months",
    custom_name: "2 months",
    deliveryIntervalCount: 2,
    isDefault: 1
  },
  {
    sellingPlanId: 26773,
    adminGraphQlApiId: "gid://shopify/SellingPlan/1614217411",
    name: "Deliver every 3 months",
    custom_name: "3 months",
    deliveryIntervalCount: 3,
    isDefault: 0
  },
  {
    sellingPlanId: 33149,
    adminGraphQlApiId: "gid://shopify/SellingPlan/1804009667",
    name: "Deliver every 4 months",
    custom_name: "4 months",
    deliveryIntervalCount: 4,
    isDefault: 0
  }
];
const DISCOUNTS = [
  { minConditionValue: 2, value: 7, code: "LPBNDLgr93k", type: "PERCENTAGE", purchaseType: "SUBSCRIPTION", conditionType: "QUANTITY", nanoId: "01JT401K6KG6MKZJE98DR8D8S5" },
  { minConditionValue: 3, value: 15, code: "LPBNDLaxwej", type: "PERCENTAGE", purchaseType: "SUBSCRIPTION", conditionType: "QUANTITY", nanoId: "01JT401K6KW0X29D50ECQQNBA5" },
  { minConditionValue: 4, value: 20, code: "LPBNDLdihed", type: "PERCENTAGE", purchaseType: "SUBSCRIPTION", conditionType: "QUANTITY", nanoId: "01JT401K6K9NCYBHT48VVF61CY" }
];
const CONCERN_FILTERS = [
  { label: "All Concerns", value: "" },
  { label: "Signs of Aging", value: "signs-of-aging" },
  { label: "Dry Skin", value: "dry-skin" },
  { label: "Dark Spots & Brightening", value: "dark-spots" },
  { label: "Thinning Hair", value: "thinning-hair" },
  { label: "Neck", value: "neck" }
];
const PRODUCTS = [
  // ── Serums (categoryId: 10628) ──
  {
    shopifyProductId: 7275481858243,
    productHandle: "fade-away-brightening-serum",
    productTitle: "Fade Away Brightening Serum",
    shortName: "Fade Away",
    badges: ["Fades spots", "For discoloration"],
    concerns: ["dark-spots"],
    categoryId: 10628,
    rating: 4.7,
    reviewCount: 312,
    variants: [{
      shopifyId: 41860241555651,
      price: 39.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/fa_no_badge.jpg?v=1764906278"
    }]
  },
  {
    shopifyProductId: 20097630225,
    productHandle: "glow-maker-vitamin-c-serum",
    productTitle: "Glow Maker Vitamin C Serum",
    shortName: "Glow Maker",
    badges: ["Brightens skin", "Evens tone"],
    concerns: ["signs-of-aging", "dark-spots"],
    categoryId: 10628,
    rating: 4.8,
    reviewCount: 1842,
    variants: [{
      shopifyId: 202519773201,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/gm_no_badge.jpg?v=1767122615"
    }]
  },
  {
    shopifyProductId: 3813924208674,
    productHandle: "hydrator-hyaluronic-acid-b5-serum",
    productTitle: "Hydrator Hyaluronic Acid B5 Serum",
    shortName: "Hydrator",
    badges: ["Deeply hydrates", "Supports skin barrier"],
    concerns: ["dry-skin", "signs-of-aging"],
    categoryId: 10628,
    rating: 4.8,
    reviewCount: 956,
    variants: [{
      shopifyId: 29080873762850,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/hy_no_badge.jpg?v=1764906350"
    }]
  },
  {
    shopifyProductId: 5964432867523,
    productHandle: "moonlight-retinaldehyde-retinal-night-serum",
    productTitle: "Moonlight Advanced Retinal Night Serum",
    shortName: "Moonlight",
    badges: ["High-strength Retinoid", "Anti-aging"],
    concerns: ["signs-of-aging", "dark-spots"],
    categoryId: 10628,
    rating: 4.7,
    reviewCount: 723,
    variants: [{
      shopifyId: 37150533124291,
      price: 39.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/ml_no_badge.jpg?v=1765582395"
    }]
  },
  {
    shopifyProductId: 3752973303842,
    productHandle: "nia-10-calming-serum",
    productTitle: "NIA 10 Niacinamide Serum",
    shortName: "NIA 10",
    badges: ["Soothes skin", "Clears pores"],
    concerns: ["signs-of-aging"],
    categoryId: 10628,
    rating: 4.6,
    reviewCount: 534,
    variants: [{
      shopifyId: 28823369809954,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/nia_10_carousel_1.jpg?v=1728357595"
    }]
  },
  {
    shopifyProductId: 7644265578691,
    productHandle: "peptide-squad-collagen-renewal-serum",
    productTitle: "Peptide Squad Collagen Renewal Serum",
    shortName: "Peptide Squad",
    badges: ["Plumps & firms", "Hydrating"],
    concerns: ["signs-of-aging", "dry-skin"],
    categoryId: 10628,
    rating: 4.5,
    reviewCount: 489,
    variants: [{
      shopifyId: 42572967936195,
      price: 47.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/ps_no_badge.jpg?v=1767122615"
    }]
  },
  {
    shopifyProductId: 6234007634115,
    productHandle: "stargaze-retinol-hyaluronic-night-serum",
    productTitle: "Stargaze Enhanced Retinol Serum",
    shortName: "Stargaze",
    badges: ["Beginner Retinol", "Gentle strength"],
    concerns: ["signs-of-aging", "dark-spots"],
    categoryId: 10628,
    rating: 4.7,
    reviewCount: 387,
    variants: [{
      shopifyId: 38055843037379,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/stargaze_carousel_1_8f2f2a6a-97e2-4488-8634-8a77f96ce91a.jpg?v=1770177426"
    }]
  },
  {
    shopifyProductId: 6234008355011,
    productHandle: "super-smooth-aha-bha-serum",
    productTitle: "Super Smooth AHA + BHA Resurfacing Serum",
    shortName: "Super Smooth",
    badges: ["Gentle exfoliation", "Refines texture"],
    concerns: ["signs-of-aging"],
    categoryId: 10628,
    rating: 4.4,
    reviewCount: 412,
    variants: [{
      shopifyId: 38055844544707,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/super_smooth_carousel_1.jpg?v=1728357982"
    }]
  },
  // ── Creams (categoryId: 10630) ──
  {
    shopifyProductId: 1584059023394,
    productHandle: "eye-enhancer-caffine-peptide-cream",
    productTitle: "Eye Enhancer De-Puffing Peptide Cream",
    shortName: "Eye Enhancer",
    badges: ["Reduces puffiness", "Awakens eyes"],
    concerns: ["signs-of-aging"],
    categoryId: 10630,
    rating: 4.5,
    reviewCount: 267,
    variants: [{
      shopifyId: 12923996340258,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/eye_enhancer_carousel_1.jpg?v=1728357210"
    }]
  },
  {
    shopifyProductId: 8219113029827,
    productHandle: "forever-firm-neck-treatment",
    productTitle: "Forever Firm Neck Treatment",
    shortName: "Forever Firm",
    badges: ["Neck firming", "Treats crepey skin"],
    concerns: ["neck", "signs-of-aging"],
    categoryId: 10630,
    rating: 4.6,
    reviewCount: 98,
    variants: [{
      shopifyId: 44894097047747,
      price: 49.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/forever_firm_carousel_1_84e98c31-9b7d-47a4-b5ed-e30770a4dc97.jpg?v=1760410372"
    }]
  },
  {
    shopifyProductId: 7702866428099,
    productHandle: "hydro-relief-peptide-amino-acid-cream",
    productTitle: "Hydro Relief Peptides & Amino Acids Cream",
    shortName: "Hydro Relief",
    badges: ["For dry skin", "Rich moisture"],
    concerns: ["dry-skin"],
    categoryId: 10630,
    rating: 4.7,
    reviewCount: 356,
    variants: [{
      shopifyId: 42785610301635,
      price: 36.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/hydro_relief_carousel_1.jpg?v=1728357485"
    }]
  },
  {
    shopifyProductId: 20098744337,
    productHandle: "night-renewer-glycolic-acid-night-cream",
    productTitle: "Night Renewer Glycolic Acid Cream",
    shortName: "Night Renewer",
    badges: ["Overnight exfoliation"],
    concerns: ["signs-of-aging", "dark-spots"],
    categoryId: 10630,
    rating: 4.6,
    reviewCount: 445,
    variants: [{
      shopifyId: 202585505809,
      price: 32.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/nr_no_badge.jpg?v=1765582395"
    }]
  },
  {
    shopifyProductId: 6990562296003,
    productHandle: "plush-cream-featherweight-moisturizer",
    productTitle: "Plush Cream Lightweight Moisturizer",
    shortName: "Plush Cream",
    badges: ["Light-as-air gel"],
    concerns: ["dry-skin"],
    categoryId: 10630,
    rating: 4.6,
    reviewCount: 289,
    variants: [{
      shopifyId: 40944929177795,
      price: 34.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/plush_carousel_1.jpg?v=1728357699"
    }]
  },
  {
    shopifyProductId: 9513953105,
    productHandle: "sun-protector-spf-30-mineral-sunscreen",
    productTitle: "Sun Protector SPF 30 Mineral Sunscreen",
    shortName: "Sun Protector",
    badges: ["Mineral protection", "Zinc"],
    concerns: ["signs-of-aging", "dark-spots"],
    categoryId: 10630,
    rating: 4.4,
    reviewCount: 512,
    variants: [{
      shopifyId: 34883756945,
      price: 24.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/sun_protector_carousel_1.jpg?v=1728357910"
    }]
  },
  // ── Hair Care (categoryId: 10629) ──
  {
    shopifyProductId: 8168957575363,
    productHandle: "full-follicle-serum",
    productTitle: "Full Follicle Advanced Scalp Serum",
    shortName: "Full Follicle Serum",
    badges: ["Fuller hair", "Energizes scalp"],
    concerns: ["thinning-hair"],
    categoryId: 10629,
    rating: 4.6,
    reviewCount: 178,
    variants: [{
      shopifyId: 44410811547843,
      price: 49.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/Full-Follicle-Serum-Stargaze-with-Skincare-Anarchy-Top-Picks-seal-2025.jpg?v=1758060547"
    }]
  },
  {
    shopifyProductId: 8168957542595,
    productHandle: "full-follicle-conditioner",
    productTitle: "Full Follicle Conditioner for Thicker Hair",
    shortName: "Full Follicle Conditioner",
    badges: ["Strengthens strands", "Volumizing"],
    concerns: ["thinning-hair"],
    categoryId: 10629,
    rating: 4.5,
    reviewCount: 87,
    variants: [{
      shopifyId: 44410811515075,
      price: 36.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/conditioner.jpg?v=1749011959"
    }]
  },
  {
    shopifyProductId: 8168957509827,
    productHandle: "full-follicle-shampoo",
    productTitle: "Full Follicle Shampoo for Thicker Hair",
    shortName: "Full Follicle Shampoo",
    badges: ["Reduces shedding", "Gentle cleansing"],
    concerns: ["thinning-hair"],
    categoryId: 10629,
    rating: 4.5,
    reviewCount: 92,
    variants: [{
      shopifyId: 44410811482307,
      price: 34.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/HaircareShampooFullFollicle.jpg?v=1748818244"
    }]
  },
  // ── Cleansers (categoryId: 10631) ──
  {
    shopifyProductId: 7116688130243,
    productHandle: "sheer-silk-ceramide-gentle-dry-skin-cleanser",
    productTitle: "Sheer Silk Ceramide Cleanser",
    shortName: "Sheer Silk",
    badges: ["Gentle cleansing", "For dry skin"],
    concerns: ["dry-skin"],
    categoryId: 10631,
    rating: 4.6,
    reviewCount: 234,
    variants: [{
      shopifyId: 41403199324355,
      price: 22.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/sheer_silk_carousel_1.jpg?v=1728357850"
    }]
  },
  {
    shopifyProductId: 3825700831266,
    productHandle: "deep-exfoliator-bha-clay-facial-scrub",
    productTitle: "The Exfoliator BHA + Clay Facial Scrub",
    shortName: "Exfoliator",
    badges: ["Kaolin clay", "Instant exfoliation"],
    concerns: ["signs-of-aging"],
    categoryId: 10631,
    rating: 4.5,
    reviewCount: 198,
    variants: [{
      shopifyId: 29138303156258,
      price: 27.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/exfoliator_carousel_1.jpg?v=1728358009"
    }]
  },
  {
    shopifyProductId: 1666765127714,
    productHandle: "refresher-aha-clarifying-face-wash-cleanser",
    productTitle: "The Refresher AHA Clarifying Cleanser",
    shortName: "Refresher",
    badges: ["Clarifying", "For normal to oily skin"],
    concerns: ["signs-of-aging"],
    categoryId: 10631,
    rating: 4.5,
    reviewCount: 312,
    variants: [{
      shopifyId: 15894156935202,
      price: 22.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/refresher_carousel_1.jpg?v=1728358037"
    }]
  },
  // ── Oils (categoryId: 10632) ──
  {
    shopifyProductId: 3781176852514,
    productHandle: "love31-oil-botanical-extract-facial",
    productTitle: "LOVE 31 Botanical Facial Oil",
    shortName: "LOVE 31",
    badges: ["Pure luxury"],
    concerns: ["dry-skin"],
    categoryId: 10632,
    rating: 4.8,
    reviewCount: 156,
    variants: [{
      shopifyId: 28950517612578,
      price: 79.95,
      image: "https://cdn.shopify.com/s/files/1/1919/1971/files/love_31_carousel_1.jpg?v=1728357521"
    }]
  }
];
const MOCK_TOKEN = "mock";
const MOCK_HANDLES = [
  "glow-maker-vitamin-c-serum",
  "hydrator-hyaluronic-acid-b5-serum",
  "moonlight-retinaldehyde-retinal-night-serum"
];
const MOCK_INTERVAL_MONTHS = 3;
const isMockSubscriptionRequest = ({ transactionId, token }) => {
  var _a2;
  const isDevEnvironment = ((_a2 = window.Shopify) == null ? void 0 : _a2.shop) === "maelove-fc-development.myshopify.com";
  return isDevEnvironment && transactionId === MOCK_TOKEN && token === MOCK_TOKEN;
};
const getMockSubscriptionData = () => {
  const url = new URL(window.location.href);
  const handles = (url.searchParams.get("mockItems") || "").split(",").map((h) => h.trim()).filter(Boolean);
  const selectedHandles = handles.length ? handles : MOCK_HANDLES;
  const intervalMonths = Number(url.searchParams.get("mockPlan")) || MOCK_INTERVAL_MONTHS;
  const plan = SELLING_PLANS.find((sp) => sp.deliveryIntervalCount === intervalMonths) || SELLING_PLANS.find((sp) => sp.deliveryIntervalCount === MOCK_INTERVAL_MONTHS);
  const missing = selectedHandles.filter((h) => !PRODUCTS.some((p2) => p2.productHandle === h));
  if (missing.length) {
    console.warn("[mock subscription] no catalog product for handle(s):", missing.join(", "));
  }
  const products = PRODUCTS.map((product) => {
    const isSelected = selectedHandles.includes(product.productHandle);
    return {
      shopifyId: product.shopifyProductId,
      title: product.productTitle,
      handle: product.productHandle,
      isSelected,
      variants: product.variants.map((variant, index) => ({
        shopifyId: variant.shopifyId,
        // Loop marks the subscribed variant; only the first variant is ever
        // subscribed here since every catalog product is single-variant.
        isSelected: isSelected && index === 0,
        quantity: isSelected && index === 0 ? 1 : 0
      }))
    };
  });
  const mockData = {
    id: MOCK_TOKEN,
    products,
    // Length 1 is what makes the reducer adopt the plan — see bundleSlice's
    // `existingSubscriptionData.sellingPlans?.length === 1` check.
    sellingPlans: [{ shopifyId: Number(plan.adminGraphQlApiId.split("/").pop()) }],
    boxSizes: [{ id: "mock-box-size" }]
  };
  console.log("[mock subscription] editing a faked Loop subscription", {
    items: selectedHandles,
    deliverEvery: plan.custom_name
  });
  return mockData;
};
const initialState = {
  data: null,
  isFetching: false,
  updatingCart: false,
  selected_variants: [],
  selected_individual_line_items: [],
  selected_treatments: [],
  qualified_for_free_product: false,
  should_show_confetti: false,
  selected_products: [],
  sellingPlans: [],
  total_qty: 0,
  total_price: 0,
  bundle_id: BUNDLE_ID,
  selected_selling_plan: null,
  applied_fc_filter: "",
  is_editing: false,
  // True only for the Loop customer-portal edit flow (?transactionId=&token=).
  // Unlike is_editing, this is set once on load and never recomputed, so picking
  // a concern or treatment kit mid-edit can't silently drop the user back into
  // "create a new subscription" mode.
  is_subscription_edit: false,
  // Fingerprint of the bundle as Loop returned it, captured once on load. The
  // Update Bundle CTA stays disabled while the current selection still matches.
  subscription_baseline_signature: "",
  editing_bundle_transaction_id: null,
  cartData: null,
  selected_concerns: [null, null],
  concern_models_opened: [false, false],
  discountPercentageConfigPerItem: {
    1: 0,
    2: 7,
    3: 15,
    4: 20,
    5: 20,
    6: 20
  },
  show_learn_more_modal: false,
  current_page: 2,
  // single-page flow — always on builder
  has_preset_routine: false,
  preset_source: ""
  // e.g. 'quiz', 'email', or '' when unknown
};
const fetchSubscriptionData = async ({ transactionId, token }) => {
  if (isMockSubscriptionRequest({ transactionId, token })) {
    return getMockSubscriptionData();
  }
  try {
    const response = await fetch(`https://api.loopsubscriptions.com/storefront/2023-10/bundle/transaction/${transactionId}`, {
      headers: {
        "accept": "application/json, text/plain, */*",
        "content-type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      method: "GET"
    });
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    const jsonData = await response.json();
    return jsonData == null ? void 0 : jsonData.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
const fetchCartData = async () => {
  try {
    const shopifyResponse = await fetch("/cart.js", {
      "headers": {
        "accept": "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      "method": "GET"
    });
    const cartData = await shopifyResponse.json();
    return cartData;
  } catch (error) {
    console.error(error);
    return null;
  }
};
const getLoopBundleData = createAsyncThunk("bundle/getLoopBundleData", async (payload, thinkAPI) => {
  const bundleData = {
    id: 3865,
    loopBundleId: BUNDLE_ID,
    label: "Family Circle",
    currencySymbol: "$",
    products: PRODUCTS.map((p2) => ({
      ...p2,
      selected_quantity: 0,
      grid_text: "",
      description: "",
      fc_filters: [],
      variants: p2.variants.map((v2) => ({
        ...v2,
        product_name: p2.productTitle,
        selected_quantity: 0,
        outOfStock: false,
        currency_code: "USD",
        compare_at_price: 0
      }))
    })),
    categories: CATEGORIES.map((c) => ({ ...c, subtitle: "", image: "", subTitle: "" })),
    sellingPlans: SELLING_PLANS,
    discounts: DISCOUNTS
  };
  let cartData;
  let editBundleId;
  const url = new URL(window.location.href);
  const concern1 = url.searchParams.get("concern1") || "";
  const concern2 = url.searchParams.get("concern2") || "";
  const queryConcernItems = url.searchParams.get("items") || "";
  const presetSource = url.searchParams.get("source") || "";
  const transactionId = url.searchParams.get("transactionId") || "";
  const token = url.searchParams.get("token") || "";
  let existingSubscriptionData;
  try {
    if (url.searchParams.get("bid")) {
      cartData = await fetchCartData();
      editBundleId = url.searchParams.get("bid");
    } else if (transactionId && token) {
      existingSubscriptionData = await fetchSubscriptionData({ transactionId, token });
    }
  } catch (error) {
    console.error(error);
  }
  return {
    bundleData,
    productsAdditionalData: null,
    cartData,
    editBundleId,
    concern1,
    concern2,
    queryConcernItems,
    presetSource,
    existingSubscriptionData,
    transactionId,
    token
  };
});
const addBundleToCart = createAsyncThunk("bundle/addBundleToCart", async (payload, thinkAPI) => {
  var _a2, _b2;
  const state = thinkAPI.getState().bundle;
  let cartData = state.cartData;
  let loopBundleGuid;
  if (state.is_editing && state.editing_bundle_transaction_id) {
    loopBundleGuid = state.editing_bundle_transaction_id;
  }
  let sellingPlan = state.selected_selling_plan;
  const shopifySellingPlanId = sellingPlan ? (_a2 = sellingPlan.adminGraphQlApiId) == null ? void 0 : _a2.split("/").pop() : void 0;
  let selected_individual_line_items = state.selected_individual_line_items;
  state.selected_variants;
  let useLatestCartData = false;
  let latestCartData;
  if (sellingPlan || !state.is_editing) {
    latestCartData = await fetchCartData();
    latestCartData.items || [];
  }
  if (!loopBundleGuid) {
    const response = await fetch(`https://api-service.loopwork.co/bundleTransaction`, {
      headers: {
        "accept": "application/json, text/plain, */*",
        "content-type": "application/json"
      },
      body: JSON.stringify({
        "bundleId": state.data.id,
        // "bundleDiscountId": 3420,
        "sellingPlanId": ((_b2 = state.selected_selling_plan) == null ? void 0 : _b2.sellingPlanId) || void 0
      }),
      method: "POST"
    });
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    const jsonData = await response.json();
    loopBundleGuid = jsonData.loopBundleGuid;
  }
  useLatestCartData = true;
  if (state.is_editing || useLatestCartData) {
    try {
      await removeBundleLoopV2(loopBundleGuid, BUNDLE_ID, shopifySellingPlanId, useLatestCartData && latestCartData ? latestCartData.items : cartData.items);
    } catch (error) {
      console.error(error);
    }
  }
  const joined_tems = [];
  for (const variant of selected_individual_line_items) {
    if (joined_tems.find((v2) => v2.shopifyId == variant.shopifyId)) {
      joined_tems.find((v2) => v2.shopifyId == variant.shopifyId).selected_quantity += 1;
    } else {
      joined_tems.push({ ...variant, selected_quantity: 1 });
    }
  }
  const currentTime = (/* @__PURE__ */ new Date()).getTime();
  const cartItemBody = joined_tems.map((v2, idx) => {
    return {
      "id": v2.shopifyId,
      "quantity": v2.selected_quantity,
      "price": Number(v2.price),
      "selling_plan": shopifySellingPlanId,
      "properties": {
        "_bundleId": loopBundleGuid,
        "_bundleRef": BUNDLE_ID,
        "bundleName": state.data.label,
        "__c": `${currentTime}-${idx}`,
        "_source": "bundle builder"
        // "__bundle_preset": bundle_preset_title ? bundle_preset_title : undefined
      }
    };
  });
  const shopifyResponse = await fetch("/cart/add.js", {
    "headers": {
      "accept": "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    "body": JSON.stringify({
      items: cartItemBody
    }),
    "method": "POST"
  });
  const updatedCartData = await shopifyResponse.json();
  try {
    await applyBundleDiscount(state.data, selected_individual_line_items);
  } catch (error) {
    console.error(error);
  }
  return updatedCartData;
});
const updateExistingBundle = createAsyncThunk("bundle/updateExistingBundle", async (payload, thinkAPI) => {
  var _a2;
  console.log("updateExistingBundle:start");
  const state = thinkAPI.getState().bundle;
  const transactionId = state.transactionId;
  const token = state.token;
  const selected_variants = state.selected_variants;
  const existingSubscriptionData = state.existingSubscriptionData;
  const discount_percentage = getDiscountMessage(state.selected_individual_line_items, state.discountPercentageConfigPerItem).discount;
  let discount_id = null;
  if (discount_percentage) {
    discount_id = (_a2 = state.data.discounts.find((d) => d.value === discount_percentage)) == null ? void 0 : _a2.nanoId;
  }
  if (!(token && transactionId && existingSubscriptionData)) {
    alert("Cannot update existing bundle. Invalid transactionId or token. Please contact customr support.");
    return;
  }
  let sellingPlan = state.selected_selling_plan;
  const selected_items = selected_variants.map((v2, idx) => {
    return {
      "productVariantShopifyId": v2.shopifyId,
      "quantity": v2.selected_quantity
    };
  });
  if (isMockSubscriptionRequest({ transactionId, token })) {
    console.log("[mock subscription] would POST /bundle/transaction/update", {
      items: selected_items,
      discountId: discount_id,
      boxSizeId: existingSubscriptionData.boxSizes[0].id,
      id: transactionId,
      sellingPlan: sellingPlan == null ? void 0 : sellingPlan.custom_name
    });
    return null;
  }
  try {
    const bundleUpdateResponse = await fetch("https://api.loopsubscriptions.com/storefront/2023-10/bundle/transaction/update", {
      "headers": {
        "accept": "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      "body": JSON.stringify({
        items: selected_items,
        "discountId": discount_id,
        "boxSizeId": existingSubscriptionData.boxSizes[0].id,
        "id": transactionId
      }),
      "method": "POST"
    });
    const bundleUpdateData = await bundleUpdateResponse.json();
    window.history.back();
    return bundleUpdateData;
  } catch (error) {
    console.error(error);
    return null;
  }
});
const refreshCartAndOpenCartDrawer = () => {
  if (typeof window.upcartOpenCart === "function") {
    window.upcartOpenOnAddToCartOverride = false;
  }
  function fireChange(newCart) {
    var _a2;
    if (typeof window.upcartOpenCart === "function") {
      window.upcartOpenCart();
    } else {
      document.dispatchEvent(
        new CustomEvent("theme:cart:change", {
          detail: {
            cart: newCart
          },
          bubbles: true
        })
      );
      console.debug("%c Firing theme:cart:change event", "color: red; font-size: 1rem");
      (_a2 = document.querySelector('[data-drawer="drawer-cart"]')) == null ? void 0 : _a2.dispatchEvent(
        new CustomEvent("theme:drawer:open", {
          bubbles: false
        })
      );
      console.debug("%c Firing theme:drawer:open event", "color: red; font-size: 1rem");
    }
  }
  window.fetch(`${window.theme.routes.cart}.js`).then((response) => {
    return response.json();
  }).then((response) => {
    window.cart = response;
    fireChange(response);
    return response;
  }).catch((e) => {
    console.error(e);
  });
};
const setBundleDataOnEdit = (state, action, cartBundleItems) => {
  const productIdsInBundle = cartBundleItems.map((bitem) => bitem.product_id.toString());
  for (let product of state.data.products) {
    product.selected_quantity = 0;
    for (let variant of product.variants) {
      variant.selected_quantity = 0;
      variant.product_name = product.productTitle;
    }
  }
  const tempProducts = state.data.products.slice().filter((product) => productIdsInBundle.includes(product.shopifyProductId.toString()));
  const tempVariants = [];
  for (const item of cartBundleItems) {
    const productFound = tempProducts.find((p2) => p2.shopifyProductId == item.product_id);
    if (productFound) {
      productFound.selected_quantity = item.quantity;
      const variantFound = item.variant_id ? productFound.variants.find((v2) => v2.shopifyId == item.variant_id) : productFound.variants[0];
      if (variantFound) {
        if (tempVariants.find((v2) => v2.shopifyId == variantFound.shopifyId)) {
          tempVariants.find((v2) => v2.shopifyId == variantFound.shopifyId).selected_quantity += item.quantity;
        } else {
          variantFound.selected_quantity = item.quantity;
          variantFound.shopifyProductId = item.product_id;
          tempVariants.push({ ...variantFound });
        }
      }
    }
  }
  let initial_selected_individual_line_items_qty = state.selected_individual_line_items.length;
  let selected_individual_line_items = [];
  for (const variant of tempVariants) {
    for (let i = 0; i < variant.selected_quantity; i++) {
      selected_individual_line_items.push({ ...variant, selected_quantity: 1 });
    }
  }
  if (selected_individual_line_items.length > MAX_ALLOWED_ITEMS) {
    selected_individual_line_items = selected_individual_line_items.slice(0, MAX_ALLOWED_ITEMS);
  }
  let totalPrice = 0;
  let totalQty = 0;
  for (let variant of selected_individual_line_items) {
    totalQty += 1;
    totalPrice += Number(variant.price);
  }
  state.selected_individual_line_items = selected_individual_line_items;
  state.selected_products = tempProducts;
  state.selected_variants = tempVariants;
  state.total_qty = totalQty;
  state.total_price = totalPrice;
  state.qualified_for_free_product = selected_individual_line_items.length >= MIN_ALLOWED_ITEMS;
  state.should_show_confetti = false;
  state.is_editing = (action.payload.editBundleId || action.payload.existingSubscriptionData) && selected_individual_line_items.length > 0;
  state.editing_bundle_transaction_id = state.editing_bundle_transaction_id || (selected_individual_line_items.length > 0 ? action.payload.editBundleId : null);
  console.log({
    selected_variants: state.selected_variants,
    selected_individual_line_items: state.selected_individual_line_items
  });
  if (initial_selected_individual_line_items_qty === 0 && state.selected_individual_line_items.length > 0) {
    expandStickyAddToCartSection();
  }
};
const reportSlice = createSlice({
  name: "bundle",
  initialState,
  reducers: {
    expandFirstVisibleCategory: (state, action) => {
      var _a2;
      const concern = action.payload;
      if (!((_a2 = state.data) == null ? void 0 : _a2.categories)) return;
      const allCollapsed = state.data.categories.every((c) => c.is_hidden);
      if (!allCollapsed) return;
      for (const category of state.data.categories) {
        const hasMatch = !concern || state.data.products.some(
          (p2) => {
            var _a3;
            return (p2.categoryId === category.categoryId || p2.mostPopularCategoryId === category.categoryId) && (!concern || ((_a3 = p2.concerns) == null ? void 0 : _a3.includes(concern)));
          }
        );
        if (hasMatch) {
          category.is_hidden = false;
          break;
        }
      }
    },
    toggleCategoryOpen: (state, action) => {
      const categoryFound = state.data.categories.find((category) => category.categoryId == action.payload.categoryId);
      if (categoryFound) {
        categoryFound.is_hidden = !categoryFound.is_hidden;
      }
    },
    setSellingPlan: (state, action) => {
      state.selected_selling_plan = action.payload;
    },
    setAppliedFCFilter: (state, action) => {
      state.applied_fc_filter = action.payload;
    },
    updateProductQty: (state, action) => {
      let initial_selected_individual_line_items_qty = state.selected_individual_line_items.length;
      if (!action.payload.shopifyProductId || !action.payload.selected_variant_id) {
        return;
      }
      const productFound = state.data.products.find((product) => product.shopifyProductId == action.payload.shopifyProductId);
      if (!productFound) {
        return;
      }
      productFound.selected_quantity = action.payload.selected_quantity;
      productFound.selected_variant_id = action.payload.selected_variant_id || 0;
      const btnAction = action.payload.action;
      const variantFound = productFound.variants.find((v2) => v2.shopifyId == action.payload.selected_variant_id);
      if (!variantFound) {
        return;
      }
      variantFound.selected_quantity = action.payload.selected_quantity;
      variantFound.shopifyProductId = action.payload.shopifyProductId;
      let tempProducts = [];
      let tempVariants = [];
      if (action.payload.selected_quantity <= 0) {
        tempProducts = state.selected_products.map((p2) => {
          if (p2.shopifyProductId == action.payload.shopifyProductId) {
            p2.selected_quantity -= action.payload.selected_quantity;
          }
          return p2;
        }).filter((p2) => p2.selected_quantity > 0);
      } else {
        let productQtyUpdated = false;
        tempProducts = state.selected_products.map((p2) => {
          if (p2.shopifyProductId == action.payload.shopifyProductId) {
            p2.selected_quantity = action.payload.selected_quantity;
            productQtyUpdated = true;
          }
          return p2;
        });
        if (!productQtyUpdated) {
          tempProducts.push(productFound);
        }
      }
      if (btnAction === "increase") {
        state.selected_individual_line_items.push({ ...variantFound, selected_quantity: 1 });
      } else {
        const idx = state.selected_individual_line_items.findIndex((v2) => v2.shopifyId == action.payload.selected_variant_id);
        if (idx !== -1) {
          state.selected_individual_line_items.splice(idx, 1);
        }
      }
      state.selected_products = tempProducts;
      let totalPrice = 0;
      let totalQty = 0;
      tempVariants = [];
      for (let variant of state.selected_individual_line_items) {
        totalQty += 1;
        totalPrice += Number(variant.price);
        if (tempVariants.find((v2) => v2.shopifyId == variant.shopifyId)) {
          tempVariants.find((v2) => v2.shopifyId == variant.shopifyId).selected_quantity += 1;
        } else {
          tempVariants.push({ ...variant, selected_quantity: 1 });
        }
      }
      state.total_qty = totalQty;
      state.total_price = totalPrice;
      state.qualified_for_free_product = state.selected_individual_line_items.length >= INITIAL_PLACEHOLDER_ITEMS;
      if (state.qualified_for_free_product) {
        state.should_show_confetti = true;
      }
      if (initial_selected_individual_line_items_qty === 0 && state.selected_individual_line_items.length > 0) {
        expandStickyAddToCartSection();
      }
      state.selected_variants = tempVariants;
      console.log({
        selected_variants: state.selected_variants,
        selected_individual_line_items: state.selected_individual_line_items.slice()
      });
    },
    setConcern: (state, action) => {
      const concerns = action.payload;
      state.selected_concerns.join("");
      state.selected_concerns = concerns;
      let items;
      if (concerns.length && concerns[0]) {
        items = SKIN_CONCERN_PRODUCTS[concerns[0]].core4.slice();
        if (concerns.length > 1 && concerns[1]) {
          const secItems = SKIN_CONCERN_PRODUCTS[concerns[1]].core4;
          for (let tempItem of secItems) {
            if (!items.slice(0, items.length - 1).find((i) => i.product_id == tempItem.product_id)) {
              items[items.length - 1] = tempItem;
              break;
            }
          }
        }
      }
      if (items) {
        setBundleDataOnEdit(state, action, items);
      }
    },
    setCustomItem: (state, action) => {
      setBundleDataOnEdit(state, action, action.payload);
    },
    updateConcernModelsOpened: (state, action) => {
      state.concern_models_opened = action.payload;
    },
    setShowLearnMoreModal: (state, action) => {
      state.show_learn_more_modal = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.current_page = action.payload;
    },
    // Track which treatment kits the user explicitly added, so the "Added"
    // state reflects an actual kit selection rather than being inferred from
    // whether its constituent products happen to be in the bundle (which would
    // light up subset kits, e.g. Wrinkle when Intensive Wrinkle is added).
    setTreatmentSelected: (state, action) => {
      const { id: id2, selected } = action.payload;
      const exists = state.selected_treatments.includes(id2);
      if (selected && !exists) {
        state.selected_treatments.push(id2);
      } else if (!selected && exists) {
        state.selected_treatments = state.selected_treatments.filter((t2) => t2 !== id2);
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getLoopBundleData.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(getLoopBundleData.fulfilled, (state, action) => {
      var _a2, _b2, _c, _d;
      const bundleData = action.payload.bundleData;
      const cartData = action.payload.cartData;
      const existingSubscriptionData = action.payload.existingSubscriptionData;
      const transactionId = action.payload.transactionId;
      const token = action.payload.token;
      if (((_a2 = bundleData.products) == null ? void 0 : _a2.length) && MOST_POPULAR_HANDLES.length) {
        const handleOrder = new Map(MOST_POPULAR_HANDLES.map((h, i) => [h, i]));
        bundleData.products.forEach((p2) => {
          if (MOST_POPULAR_HANDLES.includes(p2.productHandle)) {
            p2.isBestseller = true;
          }
        });
        bundleData.products.sort((a, b) => {
          const aOrder = handleOrder.has(a.productHandle) ? handleOrder.get(a.productHandle) : Infinity;
          const bOrder = handleOrder.has(b.productHandle) ? handleOrder.get(b.productHandle) : Infinity;
          return aOrder - bOrder;
        });
      }
      (_b2 = bundleData.categories) == null ? void 0 : _b2.forEach((category) => {
        category.is_hidden = false;
      });
      state.data = bundleData;
      state.isFetching = false;
      state.sellingPlans = [
        ...bundleData.sellingPlans.sort((a, b) => a.deliveryIntervalCount - b.deliveryIntervalCount).map((sp) => {
          sp.custom_name = `${sp.deliveryIntervalCount} months`;
          return sp;
        })
      ];
      state.selected_selling_plan = state.sellingPlans[1];
      state.cartData = cartData;
      let discountsTempObj = {};
      bundleData.discounts.forEach((discount) => {
        if (discount.type === "PERCENTAGE" && discount.purchaseType === "SUBSCRIPTION" && discount.conditionType === "QUANTITY") {
          discountsTempObj[discount.minConditionValue] = discount.value;
        }
      });
      state.discountPercentageConfigPerItem = discountsTempObj;
      state.existingSubscriptionData = existingSubscriptionData;
      state.transactionId = transactionId;
      state.token = token;
      state.is_subscription_edit = Boolean(existingSubscriptionData && transactionId && token);
      if (existingSubscriptionData) {
        const cartBundleItemsTemp = existingSubscriptionData.products.filter((item) => item.isSelected);
        const cartBundleItems = [];
        for (let item of cartBundleItemsTemp) {
          const variant = item.variants.find((v2) => v2.isSelected);
          if (!variant) continue;
          cartBundleItems.push({
            product_id: item.shopifyId,
            title: item.title,
            handle: item.handle,
            variant_id: variant.shopifyId,
            quantity: variant.quantity
          });
        }
        if (((_c = existingSubscriptionData.sellingPlans) == null ? void 0 : _c.length) === 1) {
          state.selected_selling_plan = state.sellingPlans.find((sp) => {
            var _a3;
            return sp.adminGraphQlApiId.split("/").pop() == ((_a3 = existingSubscriptionData.sellingPlans[0]) == null ? void 0 : _a3.shopifyId);
          });
        }
        setBundleDataOnEdit(state, action, cartBundleItems);
        state.subscription_baseline_signature = getBundleSignature(state.selected_variants);
      } else if (((_d = action.payload.cartData) == null ? void 0 : _d.items) && action.payload.editBundleId) {
        const cartBundleItems = action.payload.cartData.items.filter((item) => {
          var _a3;
          return ((_a3 = item.properties) == null ? void 0 : _a3._bundleId) === action.payload.editBundleId;
        });
        state.selected_selling_plan = state.sellingPlans.find((sp) => {
          var _a3, _b3;
          return sp.adminGraphQlApiId.split("/").pop() == ((_b3 = (_a3 = cartBundleItems[0]) == null ? void 0 : _a3.selling_plan_allocation) == null ? void 0 : _b3.selling_plan.id);
        }) || state.selected_selling_plan;
        setBundleDataOnEdit(state, action, cartBundleItems);
      } else if (action.payload.concern1 || action.payload.queryConcernItems) {
        if (action.payload.concern1) {
          const resp = getQuerySelectedConcernItems({
            concern1: action.payload.concern1,
            concern2: action.payload.concern2
          });
          if (resp.selected_concerns_params && resp.selected_concerns_params.length && resp.items) {
            state.selected_concerns = resp.selected_concerns_params;
            if (resp.items) {
              setBundleDataOnEdit(state, action, resp.items);
            }
          }
        } else if (action.payload.queryConcernItems) {
          const resp = getBundleItemsFromQueryItems(action.payload.queryConcernItems, bundleData);
          if (Array.isArray(resp) && resp.length) {
            setBundleDataOnEdit(state, action, resp);
            state.current_page = 2;
            state.has_preset_routine = true;
            state.preset_source = action.payload.presetSource || "";
          }
        }
      }
    });
    builder.addCase(getLoopBundleData.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(addBundleToCart.pending, (state, action) => {
      state.updatingCart = true;
    });
    builder.addCase(addBundleToCart.fulfilled, (state, action) => {
      state.cartData = action.payload;
      state.updatingCart = false;
      refreshCartAndOpenCartDrawer();
    });
    builder.addCase(addBundleToCart.rejected, (state, action) => {
      state.updatingCart = false;
    });
    builder.addCase(updateExistingBundle.pending, (state, action) => {
      state.updatingCart = true;
    });
    builder.addCase(updateExistingBundle.fulfilled, (state, action) => {
      state.updatingCart = false;
    });
    builder.addCase(updateExistingBundle.rejected, (state, action) => {
      state.updatingCart = false;
    });
  }
});
const {
  expandFirstVisibleCategory,
  toggleCategoryOpen,
  setSellingPlan,
  setAppliedFCFilter,
  updateProductQty,
  setConcern,
  setCustomItem,
  updateConcernModelsOpened,
  setShowLearnMoreModal,
  setCurrentPage,
  setTreatmentSelected
} = reportSlice.actions;
const bundleReducer = reportSlice.reducer;
const store = configureStore({
  reducer: {
    bundle: bundleReducer
  }
});
const getQuickViewStr = (productId, handle) => {
  const quickViewStr = `
    <div class="quickview" x-data="productQuickViewButton(${productId}, '${handle}')">
    <div data-quickview-holder="${productId}" data-add-action-wrapper="" data-error-boundary="">
        <div class="product-clip">
    
            <div class="product-clip__content">
    
                <button 
                    class="product-clip__btn btn--soft btn--small btn--primary fc-qv-btn fc__product-button" 
                    type="button"
                    @click.prevent="clickQuickviewButton" :class="{'loading': isLoading}" :disabled="isDisabled" :aria-busy="isLoading"
                    >
                    <span class="btn-state-ready">Quick view</span>
                    <span class="btn-state-loading">
                        <svg height="18" width="18" class="svg-loader">
                            <circle r="7" cx="9" cy="9"></circle>
                            <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                        </svg>
                    </span>
                </button>
            </div>
        </div>
    
        <div data-error-display="" class="add-action-errors">&nbsp;</div>
        <script data-quickview-modal-template="" type="text/x-template">
        <div class="drawer drawer--right quickview__modal" data-quickview-modal data-form-holder id="${productId}" aria-hidden="true">
        <div class="drawer__content" data-product-quickview-ajax></div>
    
        <span class="drawer__underlay" data-micromodal-close tabindex="-1">
            <span class="drawer__underlay__fill"></span>
            <span class="drawer__underlay__blur"></span>
        </span>
        </div>
    <\/script>
    </div>
    </div>
    `;
  return quickViewStr;
};
function QuickView({ productId, handle, additionalClass = "" }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: getQuickViewStr(productId, handle) }, style: { marginRight: "auto", marginTop: "6px", marginBottom: "6px" }, className: `fc-qview ${additionalClass}` });
}
const track = (event, properties = {}) => {
  var _a2;
  if (typeof window !== "undefined" && ((_a2 = window.posthog) == null ? void 0 : _a2.capture)) {
    window.posthog.capture(event, properties);
  }
};
const trackProductQtyChange = ({ product, price, previousQuantity, newQuantity, source }) => {
  const event = newQuantity === 0 ? "product_removed" : previousQuantity === 0 ? "product_added" : "product_quantity_changed";
  track(event, {
    product_id: product.shopifyProductId,
    product_title: product.productTitle,
    price,
    quantity: newQuantity,
    previous_quantity: previousQuantity,
    source
  });
};
function ProductCard(props) {
  var _a2, _b2;
  const product = props.product;
  const dispatch = useDispatch();
  const { currencySymbol, discounts } = useSelector((state) => state.bundle.data);
  const selected_individual_line_items = useSelector((state) => state.bundle.selected_individual_line_items);
  ((_a2 = discounts.find((discount) => discount.type === "PERCENTAGE")) == null ? void 0 : _a2.value) || 0;
  const originalPrice = parseFloat(product.variants[0].price);
  const triggerQuickView = (event) => {
    const container = event.target.closest(".cpbundle__serums__cards__grid__item");
    if (container) {
      const quickViewTriggerElem = container.querySelector("button.product-clip__btn");
      if (quickViewTriggerElem) {
        quickViewTriggerElem.click();
        track("quick_view_opened", {
          product_id: product.shopifyProductId,
          product_title: product.productTitle,
          product_handle: product.productHandle,
          price: product.variants[0].price,
          source: "product_card"
        });
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `cpbundle__serums__cards__grid__item ${props.additionalClasses || ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc__product-image-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc__product-image-container__img", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: product == null ? void 0 : product.variants[0].image, alt: product.productTitle, onClick: triggerQuickView }),
      product.isBestseller && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fc-card-bestseller-badge", children: "Bestseller" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        QuickView,
        {
          productId: product == null ? void 0 : product.shopifyProductId,
          handle: product == null ? void 0 : product.productHandle,
          additionalClass: `desktop-qv`
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__info-icon", onClick: triggerQuickView, children: "i" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__serums__cards__grid__item__details__ptitle", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h6", { onClick: triggerQuickView, children: product.productTitle }),
      product.rating > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__star-rating", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__star", children: "★" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__rating-num", children: product.rating })
      ] }),
      ((_b2 = product.badges) == null ? void 0 : _b2.length) > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle__product-badges", children: product.badges.map((badge, i) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__product-badge", children: badge }, i)) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-card-actions", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "fc-card-price", children: [
          window.getCurrencySymbol(),
          originalPrice
        ] }),
        (!product.selected_quantity || product.selected_quantity <= 0) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            className: "fc-card-add",
            "data-variant-id": product.variants[0].shopifyId,
            disabled: (selected_individual_line_items == null ? void 0 : selected_individual_line_items.length) >= MAX_ALLOWED_ITEMS || product.variants[0].outOfStock,
            onClick: () => {
              dispatch(updateProductQty({
                selected_quantity: 1,
                shopifyProductId: product.shopifyProductId,
                selected_variant_id: product.variants[0].shopifyId,
                action: "increase"
              }));
              trackProductQtyChange({
                product,
                price: product.variants[0].price,
                previousQuantity: product.selected_quantity || 0,
                newQuantity: 1,
                source: "product_card"
              });
            },
            children: product.variants[0].outOfStock ? "Sold out" : "Add"
          }
        ),
        product.selected_quantity >= 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-card-qty", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                dispatch(updateProductQty({
                  selected_quantity: product.selected_quantity - 1,
                  shopifyProductId: product.shopifyProductId,
                  selected_variant_id: product.variants[0].shopifyId,
                  action: "decrease"
                }));
                trackProductQtyChange({
                  product,
                  price: product.variants[0].price,
                  previousQuantity: product.selected_quantity,
                  newQuantity: product.selected_quantity - 1,
                  source: "product_card"
                });
              },
              children: "−"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: product.selected_quantity }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              disabled: (selected_individual_line_items == null ? void 0 : selected_individual_line_items.length) >= MAX_ALLOWED_ITEMS,
              onClick: () => {
                dispatch(updateProductQty({
                  selected_quantity: product.selected_quantity + 1,
                  shopifyProductId: product.shopifyProductId,
                  selected_variant_id: product.variants[0].shopifyId,
                  action: "increase"
                }));
                trackProductQtyChange({
                  product,
                  price: product.variants[0].price,
                  previousQuantity: product.selected_quantity,
                  newQuantity: product.selected_quantity + 1,
                  source: "product_card"
                });
              },
              children: "+"
            }
          )
        ] })
      ] })
    ] })
  ] }) });
}
function TreatmentCard({ treatment, additionalClasses }) {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.bundle.data.products);
  const selected_individual_line_items = useSelector((state) => state.bundle.selected_individual_line_items);
  const selected_treatments = useSelector((state) => state.bundle.selected_treatments);
  const kitProducts = treatment.productIds.map((id2) => products.find((p2) => p2.shopifyProductId == id2)).filter(Boolean);
  if (!kitProducts.length) return null;
  const totalPrice = kitProducts.reduce((sum, p2) => sum + parseFloat(p2.variants[0].price), 0);
  const includesLabel = kitProducts.map((p2) => p2.shortName || p2.productTitle).join(" + ");
  const allPresent = kitProducts.every((p2) => p2.selected_quantity >= 1);
  const isAdded = selected_treatments.includes(treatment.id) && allPresent;
  const missingProducts = kitProducts.filter((p2) => !(p2.selected_quantity >= 1));
  const wouldExceedMax = !isAdded && selected_individual_line_items.length + missingProducts.length > MAX_ALLOWED_ITEMS;
  const triggerQuickView = (event) => {
    const container = event.target.closest(".cpbundle__serums__cards__grid__item");
    if (container) {
      const quickViewTriggerElem = container.querySelector("button.product-clip__btn");
      if (quickViewTriggerElem) {
        quickViewTriggerElem.click();
        track("quick_view_opened", {
          product_id: treatment.shopifyProductId,
          product_title: treatment.title,
          product_handle: treatment.productHandle,
          price: totalPrice,
          source: "treatment_card"
        });
      }
    }
  };
  const addTreatment = () => {
    missingProducts.forEach((p2) => {
      dispatch(updateProductQty({
        selected_quantity: 1,
        shopifyProductId: p2.shopifyProductId,
        selected_variant_id: p2.variants[0].shopifyId,
        action: "increase"
      }));
    });
    dispatch(setTreatmentSelected({ id: treatment.id, selected: true }));
    track("treatment_added", {
      treatment_id: treatment.id,
      treatment_title: treatment.title,
      product_ids: kitProducts.map((p2) => p2.shopifyProductId),
      total_price: totalPrice
    });
  };
  const removeTreatment = () => {
    kitProducts.forEach((p2) => {
      if (p2.selected_quantity >= 1) {
        dispatch(updateProductQty({
          selected_quantity: p2.selected_quantity - 1,
          shopifyProductId: p2.shopifyProductId,
          selected_variant_id: p2.variants[0].shopifyId,
          action: "decrease"
        }));
      }
    });
    dispatch(setTreatmentSelected({ id: treatment.id, selected: false }));
    track("treatment_removed", {
      treatment_id: treatment.id,
      treatment_title: treatment.title,
      product_ids: kitProducts.map((p2) => p2.shopifyProductId),
      total_price: totalPrice
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `cpbundle__serums__cards__grid__item cpbundle__treatment-card ${additionalClasses || ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc__product-image-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc__product-image-container__img", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: treatment.image, alt: treatment.title, onClick: triggerQuickView }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "cpbundle__treatment-count-badge", children: [
        kitProducts.length,
        " products"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        QuickView,
        {
          productId: treatment.shopifyProductId,
          handle: treatment.productHandle,
          additionalClass: `desktop-qv`
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__info-icon", onClick: triggerQuickView, children: "i" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__serums__cards__grid__item__details__ptitle", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h6", { onClick: triggerQuickView, children: treatment.title }),
      treatment.rating > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__star-rating", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__star", children: "★" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__rating-num", children: treatment.rating })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "cpbundle__treatment-includes", children: includesLabel }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-card-actions", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "fc-card-price", children: [
          window.getCurrencySymbol(),
          totalPrice.toFixed(2)
        ] }),
        isAdded ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            className: "fc-card-add fc-card-add--added",
            onClick: removeTreatment,
            children: "Added ✓"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            className: "fc-card-add",
            disabled: wouldExceedMax,
            onClick: addTreatment,
            children: "Add"
          }
        )
      ] })
    ] })
  ] }) });
}
const Card = (props) => {
  var _a2;
  const category = props.category;
  const bundleData = props.bundleData;
  const applied_fc_filter = props.applied_fc_filter;
  const selectedConcern = props.selectedConcern || "";
  const dispatch = useDispatch();
  const isTreatments = category.categoryId === "treatments";
  const categoryProducts = isTreatments ? TREATMENTS : ((_a2 = bundleData == null ? void 0 : bundleData.products) == null ? void 0 : _a2.filter(
    (product) => product.categoryId === category.categoryId || product.mostPopularCategoryId === category.categoryId
  )) || [];
  const hasMatchingProducts = !selectedConcern || categoryProducts.some(
    (product) => {
      var _a3;
      return (_a3 = product.concerns) == null ? void 0 : _a3.includes(selectedConcern);
    }
  );
  let categoryHiddenClass = "";
  if (!categoryProducts.length || !hasMatchingProducts) {
    categoryHiddenClass = "pbundle-product-hidden";
  } else if (applied_fc_filter && !isTreatments) {
    const temp = categoryProducts.find((product) => {
      var _a3;
      return (_a3 = product.fc_filters) == null ? void 0 : _a3.includes(applied_fc_filter);
    });
    if (!temp) {
      categoryHiddenClass = "pbundle-product-hidden";
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: categoryHiddenClass, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `cpbundle__serum`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: `cpbundle__serums_dropdown`,
        "data-category": category.title,
        ref: category.title === "Serums" ? props.serumsElementRef : null,
        onClick: () => {
          dispatch(toggleCategoryOpen({ categoryId: category.categoryId }));
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "cpbundle__serums__dropdown__title", children: [
            category.title,
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "cpbundle__serums__dropdown__count", children: [
              "(",
              selectedConcern ? categoryProducts.filter((p2) => {
                var _a3;
                return (_a3 = p2.concerns) == null ? void 0 : _a3.includes(selectedConcern);
              }).length : categoryProducts.length,
              ")"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__serums__dropdown__right", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle__serums__dropdown__action", children: category.is_hidden ? "Show" : "Hide" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: `cpbundle__toggle ${!category.is_hidden ? "cpbundle__toggle--open" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "14", viewBox: "0 0 12 12", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3 4.5L6 7.5L9 4.5", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }) }) })
          ] })
        ]
      }
    ),
    category.categoryId && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `cpbundle__serums__cards ${category.is_hidden ? "pbundle-category-hidden" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle__serums__cards__grid", children: categoryProducts.map((product) => {
      let additionalClasses = "";
      if (selectedConcern && Array.isArray(product.concerns)) {
        if (!product.concerns.includes(selectedConcern)) {
          additionalClasses = "pbundle-product-hidden";
        }
      } else if (applied_fc_filter && Array.isArray(product.fc_filters)) {
        if (!product.fc_filters.includes(applied_fc_filter)) {
          additionalClasses = "pbundle-product-hidden";
        }
      }
      if (!product) return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
      if (isTreatments) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          TreatmentCard,
          {
            treatment: product,
            additionalClasses
          },
          product.id
        );
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ProductCard,
        {
          product,
          bundleData,
          additionalClasses
        },
        product == null ? void 0 : product.shopifyProductId
      );
    }) }) })
  ] }) });
};
var reactConfetti_min = { exports: {} };
(function(module, exports) {
  !function(t2, e) {
    module.exports = e(reactExports);
  }("undefined" != typeof self ? self : commonjsGlobal, function(t2) {
    return function(t3) {
      var e = {};
      function n2(r2) {
        if (e[r2]) return e[r2].exports;
        var i = e[r2] = { i: r2, l: false, exports: {} };
        return t3[r2].call(i.exports, i, i.exports, n2), i.l = true, i.exports;
      }
      return n2.m = t3, n2.c = e, n2.d = function(t4, e2, r2) {
        n2.o(t4, e2) || Object.defineProperty(t4, e2, { enumerable: true, get: r2 });
      }, n2.r = function(t4) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t4, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t4, "__esModule", { value: true });
      }, n2.t = function(t4, e2) {
        if (1 & e2 && (t4 = n2(t4)), 8 & e2) return t4;
        if (4 & e2 && "object" == typeof t4 && t4 && t4.__esModule) return t4;
        var r2 = /* @__PURE__ */ Object.create(null);
        if (n2.r(r2), Object.defineProperty(r2, "default", { enumerable: true, value: t4 }), 2 & e2 && "string" != typeof t4) for (var i in t4) n2.d(r2, i, (function(e3) {
          return t4[e3];
        }).bind(null, i));
        return r2;
      }, n2.n = function(t4) {
        var e2 = t4 && t4.__esModule ? function() {
          return t4.default;
        } : function() {
          return t4;
        };
        return n2.d(e2, "a", e2), e2;
      }, n2.o = function(t4, e2) {
        return Object.prototype.hasOwnProperty.call(t4, e2);
      }, n2.p = "", n2(n2.s = 2);
    }([function(e, n2) {
      e.exports = t2;
    }, function(t3, e, n2) {
      var r2 = { linear: function(t4, e2, n3, r3) {
        return (n3 - e2) * t4 / r3 + e2;
      }, easeInQuad: function(t4, e2, n3, r3) {
        return (n3 - e2) * (t4 /= r3) * t4 + e2;
      }, easeOutQuad: function(t4, e2, n3, r3) {
        return -(n3 - e2) * (t4 /= r3) * (t4 - 2) + e2;
      }, easeInOutQuad: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return (t4 /= r3 / 2) < 1 ? i / 2 * t4 * t4 + e2 : -i / 2 * (--t4 * (t4 - 2) - 1) + e2;
      }, easeInCubic: function(t4, e2, n3, r3) {
        return (n3 - e2) * (t4 /= r3) * t4 * t4 + e2;
      }, easeOutCubic: function(t4, e2, n3, r3) {
        return (n3 - e2) * ((t4 = t4 / r3 - 1) * t4 * t4 + 1) + e2;
      }, easeInOutCubic: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return (t4 /= r3 / 2) < 1 ? i / 2 * t4 * t4 * t4 + e2 : i / 2 * ((t4 -= 2) * t4 * t4 + 2) + e2;
      }, easeInQuart: function(t4, e2, n3, r3) {
        return (n3 - e2) * (t4 /= r3) * t4 * t4 * t4 + e2;
      }, easeOutQuart: function(t4, e2, n3, r3) {
        return -(n3 - e2) * ((t4 = t4 / r3 - 1) * t4 * t4 * t4 - 1) + e2;
      }, easeInOutQuart: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return (t4 /= r3 / 2) < 1 ? i / 2 * t4 * t4 * t4 * t4 + e2 : -i / 2 * ((t4 -= 2) * t4 * t4 * t4 - 2) + e2;
      }, easeInQuint: function(t4, e2, n3, r3) {
        return (n3 - e2) * (t4 /= r3) * t4 * t4 * t4 * t4 + e2;
      }, easeOutQuint: function(t4, e2, n3, r3) {
        return (n3 - e2) * ((t4 = t4 / r3 - 1) * t4 * t4 * t4 * t4 + 1) + e2;
      }, easeInOutQuint: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return (t4 /= r3 / 2) < 1 ? i / 2 * t4 * t4 * t4 * t4 * t4 + e2 : i / 2 * ((t4 -= 2) * t4 * t4 * t4 * t4 + 2) + e2;
      }, easeInSine: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return -i * Math.cos(t4 / r3 * (Math.PI / 2)) + i + e2;
      }, easeOutSine: function(t4, e2, n3, r3) {
        return (n3 - e2) * Math.sin(t4 / r3 * (Math.PI / 2)) + e2;
      }, easeInOutSine: function(t4, e2, n3, r3) {
        return -(n3 - e2) / 2 * (Math.cos(Math.PI * t4 / r3) - 1) + e2;
      }, easeInExpo: function(t4, e2, n3, r3) {
        return 0 == t4 ? e2 : (n3 - e2) * Math.pow(2, 10 * (t4 / r3 - 1)) + e2;
      }, easeOutExpo: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return t4 == r3 ? e2 + i : i * (1 - Math.pow(2, -10 * t4 / r3)) + e2;
      }, easeInOutExpo: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return 0 === t4 ? e2 : t4 === r3 ? e2 + i : (t4 /= r3 / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t4 - 1)) + e2 : i / 2 * (2 - Math.pow(2, -10 * --t4)) + e2;
      }, easeInCirc: function(t4, e2, n3, r3) {
        return -(n3 - e2) * (Math.sqrt(1 - (t4 /= r3) * t4) - 1) + e2;
      }, easeOutCirc: function(t4, e2, n3, r3) {
        return (n3 - e2) * Math.sqrt(1 - (t4 = t4 / r3 - 1) * t4) + e2;
      }, easeInOutCirc: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return (t4 /= r3 / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t4 * t4) - 1) + e2 : i / 2 * (Math.sqrt(1 - (t4 -= 2) * t4) + 1) + e2;
      }, easeInElastic: function(t4, e2, n3, r3) {
        var i, o, a, c = n3 - e2;
        return a = 1.70158, 0 === t4 ? e2 : 1 == (t4 /= r3) ? e2 + c : ((o = 0) || (o = 0.3 * r3), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t4 -= 1)) * Math.sin((t4 * r3 - a) * (2 * Math.PI) / o) + e2);
      }, easeOutElastic: function(t4, e2, n3, r3) {
        var i, o, a, c = n3 - e2;
        return a = 1.70158, 0 === t4 ? e2 : 1 == (t4 /= r3) ? e2 + c : ((o = 0) || (o = 0.3 * r3), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t4) * Math.sin((t4 * r3 - a) * (2 * Math.PI) / o) + c + e2);
      }, easeInOutElastic: function(t4, e2, n3, r3) {
        var i, o, a, c = n3 - e2;
        return a = 1.70158, 0 === t4 ? e2 : 2 == (t4 /= r3 / 2) ? e2 + c : ((o = 0) || (o = r3 * (0.3 * 1.5)), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t4 < 1 ? i * Math.pow(2, 10 * (t4 -= 1)) * Math.sin((t4 * r3 - a) * (2 * Math.PI) / o) * -0.5 + e2 : i * Math.pow(2, -10 * (t4 -= 1)) * Math.sin((t4 * r3 - a) * (2 * Math.PI) / o) * 0.5 + c + e2);
      }, easeInBack: function(t4, e2, n3, r3, i) {
        return void 0 === i && (i = 1.70158), (n3 - e2) * (t4 /= r3) * t4 * ((i + 1) * t4 - i) + e2;
      }, easeOutBack: function(t4, e2, n3, r3, i) {
        return void 0 === i && (i = 1.70158), (n3 - e2) * ((t4 = t4 / r3 - 1) * t4 * ((i + 1) * t4 + i) + 1) + e2;
      }, easeInOutBack: function(t4, e2, n3, r3, i) {
        var o = n3 - e2;
        return void 0 === i && (i = 1.70158), (t4 /= r3 / 2) < 1 ? o / 2 * (t4 * t4 * ((1 + (i *= 1.525)) * t4 - i)) + e2 : o / 2 * ((t4 -= 2) * t4 * ((1 + (i *= 1.525)) * t4 + i) + 2) + e2;
      }, easeInBounce: function(t4, e2, n3, i) {
        var o = n3 - e2;
        return o - r2.easeOutBounce(i - t4, 0, o, i) + e2;
      }, easeOutBounce: function(t4, e2, n3, r3) {
        var i = n3 - e2;
        return (t4 /= r3) < 1 / 2.75 ? i * (7.5625 * t4 * t4) + e2 : t4 < 2 / 2.75 ? i * (7.5625 * (t4 -= 1.5 / 2.75) * t4 + 0.75) + e2 : t4 < 2.5 / 2.75 ? i * (7.5625 * (t4 -= 2.25 / 2.75) * t4 + 0.9375) + e2 : i * (7.5625 * (t4 -= 2.625 / 2.75) * t4 + 0.984375) + e2;
      }, easeInOutBounce: function(t4, e2, n3, i) {
        var o = n3 - e2;
        return t4 < i / 2 ? 0.5 * r2.easeInBounce(2 * t4, 0, o, i) + e2 : 0.5 * r2.easeOutBounce(2 * t4 - i, 0, o, i) + 0.5 * o + e2;
      } };
      t3.exports = r2;
    }, function(t3, e, n2) {
      t3.exports = n2(3);
    }, function(t3, e, n2) {
      n2.r(e), n2.d(e, "ReactConfetti", function() {
        return Q2;
      });
      var r2, i, o = n2(0), a = n2.n(o), c = n2(1), s = n2.n(c);
      function u2(t4, e2) {
        return t4 + Math.random() * (e2 - t4);
      }
      function f2(t4, e2) {
        for (var n3 = 0; n3 < e2.length; n3++) {
          var r3 = e2[n3];
          r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(t4, r3.key, r3);
        }
      }
      function h(t4, e2, n3) {
        return e2 in t4 ? Object.defineProperty(t4, e2, { value: n3, enumerable: true, configurable: true, writable: true }) : t4[e2] = n3, t4;
      }
      !function(t4) {
        t4[t4.Circle = 0] = "Circle", t4[t4.Square = 1] = "Square", t4[t4.Strip = 2] = "Strip";
      }(r2 || (r2 = {})), function(t4) {
        t4[t4.Positive = 1] = "Positive", t4[t4.Negative = -1] = "Negative";
      }(i || (i = {}));
      var l2 = function() {
        function t4(e3, n4, r3, o2) {
          !function(t5, e4) {
            if (!(t5 instanceof e4)) throw new TypeError("Cannot call a class as a function");
          }(this, t4), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n4;
          var a2, c2, s2 = this.getOptions(), f3 = s2.colors, l3 = s2.initialVelocityX, p3 = s2.initialVelocityY;
          this.context = e3, this.x = r3, this.y = o2, this.w = u2(5, 20), this.h = u2(5, 20), this.radius = u2(5, 10), this.vx = "number" == typeof l3 ? u2(-l3, l3) : u2(l3.min, l3.max), this.vy = "number" == typeof p3 ? u2(-p3, 0) : u2(p3.min, p3.max), this.shape = (a2 = 0, c2 = 2, Math.floor(a2 + Math.random() * (c2 - a2 + 1))), this.angle = u2(0, 360) * Math.PI / 180, this.angularSpin = u2(-0.2, 0.2), this.color = f3[Math.floor(Math.random() * f3.length)], this.rotateY = u2(0, 1), this.rotationDirection = u2(0, 1) ? i.Positive : i.Negative;
        }
        var e2, n3;
        return e2 = t4, (n3 = [{ key: "update", value: function() {
          var t5 = this.getOptions(), e3 = t5.gravity, n4 = t5.wind, o2 = t5.friction, a2 = t5.opacity, c2 = t5.drawShape;
          this.x += this.vx, this.y += this.vy, this.vy += e3, this.vx += n4, this.vx *= o2, this.vy *= o2, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
          var s2 = 0.1 * this.rotationDirection;
          if (this.rotateY += s2, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a2, this.context.lineCap = "round", this.context.lineWidth = 2, c2 && "function" == typeof c2) c2.call(this, this.context);
          else switch (this.shape) {
            case r2.Circle:
              this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
              break;
            case r2.Square:
              this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
              break;
            case r2.Strip:
              this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
          }
          this.context.closePath(), this.context.restore();
        } }]) && f2(e2.prototype, n3), t4;
      }();
      function p2(t4, e2, n3) {
        return e2 in t4 ? Object.defineProperty(t4, e2, { value: n3, enumerable: true, configurable: true, writable: true }) : t4[e2] = n3, t4;
      }
      var v2 = function t4(e2, n3) {
        var r3 = this;
        !function(t5, e3) {
          if (!(t5 instanceof e3)) throw new TypeError("Cannot call a class as a function");
        }(this, t4), p2(this, "canvas", void 0), p2(this, "context", void 0), p2(this, "getOptions", void 0), p2(this, "x", 0), p2(this, "y", 0), p2(this, "w", 0), p2(this, "h", 0), p2(this, "lastNumberOfPieces", 0), p2(this, "tweenInitTime", Date.now()), p2(this, "particles", []), p2(this, "particlesGenerated", 0), p2(this, "removeParticleAt", function(t5) {
          r3.particles.splice(t5, 1);
        }), p2(this, "getParticle", function() {
          var t5 = u2(r3.x, r3.w + r3.x), e3 = u2(r3.y, r3.h + r3.y);
          return new l2(r3.context, r3.getOptions, t5, e3);
        }), p2(this, "animate", function() {
          var t5 = r3.canvas, e3 = r3.context, n4 = r3.particlesGenerated, i3 = r3.lastNumberOfPieces, o2 = r3.getOptions(), a2 = o2.run, c2 = o2.recycle, s2 = o2.numberOfPieces, u3 = o2.debug, f3 = o2.tweenFunction, h2 = o2.tweenDuration;
          if (!a2) return false;
          var l3 = r3.particles.length, p3 = c2 ? l3 : n4, v3 = Date.now();
          if (p3 < s2) {
            i3 !== s2 && (r3.tweenInitTime = v3, r3.lastNumberOfPieces = s2);
            for (var y3 = r3.tweenInitTime, d2 = f3(v3 - y3 > h2 ? h2 : Math.max(0, v3 - y3), p3, s2, h2), b2 = Math.round(d2 - p3), g3 = 0; g3 < b2; g3++) r3.particles.push(r3.getParticle());
            r3.particlesGenerated += b2;
          }
          return u3 && (e3.font = "12px sans-serif", e3.fillStyle = "#333", e3.textAlign = "right", e3.fillText("Particles: ".concat(l3), t5.width - 10, t5.height - 20)), r3.particles.forEach(function(e4, n5) {
            e4.update(), (e4.y > t5.height || e4.y < -100 || e4.x > t5.width + 100 || e4.x < -100) && (c2 && p3 <= s2 ? r3.particles[n5] = r3.getParticle() : r3.removeParticleAt(n5));
          }), l3 > 0 || p3 < s2;
        }), this.canvas = e2;
        var i2 = this.canvas.getContext("2d");
        if (!i2) throw new Error("Could not get canvas context");
        this.context = i2, this.getOptions = n3;
      };
      function y2(t4, e2) {
        var n3 = Object.keys(t4);
        if (Object.getOwnPropertySymbols) {
          var r3 = Object.getOwnPropertySymbols(t4);
          e2 && (r3 = r3.filter(function(e3) {
            return Object.getOwnPropertyDescriptor(t4, e3).enumerable;
          })), n3.push.apply(n3, r3);
        }
        return n3;
      }
      function d(t4) {
        for (var e2 = 1; e2 < arguments.length; e2++) {
          var n3 = null != arguments[e2] ? arguments[e2] : {};
          e2 % 2 ? y2(Object(n3), true).forEach(function(e3) {
            g2(t4, e3, n3[e3]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(n3)) : y2(Object(n3)).forEach(function(e3) {
            Object.defineProperty(t4, e3, Object.getOwnPropertyDescriptor(n3, e3));
          });
        }
        return t4;
      }
      function b(t4, e2) {
        for (var n3 = 0; n3 < e2.length; n3++) {
          var r3 = e2[n3];
          r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(t4, r3.key, r3);
        }
      }
      function g2(t4, e2, n3) {
        return e2 in t4 ? Object.defineProperty(t4, e2, { value: n3, enumerable: true, configurable: true, writable: true }) : t4[e2] = n3, t4;
      }
      var O2 = { width: "undefined" != typeof window ? window.innerWidth : 300, height: "undefined" != typeof window ? window.innerHeight : 200, numberOfPieces: 200, friction: 0.99, wind: 0, gravity: 0.1, initialVelocityX: 4, initialVelocityY: 10, colors: ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FFC107", "#FF9800", "#FF5722", "#795548"], opacity: 1, debug: false, tweenFunction: s.a.easeInOutQuad, tweenDuration: 5e3, recycle: true, run: true }, w2 = function() {
        function t4(e3, n4) {
          var r3 = this;
          !function(t5, e4) {
            if (!(t5 instanceof e4)) throw new TypeError("Cannot call a class as a function");
          }(this, t4), g2(this, "canvas", void 0), g2(this, "context", void 0), g2(this, "_options", void 0), g2(this, "generator", void 0), g2(this, "rafId", void 0), g2(this, "setOptionsWithDefaults", function(t5) {
            var e4 = { confettiSource: { x: 0, y: 0, w: r3.canvas.width, h: 0 } };
            r3._options = d(d(d({}, e4), O2), t5), Object.assign(r3, t5.confettiSource);
          }), g2(this, "update", function() {
            var t5 = r3.options, e4 = t5.run, n5 = t5.onConfettiComplete, i3 = r3.canvas, o2 = r3.context;
            e4 && (o2.fillStyle = "white", o2.clearRect(0, 0, i3.width, i3.height)), r3.generator.animate() ? r3.rafId = requestAnimationFrame(r3.update) : (n5 && "function" == typeof n5 && r3.generator.particlesGenerated > 0 && n5.call(r3, r3), r3._options.run = false);
          }), g2(this, "reset", function() {
            r3.generator && r3.generator.particlesGenerated > 0 && (r3.generator.particlesGenerated = 0, r3.generator.particles = [], r3.generator.lastNumberOfPieces = 0);
          }), g2(this, "stop", function() {
            r3.options = { run: false }, r3.rafId && (cancelAnimationFrame(r3.rafId), r3.rafId = void 0);
          }), this.canvas = e3;
          var i2 = this.canvas.getContext("2d");
          if (!i2) throw new Error("Could not get canvas context");
          this.context = i2, this.generator = new v2(this.canvas, function() {
            return r3.options;
          }), this.options = n4, this.update();
        }
        var e2, n3;
        return e2 = t4, (n3 = [{ key: "options", get: function() {
          return this._options;
        }, set: function(t5) {
          var e3 = this._options && this._options.run, n4 = this._options && this._options.recycle;
          this.setOptionsWithDefaults(t5), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t5.recycle && t5.recycle && false === n4 && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t5.run && t5.run && false === e3 && this.update();
        } }]) && b(e2.prototype, n3), t4;
      }();
      function m2(t4) {
        return function(t5) {
          if (Array.isArray(t5)) return C2(t5);
        }(t4) || function(t5) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(t5)) return Array.from(t5);
        }(t4) || S2(t4) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function x2(t4) {
        return (x2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
          return typeof t5;
        } : function(t5) {
          return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
        })(t4);
      }
      function P2() {
        return (P2 = Object.assign || function(t4) {
          for (var e2 = 1; e2 < arguments.length; e2++) {
            var n3 = arguments[e2];
            for (var r3 in n3) Object.prototype.hasOwnProperty.call(n3, r3) && (t4[r3] = n3[r3]);
          }
          return t4;
        }).apply(this, arguments);
      }
      function j(t4, e2) {
        var n3 = Object.keys(t4);
        if (Object.getOwnPropertySymbols) {
          var r3 = Object.getOwnPropertySymbols(t4);
          e2 && (r3 = r3.filter(function(e3) {
            return Object.getOwnPropertyDescriptor(t4, e3).enumerable;
          })), n3.push.apply(n3, r3);
        }
        return n3;
      }
      function M2(t4) {
        for (var e2 = 1; e2 < arguments.length; e2++) {
          var n3 = null != arguments[e2] ? arguments[e2] : {};
          e2 % 2 ? j(Object(n3), true).forEach(function(e3) {
            T2(t4, e3, n3[e3]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(n3)) : j(Object(n3)).forEach(function(e3) {
            Object.defineProperty(t4, e3, Object.getOwnPropertyDescriptor(n3, e3));
          });
        }
        return t4;
      }
      function I2(t4, e2) {
        return function(t5) {
          if (Array.isArray(t5)) return t5;
        }(t4) || function(t5, e3) {
          if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t5))) return;
          var n3 = [], r3 = true, i2 = false, o2 = void 0;
          try {
            for (var a2, c2 = t5[Symbol.iterator](); !(r3 = (a2 = c2.next()).done) && (n3.push(a2.value), !e3 || n3.length !== e3); r3 = true) ;
          } catch (t6) {
            i2 = true, o2 = t6;
          } finally {
            try {
              r3 || null == c2.return || c2.return();
            } finally {
              if (i2) throw o2;
            }
          }
          return n3;
        }(t4, e2) || S2(t4, e2) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function S2(t4, e2) {
        if (t4) {
          if ("string" == typeof t4) return C2(t4, e2);
          var n3 = Object.prototype.toString.call(t4).slice(8, -1);
          return "Object" === n3 && t4.constructor && (n3 = t4.constructor.name), "Map" === n3 || "Set" === n3 ? Array.from(t4) : "Arguments" === n3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3) ? C2(t4, e2) : void 0;
        }
      }
      function C2(t4, e2) {
        (null == e2 || e2 > t4.length) && (e2 = t4.length);
        for (var n3 = 0, r3 = new Array(e2); n3 < e2; n3++) r3[n3] = t4[n3];
        return r3;
      }
      function D2(t4, e2) {
        if (!(t4 instanceof e2)) throw new TypeError("Cannot call a class as a function");
      }
      function E2(t4, e2) {
        for (var n3 = 0; n3 < e2.length; n3++) {
          var r3 = e2[n3];
          r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(t4, r3.key, r3);
        }
      }
      function _(t4, e2) {
        return (_ = Object.setPrototypeOf || function(t5, e3) {
          return t5.__proto__ = e3, t5;
        })(t4, e2);
      }
      function R2(t4) {
        var e2 = function() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if ("function" == typeof Proxy) return true;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
            })), true;
          } catch (t5) {
            return false;
          }
        }();
        return function() {
          var n3, r3 = F2(t4);
          if (e2) {
            var i2 = F2(this).constructor;
            n3 = Reflect.construct(r3, arguments, i2);
          } else n3 = r3.apply(this, arguments);
          return k2(this, n3);
        };
      }
      function k2(t4, e2) {
        return !e2 || "object" !== x2(e2) && "function" != typeof e2 ? A2(t4) : e2;
      }
      function A2(t4) {
        if (void 0 === t4) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t4;
      }
      function F2(t4) {
        return (F2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(t5) {
          return t5.__proto__ || Object.getPrototypeOf(t5);
        })(t4);
      }
      function T2(t4, e2, n3) {
        return e2 in t4 ? Object.defineProperty(t4, e2, { value: n3, enumerable: true, configurable: true, writable: true }) : t4[e2] = n3, t4;
      }
      var B2 = a.a.createRef(), N2 = function(t4) {
        !function(t5, e3) {
          if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
          t5.prototype = Object.create(e3 && e3.prototype, { constructor: { value: t5, writable: true, configurable: true } }), e3 && _(t5, e3);
        }(o2, t4);
        var e2, n3, i2 = R2(o2);
        function o2(t5) {
          var e3;
          D2(this, o2);
          for (var n4 = arguments.length, r3 = new Array(n4 > 1 ? n4 - 1 : 0), c2 = 1; c2 < n4; c2++) r3[c2 - 1] = arguments[c2];
          return T2(A2(e3 = i2.call.apply(i2, [this, t5].concat(r3))), "canvas", a.a.createRef()), T2(A2(e3), "confetti", void 0), e3.canvas = t5.canvasRef || B2, e3;
        }
        return e2 = o2, (n3 = [{ key: "componentDidMount", value: function() {
          if (this.canvas.current) {
            var t5 = q2(this.props)[0];
            this.confetti = new w2(this.canvas.current, t5);
          }
        } }, { key: "componentDidUpdate", value: function() {
          var t5 = q2(this.props)[0];
          this.confetti && (this.confetti.options = t5);
        } }, { key: "componentWillUnmount", value: function() {
          this.confetti && this.confetti.stop(), this.confetti = void 0;
        } }, { key: "render", value: function() {
          var t5 = I2(q2(this.props), 2), e3 = t5[0], n4 = t5[1], r3 = M2({ zIndex: 2, position: "absolute", pointerEvents: "none", top: 0, left: 0, bottom: 0, right: 0 }, n4.style);
          return a.a.createElement("canvas", P2({ width: e3.width, height: e3.height, ref: this.canvas }, n4, { style: r3 }));
        } }]) && E2(e2.prototype, n3), o2;
      }(o.Component);
      function q2(t4) {
        var e2 = {}, n3 = {}, r3 = [].concat(m2(Object.keys(O2)), ["confettiSource", "drawShape", "onConfettiComplete"]), i2 = ["canvasRef"];
        for (var o2 in t4) {
          var a2 = t4[o2];
          r3.includes(o2) ? e2[o2] = a2 : i2.includes(o2) ? i2[o2] = a2 : n3[o2] = a2;
        }
        return [e2, n3, {}];
      }
      T2(N2, "defaultProps", M2({}, O2)), T2(N2, "displayName", "ReactConfetti");
      var Q2 = a.a.forwardRef(function(t4, e2) {
        return a.a.createElement(N2, P2({ canvasRef: e2 }, t4));
      });
      e.default = Q2;
    }]).default;
  });
})(reactConfetti_min);
var reactConfetti_minExports = reactConfetti_min.exports;
const ReactConfetti = /* @__PURE__ */ getDefaultExportFromCjs(reactConfetti_minExports);
const Confetti = () => {
  const { selected_individual_line_items, discountPercentageConfigPerItem } = useSelector((state) => state.bundle);
  const unlockedDiscount = getDiscountForItemCount(selected_individual_line_items.length, discountPercentageConfigPerItem);
  const [dimension, setDimention] = reactExports.useState({ width: window.innerWidth, height: window.innerHeight });
  const [showConfetti, setShowConfetti] = reactExports.useState(true);
  const [fadeOut, setFadeOut] = reactExports.useState(false);
  const detectSize = () => {
    setDimention({ width: window.innerWidth, height: window.innerHeight });
  };
  reactExports.useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [dimension]);
  reactExports.useEffect(() => {
    setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setShowConfetti(false);
      }, 500);
    }, 4e3);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    showConfetti && unlockedDiscount > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-confetti-toast", style: { opacity: fadeOut ? 0 : 1 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "fc-confetti-toast__headline", children: [
        "🎉 ",
        unlockedDiscount,
        "% off unlocked!"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fc-confetti-toast__sub", children: "That's our biggest discount" })
    ] }),
    showConfetti && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ReactConfetti,
      {
        width: dimension.width,
        height: dimension.height,
        tweenDuration: 3e3,
        style: {
          position: "fixed",
          right: "0px",
          bottom: "0px",
          left: "0px",
          opacity: fadeOut ? 0 : 1,
          transition: "opacity 1s ease-out",
          zIndex: 9999
        }
      }
    )
  ] });
};
function Spinner() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: "60px", height: "60px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-loader" }) });
}
function SelectConcernWithCheckbox({ selectingConcern }) {
  const dispatch = useDispatch();
  const selected_concerns = useSelector((state) => state.bundle.selected_concerns);
  const concern_models_opened = useSelector((state) => state.bundle.concern_models_opened);
  let disablePrimaryConcern = false;
  if (selectingConcern === "secondary" && selected_concerns[0]) {
    disablePrimaryConcern = true;
  }
  let concernsList = Object.keys(SKIN_CONCERN_PRODUCTS);
  {
    concernsList = concernsList.filter((c) => c !== "(none)");
  }
  let selectedConcernValue = selectingConcern === "primary" ? selected_concerns[0] : selected_concerns[1];
  selectedConcernValue = selectedConcernValue || "";
  const handleConcernSelection = (selectedValue) => {
    let temp = selected_concerns.slice();
    const selectionIndex = temp.findIndex((t2) => t2 === selectedValue);
    if (selectionIndex >= 0) {
      temp[selectionIndex] = "";
    } else {
      if (!temp[0]) {
        temp[0] = selectedValue;
      } else {
        temp[1] = selectedValue;
      }
    }
    temp = temp.filter((t2) => t2);
    if (temp.length === 0) {
      temp = ["", ""];
    } else if (temp.length === 1) {
      temp.push("");
    }
    temp = temp.map((t2) => t2 || "");
    dispatch(setConcern(temp));
    track("concern_selected", { concerns: temp.filter(Boolean), source: "checkbox" });
    handleDropdown(selectingConcern);
  };
  const handleDropdown = (selectingConcern2, closeOthers = false) => {
    const index = getSelectedConcernIndex(selectingConcern2);
    const temp = concern_models_opened.slice();
    temp[index] = !temp[index];
    if (closeOthers) {
      for (let i = 0; i < concern_models_opened.length; i++) {
        if (i !== index) {
          temp[i] = false;
        }
      }
    }
    dispatch(updateConcernModelsOpened(temp));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cbundle_concerns", value: selectedConcernValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "cbundle_concerns_list", children: concernsList.map((option) => {
    disablePrimaryConcern && option === selected_concerns[0];
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "li",
      {
        style: { cursor: "pointer" },
        value: option,
        disabled: false,
        onClick: () => handleConcernSelection(option),
        className: `${selected_concerns.includes(option) ? "selected" : ""}`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", checked: selected_concerns.includes(option), disabled: false, onChange: () => {
          } }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: option }),
          (selected_concerns == null ? void 0 : selected_concerns.length) && selected_concerns[0] === option && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cbundle_badge", children: "Main" })
        ]
      },
      `${selectingConcern}-${option}`
    );
  }) }) });
}
function StickyAddToCard({ onOpenFrequencySheet }) {
  const {
    data: bundleData,
    selected_individual_line_items,
    total_price,
    total_qty,
    updatingCart,
    is_subscription_edit,
    selected_variants,
    subscription_baseline_signature,
    discountPercentageConfigPerItem,
    has_preset_routine
  } = useSelector((state) => state.bundle);
  const [isExpanded, setIsExpanded] = reactExports.useState(has_preset_routine || is_subscription_edit);
  const dispatch = useDispatch();
  if (selected_individual_line_items.length === 0) return null;
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const products = [...Array(Math.max(INITIAL_PLACEHOLDER_ITEMS, selected_individual_line_items.length, Math.min(MAX_ALLOWED_ITEMS, selected_individual_line_items.length + 1))).keys()];
  let mostExpensiveItemIndex = 3;
  let mostExpensiveItemPrice = 0;
  for (let i = 0; i < selected_individual_line_items.length; i++) {
    if (Number(selected_individual_line_items[i].price) > mostExpensiveItemPrice) {
      mostExpensiveItemPrice = Number(selected_individual_line_items[i].price);
      mostExpensiveItemIndex = i;
    }
  }
  const hasOutOfStockVariantSelected = selected_individual_line_items.find((v2) => v2.outOfStock);
  const hasNoSubscriptionChanges = is_subscription_edit && getBundleSignature(selected_variants) === subscription_baseline_signature;
  const { message: discountMessage, discount: currentDiscountPercentage } = getDiscountMessage(selected_individual_line_items, discountPercentageConfigPerItem);
  const discountedTotalPrice = currentDiscountPercentage > 0 ? (total_price || 0) - (total_price || 0) * (currentDiscountPercentage / 100) : total_price || 0;
  const savedAmount = total_price - discountedTotalPrice;
  const handleCtaClick = () => {
    if (!is_subscription_edit) {
      onOpenFrequencySheet();
      return;
    }
    track("add_to_cart_clicked", {
      item_count: selected_individual_line_items.length,
      total_price,
      discounted_price: discountedTotalPrice,
      is_editing: true,
      source: "sticky_add_to_cart"
    });
    dispatch(updateExistingBundle()).then((result) => {
      var _a2;
      if (result.meta.requestStatus === "fulfilled") {
        track("bundle_added_to_cart", {
          item_count: selected_individual_line_items.length,
          total_price,
          discounted_price: discountedTotalPrice,
          is_editing: true,
          source: "sticky_add_to_cart"
        });
      } else {
        track("bundle_add_to_cart_failed", { error: String(((_a2 = result.error) == null ? void 0 : _a2.message) || "unknown"), source: "sticky_add_to_cart" });
      }
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle-sticky-add-to-cart", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-collapse-expand-section", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { onClick: toggleExpand, className: `cpbundle-expand-button ${isExpanded ? "expanded" : ""}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: isExpanded ? "HIDE" : "EXPAND" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "8", viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.6925 0.557809C13.6345 0.499699 13.5656 0.453599 13.4897 0.422146C13.4138 0.390694 13.3325 0.374506 13.2503 0.374506C13.1682 0.374506 13.0869 0.390694 13.011 0.422146C12.9351 0.453599 12.8662 0.499699 12.8082 0.557809L7.00035 6.3664L1.19253 0.557809C1.07526 0.440533 0.9162 0.374649 0.750347 0.374649C0.584495 0.374649 0.425435 0.440533 0.30816 0.557809C0.190885 0.675084 0.125 0.834144 0.125 0.999997C0.125 1.16585 0.190885 1.32491 0.30816 1.44218L6.55816 7.69218C6.61621 7.75029 6.68514 7.79639 6.76101 7.82785C6.83688 7.8593 6.91821 7.87549 7.00035 7.87549C7.08248 7.87549 7.16381 7.8593 7.23969 7.82785C7.31556 7.79639 7.38449 7.75029 7.44254 7.69218L13.6925 1.44218C13.7506 1.38414 13.7967 1.31521 13.8282 1.23933C13.8597 1.16346 13.8758 1.08213 13.8758 0.999997C13.8758 0.917862 13.8597 0.836533 13.8282 0.760659C13.7967 0.684785 13.7506 0.615854 13.6925 0.557809Z", fill: "#66635C" }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-sticky-add-to-cart__bundle-info", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "bundle-discount-message", dangerouslySetInnerHTML: { __html: discountMessage } }) }),
    isExpanded && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-bundle-section", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle-bundle-family__cirle", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-bundle-header", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-bundle-title" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-products-list", children: products.map((index) => {
        const currentVariant = selected_individual_line_items[index];
        const currentProduct = bundleData.products.find((p2) => p2.shopifyProductId == (currentVariant == null ? void 0 : currentVariant.shopifyProductId));
        const isFreeProduct = index === mostExpensiveItemIndex && selected_individual_line_items.length >= 4;
        const hasFreeBadge = selected_individual_line_items.length < 4 && index === 3 ? true : isFreeProduct;
        const isOutOfStock = currentVariant == null ? void 0 : currentVariant.outOfStock;
        const currentProductdiscount = getDiscountForItemCount(index + 1, discountPercentageConfigPerItem);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `cpbundle-product-item ${isOutOfStock ? "is-out-of-stock" : ""} ${(isFreeProduct || hasFreeBadge) && "is-free-product"}`, children: [
          currentVariant && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              className: "cpbundle-remove-product",
              onClick: () => {
                dispatch(updateProductQty({
                  selected_quantity: 0,
                  shopifyProductId: currentProduct.shopifyProductId,
                  selected_variant_id: currentVariant == null ? void 0 : currentVariant.shopifyId
                }));
                trackProductQtyChange({
                  product: currentProduct,
                  price: currentVariant == null ? void 0 : currentVariant.price,
                  previousQuantity: currentProduct.selected_quantity,
                  newQuantity: 0,
                  source: "sticky_add_to_cart"
                });
              },
              children: "✕"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle-product-image", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: (currentVariant == null ? void 0 : currentVariant.image) || "https://cdn.shopify.com/s/files/1/1919/1971/files/no-product.png?v=1736696073", alt: (currentVariant == null ? void 0 : currentVariant.image) || "Add product" }),
            currentProductdiscount > 0 && !currentVariant && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__off-text", children: [
              currentProductdiscount,
              "% off",
              /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
              " Total"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-product-info", children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle-product-name", children: (currentProduct == null ? void 0 : currentProduct.shortName) || (currentProduct == null ? void 0 : currentProduct.productTitle) }) })
        ] }, `sticky-add-to-cart-${index}`);
      }) })
    ] }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-cart-section", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle-price-details", "data-zero-section": (selected_individual_line_items == null ? void 0 : selected_individual_line_items.length) === 0 ? "true" : "false", "data-has-discount": Number(savedAmount) > 0 ? "true" : "false", children: [
      savedAmount > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-savings", "data-is-empty": "false", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "cpbundle-save-amount", children: [
        "You save ",
        window.getCurrencySymbol(),
        Number(savedAmount).toFixed(2)
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cpbundle-subtotal", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", gap: "10px", alignItems: "center", flexWrap: "nowrap", justifyContent: "flex-end" }, children: [
        selected_individual_line_items.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { textDecoration: "line-through", fontWeight: "600", fontSize: "16px", color: "#66635C" }, children: [
          window.getCurrencySymbol(),
          Number(total_price).toFixed(2)
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "cpbundle-amount", children: [
          window.getCurrencySymbol(),
          Number(discountedTotalPrice).toFixed(2)
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          className: `cpbundle-add-to-cart-btn${updatingCart ? " is-loading" : ""}`,
          disabled: total_qty < MIN_ALLOWED_ITEMS || updatingCart || hasOutOfStockVariantSelected || hasNoSubscriptionChanges,
          onClick: handleCtaClick,
          children: updatingCart ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle-btn-spinner", "aria-hidden": "true" }),
            is_subscription_edit ? "Updating..." : "Adding..."
          ] }) : is_subscription_edit ? "Update Bundle" : "Add to Cart"
        }
      )
    ] }) })
  ] });
}
function StepComponent({ stepTitle = "NEXT STEP", needHelpRef, children, hideArrowIcon = false }) {
  const [isOpen, setIsOpen] = reactExports.useState(false);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "step-container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "step-container-content", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: toggleOpen, ref: needHelpRef, children: !hideArrowIcon && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "step-header", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: stepTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: `cpbundle-step-expand-button ${!isOpen ? "expanded" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: "angle-icon", width: "14", height: "8", viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.6925 0.557809C13.6345 0.499699 13.5656 0.453599 13.4897 0.422146C13.4138 0.390694 13.3325 0.374506 13.2503 0.374506C13.1682 0.374506 13.0869 0.390694 13.011 0.422146C12.9351 0.453599 12.8662 0.499699 12.8082 0.557809L7.00035 6.3664L1.19253 0.557809C1.07526 0.440533 0.9162 0.374649 0.750347 0.374649C0.584495 0.374649 0.425435 0.440533 0.30816 0.557809C0.190885 0.675084 0.125 0.834144 0.125 0.999997C0.125 1.16585 0.190885 1.32491 0.30816 1.44218L6.55816 7.69218C6.61621 7.75029 6.68514 7.79639 6.76101 7.82785C6.83688 7.8593 6.91821 7.87549 7.00035 7.87549C7.08248 7.87549 7.16381 7.8593 7.23969 7.82785C7.31556 7.79639 7.38449 7.75029 7.44254 7.69218L13.6925 1.44218C13.7506 1.38414 13.7967 1.31521 13.8282 1.23933C13.8597 1.16346 13.8758 1.08213 13.8758 0.999997C13.8758 0.917862 13.8597 0.836533 13.8282 0.760659C13.7967 0.684785 13.7506 0.615854 13.6925 0.557809Z", fill: "#66635C" }) }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `step-content ${isOpen ? "open" : "open"}`, children })
  ] }) });
}
function SelectedProductCard(props) {
  const { handleOpenCorrespondingQuickView, selected_individual_line_items, index, bundleData, show_cards_fade_effect, serumsElementRef, discountPercentageConfigPerItem } = props;
  const currentVariant = selected_individual_line_items[index];
  const currentProduct = bundleData.products.find((p2) => p2.shopifyProductId == (currentVariant == null ? void 0 : currentVariant.shopifyProductId));
  const isFreeProduct = false;
  const isOutOfStock = currentVariant == null ? void 0 : currentVariant.outOfStock;
  let originalPrice = currentVariant ? currentVariant.price : 0;
  const { message: discountMessage, discount: currentDiscountPercentage } = getDiscountMessage(selected_individual_line_items, discountPercentageConfigPerItem);
  let discountedPrice = currentProduct && currentDiscountPercentage ? originalPrice - originalPrice * (currentDiscountPercentage / 100) : originalPrice;
  const dispatch = useDispatch();
  const currentProductdiscount = getDiscountForItemCount(index + 1, discountPercentageConfigPerItem);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `cpbundle__goals__cards  ${show_cards_fade_effect ? "show-cards-fade-effect" : ""} ${isOutOfStock ? "is-out-of-stock" : ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "article",
    {
      className: `cpbundle__goals__card cpbundle__goals__card--active ${!currentVariant ? "empty" : ""}`,
      style: {
        justifyContent: (currentVariant == null ? void 0 : currentVariant.image) ? "space-around" : "center"
      },
      onClick: (event) => {
        if (event.target.nodeName === "IMG" || event.target.nodeName === "P") {
          handleOpenCorrespondingQuickView(currentProduct);
        }
        if (currentProduct) return;
        serumsElementRef.current.scrollIntoView({ behavior: "smooth" });
      },
      children: [
        currentVariant && // <svg
        //   onClick={() => {
        //     dispatch(updateProductQty({
        //       selected_quantity: 0,
        //       shopifyProductId: currentProduct.shopifyProductId,
        //       selected_variant_id: currentVariant?.shopifyId,
        //     }))
        //   }}
        //   className='cpbundle_cross_icon' width="30" height="40" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        //   <path d="M17.354 16.1463C17.4005 16.1927 17.4373 16.2479 17.4625 16.3086C17.4876 16.3693 17.5006 16.4343 17.5006 16.5C17.5006 16.5657 17.4876 16.6308 17.4625 16.6915C17.4373 16.7522 17.4005 16.8073 17.354 16.8538C17.3076 16.9002 17.2524 16.9371 17.1917 16.9622C17.131 16.9874 17.066 17.0003 17.0003 17.0003C16.9346 17.0003 16.8695 16.9874 16.8088 16.9622C16.7481 16.9371 16.693 16.9002 16.6465 16.8538L12.5003 12.7069L8.35403 16.8538C8.26021 16.9476 8.13296 17.0003 8.00028 17.0003C7.8676 17.0003 7.74035 16.9476 7.64653 16.8538C7.55271 16.76 7.5 16.6327 7.5 16.5C7.5 16.3674 7.55271 16.2401 7.64653 16.1463L11.7934 12L7.64653 7.85378C7.55271 7.75996 7.5 7.63272 7.5 7.50003C7.5 7.36735 7.55271 7.2401 7.64653 7.14628C7.74035 7.05246 7.8676 6.99976 8.00028 6.99976C8.13296 6.99976 8.26021 7.05246 8.35403 7.14628L12.5003 11.2932L16.6465 7.14628C16.7403 7.05246 16.8676 6.99976 17.0003 6.99976C17.133 6.99976 17.2602 7.05246 17.354 7.14628C17.4478 7.2401 17.5006 7.36735 17.5006 7.50003C17.5006 7.63272 17.4478 7.75996 17.354 7.85378L13.2072 12L17.354 16.1463Z" fill="#666" />
        // </svg>
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            className: "cpbundle-remove-product placeholder-cards",
            onClick: () => {
              dispatch(updateProductQty({
                selected_quantity: 0,
                shopifyProductId: currentProduct.shopifyProductId,
                selected_variant_id: currentVariant == null ? void 0 : currentVariant.shopifyId
              }));
              trackProductQtyChange({
                product: currentProduct,
                price: currentVariant == null ? void 0 : currentVariant.price,
                previousQuantity: currentProduct.selected_quantity,
                newQuantity: 0,
                source: "selected_product_card"
              });
            },
            children: "✕"
          }
        ),
        (currentVariant == null ? void 0 : currentVariant.image) && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: currentVariant == null ? void 0 : currentVariant.image, alt: "Add products" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__goals__card__step_free--text", children: [
          !(currentVariant == null ? void 0 : currentVariant.image) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__goals__card__step_add--product", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "cpbundle-product-image ", src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_placeholder.png?v=1744133300", alt: "Add product" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: "cpbundle__goals__card__step_plus--icon", width: "29", height: "28", viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M25.25 14C25.25 14.2321 25.1578 14.4546 24.9937 14.6187C24.8296 14.7828 24.6071 14.875 24.375 14.875H15.625V23.625C15.625 23.8571 15.5328 24.0796 15.3687 24.2437C15.2046 24.4078 14.9821 24.5 14.75 24.5C14.5179 24.5 14.2954 24.4078 14.1313 24.2437C13.9672 24.0796 13.875 23.8571 13.875 23.625V14.875H5.125C4.89294 14.875 4.67038 14.7828 4.50628 14.6187C4.34219 14.4546 4.25 14.2321 4.25 14C4.25 13.7679 4.34219 13.5454 4.50628 13.3813C4.67038 13.2172 4.89294 13.125 5.125 13.125H13.875V4.375C13.875 4.14294 13.9672 3.92038 14.1313 3.75628C14.2954 3.59219 14.5179 3.5 14.75 3.5C14.9821 3.5 15.2046 3.59219 15.3687 3.75628C15.5328 3.92038 15.625 4.14294 15.625 4.375V13.125H24.375C24.6071 13.125 24.8296 13.2172 24.9937 13.3813C25.1578 13.5454 25.25 13.7679 25.25 14Z", fill: "#E04184" }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "cpbundel--product__title", children: [
            " ",
            currentProduct == null ? void 0 : currentProduct.productTitle
          ] }),
          currentVariant && !isOutOfStock && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: { fontSize: "14px", fontWeight: 700 }, className: "price-details", children: [
            originalPrice > discountedPrice && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "original-price", children: [
              window.getCurrencySymbol(),
              Number(originalPrice).toFixed(2)
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "current-price", children: [
              window.getCurrencySymbol(),
              Number(discountedPrice).toFixed(2)
            ] })
          ] }),
          currentVariant && isOutOfStock && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { fontSize: "14px", color: "red", fontWeight: 700 }, children: "Sold out" }),
          (currentVariant == null ? void 0 : currentVariant.price) && isFreeProduct && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "cpbundel--product__title__save", style: { fontSize: "16px", lineHeight: "normal", color: "rgb(226, 40, 130)" }, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { fontSize: "14px" }, children: "You save" }),
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
              " $",
              currentVariant == null ? void 0 : currentVariant.price
            ] })
          ] })
        ] }),
        currentProductdiscount > 0 && !(currentProduct == null ? void 0 : currentProduct.productTitle) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__off-text", children: [
          currentProductdiscount,
          "% ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
          " OFF"
        ] })
      ]
    }
  ) }, index);
}
function ModalComponent({ isOpen, onClose, children }) {
  reactExports.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modal-overlay", onClick: handleOverlayClick, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "modal-content", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: "100%", height: "1rem" } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "modal-close", onClick: onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
    ] }) }),
    children
  ] }) });
}
function LearnMoreModal() {
  const dispatch = useDispatch();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalComponent, { isOpen: true, onClose: () => {
    dispatch(setShowLearnMoreModal(false));
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_popup_header.jpg?v=1746590448", alt: "Family Circle" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: "background-color: #fafafa;\n        border: 1px solid #cecece;\n        border-radius: 8px;\n        padding: 12px;\n        font-size: 16px;\n        max-width: 600px;\n        margin: 0 auto; text-align: left;", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: "list-style: none; padding-left: 20px; margin-top: 10px;", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: "padding-bottom: 10px;", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: "font-weight: 800;", children: "Choose 4 Items, the Most Expensive is Free" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: "color: #7a787d ;", children: "Our most incredible deal!" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: "padding-bottom: 10px;", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: "font-weight: 800;", children: "Flexibility For Your Routine" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: "color: #7a787d ;", children: "Swap items in your bundle any time" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { style: "padding-bottom: 10px;", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: "font-weight: 800;", children: "Full Flexibility with Your Subscripion" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: "color: #7a787d ;", children: "Skip, pause, delay or cancel anytime" })
      ] })
    ] }) })
  ] });
}
function HorizontalScroller({ children, itemCount, scrollableClassName = "" }) {
  const scrollContainerRef = reactExports.useRef(null);
  const [canScrollLeft, setCanScrollLeft] = reactExports.useState(false);
  const [canScrollRight, setCanScrollRight] = reactExports.useState(false);
  const checkScrollability = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollLeft = Math.ceil(container.scrollLeft);
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const maxScrollLeft = scrollWidth - clientWidth;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < maxScrollLeft - 1);
    }
  };
  reactExports.useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    checkScrollability();
    container.addEventListener("scroll", checkScrollability, { passive: true });
    const resizeObserver = new ResizeObserver(checkScrollability);
    resizeObserver.observe(container);
    return () => {
      container.removeEventListener("scroll", checkScrollability);
      resizeObserver.disconnect();
    };
  }, [itemCount]);
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.clientWidth * 0.8;
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth"
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__goals-wrapper", children: [
    canScrollLeft && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: "cpbundle__scroll-arrow cpbundle__scroll-arrow--left",
        onClick: () => scroll("left"),
        "aria-label": "Scroll left",
        disabled: !canScrollLeft,
        children: "‹"
      }
    ),
    React$1.cloneElement(React$1.Children.only(children), {
      ref: scrollContainerRef,
      // Add the passed className and potentially others needed for scrolling styles
      className: `${children.props.className || ""} ${scrollableClassName}`.trim()
    }),
    canScrollRight && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        type: "button",
        className: "cpbundle__scroll-arrow cpbundle__scroll-arrow--right",
        onClick: () => scroll("right"),
        "aria-label": "Scroll right",
        disabled: !canScrollRight,
        children: "›"
      }
    )
  ] });
}
function FCPerks() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-modal-perks-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-modal-perk", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_icon_save.webp?v=1750960496" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "custom-modal-perk-text", children: "SAVE UP TO 20% ON EVERY ORDER" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-modal-perk", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_icon_shipping.webp?v=1750960496" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "custom-modal-perk-text", children: "FREE US SHIPPING ON EVERY ORDER" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-modal-perk", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_icon_swap.webp?v=1750960496" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "custom-modal-perk-text", children: "SWITCH PRODUCTS EVERY SHIPMENT" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-modal-perk", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_icon_edit.webp?v=1750960496" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "custom-modal-perk-text", children: "RESCHEDULE OR CANCEL ANY TIME" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "custom-modal-perk", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_icon_oos.webp?v=1750960496" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "custom-modal-perk-text", children: "100-DAY MONEY-BACK GUARANTEE" })
    ] })
  ] });
}
const TESTIMONIALS = [
  {
    initials: "SM",
    photo: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_testimonial_1.jpg?v=1779742430",
    photoPosition: "center 20%",
    quote: "Consistency changed everything for my skin. I’ve never felt more confident going makeup-free.",
    name: "Sarah M.",
    since: "2025"
  },
  {
    initials: "DL",
    photo: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_testimonial_2.jpg?v=1779742442",
    quote: "It just shows up before I run out. I haven’t missed a day in over a year.",
    name: "Dana L.",
    since: "2025"
  },
  {
    initials: "RK",
    photo: "https://cdn.shopify.com/s/files/1/1919/1971/files/fc_tt3.png?v=1779743005",
    photoPosition: "center 30%",
    quote: "Same routine on autopilot, at the lowest price they offer. I stopped thinking about it and my skin got better.",
    name: "Renee K.",
    since: "2026"
  }
];
function Hero() {
  const trackRef = reactExports.useRef(null);
  const [activeSlide, setActiveSlide] = reactExports.useState(0);
  const handleBuildClick = () => {
    const target = document.querySelector(".cpbundle__container");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const handleTrackScroll = () => {
    const track2 = trackRef.current;
    if (!track2) return;
    const trackLeft = track2.getBoundingClientRect().left;
    let nearest = 0;
    let shortest = Infinity;
    Array.from(track2.children).forEach((card, i) => {
      const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
      if (distance < shortest) {
        shortest = distance;
        nearest = i;
      }
    });
    setActiveSlide(nearest);
  };
  const scrollToSlide = (index) => {
    const track2 = trackRef.current;
    const cards = track2 && Array.from(track2.children);
    if (!cards || !cards.length) return;
    const first = cards[0].getBoundingClientRect();
    const step = cards.length > 1 ? cards[1].getBoundingClientRect().left - first.left : first.width;
    track2.scrollTo({ left: index * step, behavior: "smooth" });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__top", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__content", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__hero-block", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              className: "fc-hero__img--mobile",
              src: "https://cdn.shopify.com/s/files/1/1919/1971/files/hand-wrk-fc-hero.jpg?v=1780286234",
              alt: "",
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__hero-block-content", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__eyebrow", children: "Family Circle Subscription" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("h1", { className: "fc-hero__headline", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fc-hero__headline-line", children: "Your best skin" }),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fc-hero__headline-line", children: "at our best price." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "fc-hero__sub", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "fc-hero__sub-line", children: [
            "Subscribe and save. 7% off 2 items. 15% off 3 items. ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "20% off 4+ items." })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fc-hero__sub-line", children: "Free shipping forever" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "fc-hero__sub-line", children: "Swap products, pause or cancel anytime" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__divider", "aria-hidden": "true" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__proof", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__proof-avatars", "aria-hidden": "true", children: TESTIMONIALS.map((t2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: t2.photo,
              alt: "",
              style: t2.photoPosition ? { objectPosition: t2.photoPosition } : void 0
            },
            t2.initials
          )) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "fc-hero__proof-text", children: [
            "Join ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "15,000+" }),
            " Family Circle subscribers"
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__cta-row", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "fc-hero__cta", onClick: handleBuildClick, children: "Get started" }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__right", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__img fc-hero__img--desktop", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          src: "https://cdn.shopify.com/s/files/1/1919/1971/files/hand-wrk-fc-hero.jpg?v=1780286234",
          alt: "Family Circle",
          onError: (e) => {
            e.target.style.display = "none";
          }
        }
      ) }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__social-section", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__testimonials-header", children: [
        "Join ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "15,000+" }),
        " Family Circle subscribers"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__testimonials", ref: trackRef, onScroll: handleTrackScroll, children: TESTIMONIALS.map((t2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__testimonial-card", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__testimonial-avatar", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: t2.photo,
            alt: "",
            "aria-hidden": "true",
            style: t2.photoPosition ? { objectPosition: t2.photoPosition } : void 0
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-hero__testimonial-text", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "fc-hero__testimonial-quote", children: [
            "“",
            t2.quote,
            "”"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "fc-hero__testimonial-byline", children: [
            t2.name,
            " · since ",
            t2.since
          ] })
        ] })
      ] }, t2.initials)) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-hero__dots", children: TESTIMONIALS.map((t2, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          className: `fc-hero__dot${i === activeSlide ? " is-active" : ""}`,
          "aria-label": `Show testimonial ${i + 1} of ${TESTIMONIALS.length}`,
          "aria-current": i === activeSlide,
          onClick: () => scrollToSlide(i)
        },
        t2.initials
      )) })
    ] })
  ] });
}
function DeliveryFrequencySheet({ isOpen, onClose }) {
  var _a2;
  const dispatch = useDispatch();
  const {
    data: bundleData,
    selected_individual_line_items,
    total_price,
    updatingCart,
    is_editing,
    is_subscription_edit,
    selected_variants,
    subscription_baseline_signature,
    discountPercentageConfigPerItem,
    selected_selling_plan
  } = useSelector((state) => state.bundle);
  const sellingPlans = (bundleData == null ? void 0 : bundleData.sellingPlans) || [];
  const hasNoSubscriptionChanges = is_subscription_edit && getBundleSignature(selected_variants) === subscription_baseline_signature;
  const { discount: currentDiscountPercentage } = getDiscountMessage(selected_individual_line_items, discountPercentageConfigPerItem);
  const discountedTotalPrice = currentDiscountPercentage > 0 ? total_price - total_price * (currentDiscountPercentage / 100) : total_price;
  reactExports.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);
  const handleAddToCart = () => {
    track("add_to_cart_clicked", {
      item_count: selected_individual_line_items.length,
      total_price,
      discounted_price: discountedTotalPrice,
      selling_plan_name: selected_selling_plan == null ? void 0 : selected_selling_plan.custom_name,
      is_editing,
      source: "delivery_frequency_sheet"
    });
    const action = is_subscription_edit ? updateExistingBundle() : addBundleToCart();
    dispatch(action).then((result) => {
      var _a3;
      if (result.meta.requestStatus === "fulfilled") {
        track("bundle_added_to_cart", {
          item_count: selected_individual_line_items.length,
          total_price,
          discounted_price: discountedTotalPrice,
          selling_plan_name: selected_selling_plan == null ? void 0 : selected_selling_plan.custom_name,
          is_editing,
          source: "delivery_frequency_sheet"
        });
      } else {
        track("bundle_add_to_cart_failed", { error: String(((_a3 = result.error) == null ? void 0 : _a3.message) || "unknown"), source: "delivery_frequency_sheet" });
      }
      onClose();
    });
  };
  const getMostPopularPlanName = () => "2 months";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: `freq-sheet__overlay ${isOpen ? "open" : ""}`,
        onClick: onClose
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `freq-sheet ${isOpen ? "open" : ""}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__handle" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__title", children: "How often should we ship?" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "freq-sheet__sub", children: "You can change, skip or cancel anytime." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__options", children: sellingPlans.map((plan) => {
        const isSelected = plan.sellingPlanId === (selected_selling_plan == null ? void 0 : selected_selling_plan.sellingPlanId);
        const isMostPopular = plan.custom_name === getMostPopularPlanName();
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `freq-sheet__option ${isSelected ? "selected" : ""}`,
            onClick: () => {
              dispatch(setSellingPlan(plan));
              track("selling_plan_selected", { selling_plan_id: plan.sellingPlanId, selling_plan_name: plan.custom_name, source: "delivery_frequency_sheet" });
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__radio", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__radio-dot" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__label", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "freq-sheet__label-title", children: [
                "Every ",
                plan.custom_name
              ] }) }),
              isMostPopular && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "freq-sheet__tag", children: "Most popular" })
            ]
          },
          plan.sellingPlanId
        );
      }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          className: `freq-sheet__cta${updatingCart ? " is-loading" : ""}`,
          disabled: updatingCart || !selected_selling_plan || hasNoSubscriptionChanges,
          onClick: handleAddToCart,
          children: updatingCart ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "cpbundle-btn-spinner", "aria-hidden": "true" }),
            is_subscription_edit ? "Updating..." : "Adding..."
          ] }) : `${is_subscription_edit ? "Update Bundle" : "Add to Cart"} — ${((_a2 = window.getCurrencySymbol) == null ? void 0 : _a2.call(window)) || "$"}${discountedTotalPrice.toFixed(2)}`
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "freq-sheet__cancel", onClick: onClose, children: "Go back" })
    ] })
  ] });
}
function BuilderSidebar() {
  var _a2, _b2, _c;
  const dispatch = useDispatch();
  const {
    data: bundleData,
    selected_individual_line_items,
    total_price,
    updatingCart,
    is_editing,
    is_subscription_edit,
    selected_variants,
    subscription_baseline_signature,
    discountPercentageConfigPerItem,
    selected_selling_plan,
    has_preset_routine
  } = useSelector((state) => state.bundle);
  const hasNoSubscriptionChanges = is_subscription_edit && getBundleSignature(selected_variants) === subscription_baseline_signature;
  const sellingPlans = (bundleData == null ? void 0 : bundleData.sellingPlans) || [];
  const { message: discountMessage, discount: currentDiscountPercentage } = getDiscountMessage(selected_individual_line_items, discountPercentageConfigPerItem);
  const discountedTotalPrice = currentDiscountPercentage > 0 ? total_price - total_price * (currentDiscountPercentage / 100) : total_price;
  const savedAmount = total_price - discountedTotalPrice;
  const hasOutOfStockVariantSelected = selected_individual_line_items.find((v2) => v2.outOfStock);
  const slots = [...Array(Math.max(INITIAL_PLACEHOLDER_ITEMS, selected_individual_line_items.length, Math.min(MAX_ALLOWED_ITEMS, selected_individual_line_items.length + 1))).keys()];
  const handleAddToCart = () => {
    track("add_to_cart_clicked", {
      item_count: selected_individual_line_items.length,
      total_price,
      discounted_price: discountedTotalPrice,
      selling_plan_name: selected_selling_plan == null ? void 0 : selected_selling_plan.custom_name,
      is_editing,
      source: "builder_sidebar"
    });
    const action = is_subscription_edit ? updateExistingBundle() : addBundleToCart();
    dispatch(action).then((result) => {
      var _a3;
      if (result.meta.requestStatus === "fulfilled") {
        track("bundle_added_to_cart", {
          item_count: selected_individual_line_items.length,
          total_price,
          discounted_price: discountedTotalPrice,
          selling_plan_name: selected_selling_plan == null ? void 0 : selected_selling_plan.custom_name,
          is_editing,
          source: "builder_sidebar"
        });
      } else {
        track("bundle_add_to_cart_failed", { error: String(((_a3 = result.error) == null ? void 0 : _a3.message) || "unknown"), source: "builder_sidebar" });
      }
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "builder-sidebar", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__inner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "builder-sidebar__title", children: has_preset_routine ? "Your Routine" : "Your Picks" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "builder-sidebar__nudge", dangerouslySetInnerHTML: { __html: discountMessage } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "builder-sidebar__items", children: slots.map((index) => {
      const currentVariant = selected_individual_line_items[index];
      const currentProduct = currentVariant ? bundleData.products.find((p2) => p2.shopifyProductId == currentVariant.shopifyProductId) : null;
      const nextDiscount = getDiscountForItemCount(index + 1, discountPercentageConfigPerItem);
      if (currentVariant && currentProduct) {
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__item", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__item-img", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: currentVariant.image, alt: currentProduct.productTitle }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                className: "builder-sidebar__item-remove",
                onClick: () => {
                  dispatch(updateProductQty({
                    selected_quantity: 0,
                    shopifyProductId: currentProduct.shopifyProductId,
                    selected_variant_id: currentVariant.shopifyId
                  }));
                  trackProductQtyChange({
                    product: currentProduct,
                    price: currentVariant.price,
                    previousQuantity: currentProduct.selected_quantity,
                    newQuantity: 0,
                    source: "builder_sidebar"
                  });
                },
                children: "✕"
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "builder-sidebar__item-name", children: currentProduct.shortName || currentProduct.productTitle })
        ] }, `sidebar-item-${index}`);
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "builder-sidebar__item builder-sidebar__item--empty", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__item-img builder-sidebar__item-img--placeholder", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: "https://cdn.shopify.com/s/files/1/1919/1971/files/no-product.png?v=1736696073", alt: "Add product" }),
        nextDiscount > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "builder-sidebar__item-discount", children: [
          nextDiscount,
          "% off",
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
          "Total"
        ] })
      ] }) }, `sidebar-item-${index}`);
    }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__summary", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__row", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Regular Price" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ((_a2 = window.getCurrencySymbol) == null ? void 0 : _a2.call(window)) || "$",
          total_price.toFixed(2)
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__row builder-sidebar__row--savings", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Family Circle Discount" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          currentDiscountPercentage > 0 && `(${currentDiscountPercentage}% off) `,
          savedAmount > 0 ? `−${((_b2 = window.getCurrencySymbol) == null ? void 0 : _b2.call(window)) || "$"}${savedAmount.toFixed(2)}` : "—"
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__row builder-sidebar__row--shipping", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Shipping" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Free Forever" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__row builder-sidebar__row--total", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Total" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ((_c = window.getCurrencySymbol) == null ? void 0 : _c.call(window)) || "$",
          discountedTotalPrice.toFixed(2)
        ] })
      ] })
    ] }),
    !is_subscription_edit && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "builder-sidebar__frequency", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("label", { className: "builder-sidebar__freq-title", htmlFor: "builder-sidebar-freq", children: "Deliver every" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "select",
        {
          id: "builder-sidebar-freq",
          className: "builder-sidebar__freq-select",
          value: (selected_selling_plan == null ? void 0 : selected_selling_plan.sellingPlanId) || "",
          onChange: (e) => {
            const plan = sellingPlans.find((p2) => String(p2.sellingPlanId) === e.target.value);
            if (plan) {
              dispatch(setSellingPlan(plan));
              track("selling_plan_selected", { selling_plan_id: plan.sellingPlanId, selling_plan_name: plan.custom_name, source: "builder_sidebar" });
            }
          },
          children: sellingPlans.map((plan) => /* @__PURE__ */ jsxRuntimeExports.jsxs("option", { value: plan.sellingPlanId, children: [
            plan.custom_name,
            plan.custom_name === "2 months" ? " (most popular)" : ""
          ] }, plan.sellingPlanId))
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        className: "builder-sidebar__cta",
        disabled: selected_individual_line_items.length < MIN_ALLOWED_ITEMS || updatingCart || hasOutOfStockVariantSelected || hasNoSubscriptionChanges,
        onClick: handleAddToCart,
        children: updatingCart ? is_subscription_edit ? "Updating..." : "Adding..." : is_subscription_edit ? "Update Bundle" : "Add to Cart"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "builder-sidebar__notes", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: "100-day free returns." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: "Free shipping, forever." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: "Swap products, pause, or cancel anytime." })
    ] })
  ] }) });
}
function ConcernFilter({ selectedConcern, onSelectConcern }) {
  const dispatch = useDispatch();
  const is_subscription_edit = useSelector((state) => state.bundle.is_subscription_edit);
  const handleClick = (value) => {
    onSelectConcern(value);
    dispatch(expandFirstVisibleCategory(value));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "concern-filter-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "concern-filter", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "concern-filter__title", children: "Show products for" }),
    !is_subscription_edit && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "concern-filter__quiz-link", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Not sure where to start?" }),
      " Take our ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://maelove.com/pages/routine-finder", children: "Skin Quiz" }),
      "."
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "concern-filter__pills", children: CONCERN_FILTERS.map((concern) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        className: `concern-filter__btn ${selectedConcern === concern.value ? "selected" : ""}`,
        onClick: () => handleClick(concern.value),
        children: concern.label
      },
      concern.value
    )) })
  ] }) });
}
const FAQ_ITEMS = [
  {
    q: "What are the perks of Family Circle subscription?",
    a: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Family Circle is our subscription membership that gives you unprecedented freedom and flexibility when it comes to your skincare routine. Here are the perks:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ol", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Enjoy discounts on every shipment:" }),
          " Discounts start with 2 item bundles and go up to 20% off on bundles of 4 items or more. You can choose to receive shipments every 1, 2, 3, or 4 months. Shipping is always free."
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Product Flexibility:" }),
          " You're not locked into receiving the same products each shipment. You can change any or all of the products included in each recurring order."
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Guaranteed Stock:" }),
          " Family Circle members get guaranteed stock of their favorite products, even when they're sold out on the website."
        ] })
      ] })
    ] })
  },
  {
    q: "Can I change products in each shipment?",
    a: "Absolutely! You have the flexibility to swap out any or all of the products in your subscription each cycle. You'll receive an email reminder allowing you to make changes a few days before your replenishment order is set to ship. There is no limit on how many times you can swap your products. However, please note that final changes must be completed before your products ship. We are unable to edit your order once the items have shipped."
  },
  {
    q: "Is shipping free?",
    a: "Shipping is always free with Family Circle shipments within the US."
  },
  {
    q: "How frequent is each shipment?",
    a: "Choose a delivery schedule that works for you - every 1, 2, 3, or 4 months. You can change your frequency at any time."
  },
  {
    q: "Can I postpone or move my shipment dates?",
    a: "You can easily postpone or get your order sooner by logging into your account and adjusting your next shipment date."
  },
  {
    q: "What if I forget to review my upcoming shipment?",
    a: "If you don't make any changes, you'll receive the same set of products as your previous shipment."
  },
  {
    q: "What happens if a product becomes unavailable?",
    a: "As a member of Family Circle, you're guaranteed to receive your selected products even if they're out of stock on the website."
  },
  {
    q: "How do I cancel or pause my subscription?",
    a: "You can cancel your subscription at any time by logging into your account and selecting the cancel option, or by contacting our customer service team at support@maelove.com. If you'd like to pause your membership for a specified period without canceling, simply log into your account and select the pause option."
  },
  {
    q: "How do returns work?",
    a: "You get 100 days to return your order, with free return shipping. Same policy we stand behind for every single purchase."
  }
];
function FAQ() {
  const [openIndex, setOpenIndex] = reactExports.useState(null);
  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "fc-faq", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "fc-faq__title", children: "Frequently Asked Questions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-faq__list", children: FAQ_ITEMS.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: `fc-faq__item ${openIndex === index ? "open" : ""}`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { className: "fc-faq__question", onClick: () => toggle(index), children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: item.q }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { className: "fc-faq__chevron", width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3.5 5.25L7 8.75L10.5 5.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-faq__answer-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fc-faq__answer", children: item.a }) })
        ]
      },
      index
    )) })
  ] });
}
function App() {
  var _a2;
  const dispatch = useDispatch();
  const {
    data: bundleData,
    show_learn_more_modal,
    selected_individual_line_items,
    selected_selling_plan,
    applied_fc_filter,
    qualified_for_free_product,
    should_show_confetti,
    selected_concerns,
    discountPercentageConfigPerItem,
    has_preset_routine,
    preset_source,
    is_subscription_edit
  } = useSelector((state) => state.bundle);
  const isFetching = useSelector((state) => state.bundle.isFetching);
  const serumsElementRef = reactExports.useRef(null);
  const scrollAfterItemAddedRef = reactExports.useRef(null);
  const needHelpRef = reactExports.useRef(null);
  const [show_cards_fade_effect, setShow_cards_fade_effect] = reactExports.useState(false);
  const [isFrequencySheetOpen, setIsFrequencySheetOpen] = reactExports.useState(false);
  const [selectedConcern, setSelectedConcern] = reactExports.useState("");
  let mostExpensiveItemPrice = 0;
  for (let i = 0; i < selected_individual_line_items.length; i++) {
    if (Number(selected_individual_line_items[i].price) > mostExpensiveItemPrice) {
      mostExpensiveItemPrice = Number(selected_individual_line_items[i].price);
    }
  }
  reactExports.useEffect(() => {
    dispatch(getLoopBundleData({}));
    window.handleQuickViewAdd = (event, currentTarget) => {
      event.preventDefault();
      event.stopPropagation();
      const variantId = currentTarget.closest("form").querySelector('input[name="id"]').value;
      let addToCartBtn = document.querySelector(`.cpbundle__items .fc-card-add[data-variant-id="${variantId}"]`);
      if (addToCartBtn) {
        addToCartBtn.click();
      }
      currentTarget.closest(".drawer__content").querySelector("button.drawer__button.drawer__close").click();
    };
    window.handleQuickViewClose = (event, currentTarget) => {
      currentTarget.closest(".drawer__content").querySelector("button.drawer__button.drawer__close").click();
    };
    document.addEventListener("theme:scroll:lock", () => {
      const pFormInner = document.querySelector(".product__form__inner");
      if (pFormInner) {
        pFormInner.innerHTML = `<a class="capsulbtn" onclick="handleQuickViewAdd(event, this)">Add</a>`;
        const divsToHide = pFormInner.nextElementSibling.querySelectorAll("div.box");
        for (const d of divsToHide) {
          if (d.textContent.includes("shipping")) {
            d.parentElement.parentElement.style.display = "none";
            break;
          }
        }
      }
    });
  }, [dispatch]);
  reactExports.useEffect(() => {
    if (qualified_for_free_product && scrollAfterItemAddedRef) {
      scrollAfterItemAddedRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [qualified_for_free_product]);
  reactExports.useEffect(() => {
    if (selected_concerns[0]) {
      setShow_cards_fade_effect(true);
      setTimeout(() => {
        setShow_cards_fade_effect(false);
      }, 3e3);
    }
  }, [selected_concerns]);
  reactExports.useEffect(() => {
    if (bundleData && has_preset_routine) {
      const target = document.getElementById("builder");
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "auto", block: "start" });
        }, 50);
      }
    }
  }, [bundleData, has_preset_routine]);
  reactExports.useEffect(() => {
    if (bundleData && bundleData.products.length) {
      restartReviewsWidget();
      setTimeout(equalizeDescriptionHeights, 100);
      window.addEventListener("resize", equalizeDescriptionHeights);
      return () => {
        window.removeEventListener("resize", equalizeDescriptionHeights);
      };
    }
  }, [bundleData]);
  const handleOpenCorrespondingQuickView = (currentProduct) => {
    if (!currentProduct) return;
    const qvReference = document.querySelector(`div[data-quickview-holder="${currentProduct.shopifyProductId}"] button`);
    if (qvReference) {
      qvReference.click();
    }
  };
  if (isFetching || !bundleData) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {});
  }
  (bundleData == null ? void 0 : bundleData.sellingPlans) || [];
  const openFrequencySheet = () => setIsFrequencySheetOpen(true);
  const closeFrequencySheet = () => setIsFrequencySheetOpen(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `cpbundle__sticky-wrapper ph-no-deadclick${is_subscription_edit ? " cpbundle__sticky-wrapper--edit" : ""}`, children: [
    !is_subscription_edit && /* @__PURE__ */ jsxRuntimeExports.jsx(Hero, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "builder", className: "cpbundle__container", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "cpbundle__builder-heading", children: is_subscription_edit ? "Edit your Family Circle bundle" : has_preset_routine ? "Customize your routine" : "Pick your products" }),
      !is_subscription_edit && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "cpbundle__routine-finder-nudge", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "Not sure where to start?" }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "cpbundle__routine-finder-quiz", href: "https://maelove.com/pages/routine-finder", children: "Take our Skin Quiz" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__builder-layout", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("section", { className: "cpbundle__content", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cpbundle__content__card", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FCPerks, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cbundle--step-one", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "bundle-steps", ref: scrollAfterItemAddedRef, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "STEP 1" }),
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "step-details", children: "Add 2 or more items to your bundle" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "cbundle-help-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StepComponent, { stepTitle: "Need help selecting products?", needHelpRef, hideArrowIcon: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cbundle--help", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { marginTop: "1rem", marginBottom: "1rem" }, children: "Select up to two skincare concerns (optional)" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                SelectConcernWithCheckbox,
                {
                  selectingConcern: selected_concerns.filter((sc2) => sc2).length > 0 ? "secondary" : "primary",
                  selectMaxConcern: MAX_CONCERN_ALLOWED
                }
              )
            ] }) }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalScroller, { itemCount: selected_individual_line_items.length, scrollableClassName: "cpbundle__goals", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "section",
            {
              className: `${selected_individual_line_items.length > 0 ? "has-items" : ""} ${selected_individual_line_items.length >= 4 ? "is-complete" : ""}`,
              children: [...Array(Math.max(INITIAL_PLACEHOLDER_ITEMS, selected_individual_line_items.length, Math.min(MAX_ALLOWED_ITEMS, selected_individual_line_items.length + 1))).keys()].map((index) => {
                return /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SelectedProductCard,
                  {
                    handleOpenCorrespondingQuickView,
                    selected_individual_line_items,
                    index,
                    bundleData,
                    show_cards_fade_effect,
                    serumsElementRef,
                    discountPercentageConfigPerItem
                  },
                  `product-card-${index}`
                );
              })
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "cpbundle__items", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ConcernFilter, { selectedConcern, onSelectConcern: setSelectedConcern }),
            (_a2 = bundleData == null ? void 0 : bundleData.categories) == null ? void 0 : _a2.map((category) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              Card,
              {
                category,
                bundleData,
                applied_fc_filter,
                selectedConcern,
                serumsElementRef
              },
              category.categoryId
            ))
          ] })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BuilderSidebar, {})
      ] })
    ] }) }),
    !is_subscription_edit && /* @__PURE__ */ jsxRuntimeExports.jsx(FAQ, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StickyAddToCard, { onOpenFrequencySheet: openFrequencySheet }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DeliveryFrequencySheet, { isOpen: isFrequencySheetOpen, onClose: closeFrequencySheet }),
    should_show_confetti && /* @__PURE__ */ jsxRuntimeExports.jsx(Confetti, {}),
    show_learn_more_modal && /* @__PURE__ */ jsxRuntimeExports.jsx(LearnMoreModal, {})
  ] });
}
client.createRoot(document.getElementById("custom-subscription-bundle")).render(
  /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.StrictMode, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Provider_default, { store, children: /* @__PURE__ */ jsxRuntimeExports.jsx(App, {}) }) })
);


})();